const SHOP = 'https://www.hechtundbarsch.de/products/';

const SPECIES = {
  barsch:    {name:'Barsch', sci:'Perca fluviatilis', em:'🐟',
              wMin:0.05,wMax:1.6,trophy:1.0,fight:1.0,value:6,xp:8,
              desc:'Der Klassiker. Räuberischer Schwarmfisch, tag- & sichtaktiv. Beißt aggressiv auf kleine Köder.'},
  hecht:     {name:'Hecht', sci:'Esox lucius', em:'🐊',
              wMin:0.6,wMax:18,trophy:9,fight:2.4,value:22,xp:24,
              desc:'Der Wasserwolf. Attacken aus dem Hinterhalt, am besten in der Dämmerung und bei Bewölkung.'},
  zander:    {name:'Zander', sci:'Sander lucioperca', em:'🐠',
              wMin:0.4,wMax:13,trophy:7,fight:2.0,value:26,xp:26,
              desc:'Der Glasaugen-Räuber. Dämmerungs- & nachtaktiv, liebt trübes Wasser und Gummifisch am Grund.'},
  blackbass: {name:'Black Bass', sci:'Micropterus salmoides', em:'🐡', special:true,
              wMin:0.4,wMax:5,trophy:3,fight:2.6,value:55,xp:60,
              desc:'Selten in Deutschland. Kampfstark, springt aus dem Wasser. Tagsüber bei Sonne aktiv.'},
  wels:      {name:'Wels', sci:'Silurus glanis', em:'🐋', special:true,
              wMin:3,wMax:90,trophy:50,fight:4.2,value:90,xp:120,
              desc:'Der Gigant. Europas größter Süßwasserfisch – nachtaktiv. Nur mit schwerem Gerät zu bändigen.'},
  rapfen:    {name:'Rapfen', sci:'Leuciscus aspius', em:'🐬', special:true,
              wMin:0.5,wMax:8,trophy:5,fight:2.2,value:48,xp:55,
              desc:'Räuber der Oberfläche. Jagt sichtig bei Tag & Sonne, blitzschnelle Bisse im freien Wasser.'},
  dorsch:    {name:'Dorsch', sci:'Gadus morhua', em:'🐟', sea:true,
              wMin:0.5,wMax:25,trophy:12,fight:2.2,value:42,xp:46,
              desc:'Klassiker der Fjorde – steht tief über Kanten, beißt auf Pilker & große Gummiköder.'},
  seelachs:  {name:'Seelachs (Köhler)', sci:'Pollachius virens', em:'🐠', sea:true,
              wMin:1,wMax:20,trophy:10,fight:2.9,value:40,xp:44,
              desc:'Kampfmaschine im Freiwasser – zieht wie ein D-Zug, oft im Schwarm.'},
  heilbutt:  {name:'Heilbutt', sci:'Hippoglossus hippoglossus', em:'🐋', sea:true, special:true,
              wMin:5,wMax:220,trophy:90,fight:4.6,value:170,xp:210,
              desc:'Der Traum jedes Norwegen-Anglers – ein Plattfisch wie eine Scheunentür. Nur mit schwerstem Gerät.'},
};

/* Gezeichnete, realistischere Fisch-Icons (SVG, Seitenansicht, Kopf links) */
const FISHART = {
  barsch:{vb:'0 0 110 64', svg:`
    <path d="M90 32 L108 18 Q103 32 108 46 Z" fill="#b98e3e"/>
    <path d="M12 32 Q30 11 58 12 Q80 13 92 32 Q80 51 58 52 Q30 53 12 32 Z" fill="#6f8a39"/>
    <path d="M18 38 Q44 50 72 47 Q84 45 90 35 Q80 51 58 52 Q34 53 18 38 Z" fill="#e6e4ad" opacity=".5"/>
    <g stroke="#39491c" stroke-width="3.2" stroke-linecap="round" opacity=".55"><path d="M33 17 L31 48"/><path d="M45 14 L44 51"/><path d="M57 13 L57 52"/><path d="M69 14 L70 50"/><path d="M80 18 L82 47"/></g>
    <path d="M32 15 Q53 1 76 13 L73 19 Q53 9 35 21 Z" fill="#5a7030"/>
    <path d="M44 51 Q53 63 66 52 Z" fill="#c14e2c"/>
    <path d="M38 35 Q31 45 27 36 Z" fill="#c14e2c" opacity=".85"/>
    <path d="M30 16 Q26 32 31 47" stroke="#39491c" stroke-width="2" fill="none" opacity=".5"/>
    <circle cx="24" cy="26" r="5" fill="#f3e6bd"/><circle cx="22.5" cy="26" r="2.6" fill="#15130c"/>`},
  hecht:{vb:'0 0 140 60', svg:`
    <path d="M126 30 L140 16 Q135 30 140 44 Z" fill="#5f7032"/>
    <path d="M7 31 Q22 25 40 22 Q80 16 116 18 Q126 22 128 30 Q126 38 116 42 Q80 44 40 39 Q22 36 7 31 Z" fill="#5b7733"/>
    <path d="M14 33 Q50 44 100 40 Q120 38 126 32 Q120 39 110 41 Q70 45 30 39 Q20 37 14 33 Z" fill="#d9dca0" opacity=".45"/>
    <path d="M92 18 Q108 8 120 19 L116 23 Q104 16 94 24 Z" fill="#4c5f29"/>
    <path d="M70 42 Q84 52 98 43 Z" fill="#6f8038" opacity=".9"/>
    <g fill="#e7e6b0" opacity=".7"><ellipse cx="56" cy="26" rx="4" ry="2.6"/><ellipse cx="70" cy="30" rx="4" ry="2.6"/><ellipse cx="84" cy="25" rx="4" ry="2.6"/><ellipse cx="64" cy="36" rx="3.6" ry="2.4"/><ellipse cx="96" cy="33" rx="3.6" ry="2.4"/><ellipse cx="48" cy="33" rx="3.4" ry="2.2"/></g>
    <path d="M7 31 Q15 29 26 30 L26 33 Q15 34 7 31 Z" fill="#3f5022"/>
    <path d="M8 31 L25 31" stroke="#2c3818" stroke-width="1.5"/>
    <circle cx="31" cy="27" r="3.8" fill="#f0e7c2"/><circle cx="29.8" cy="27" r="2" fill="#15130c"/>`},
  zander:{vb:'0 0 124 58', svg:`
    <path d="M108 29 L122 15 Q117 29 122 43 Z" fill="#8a7d4a"/>
    <path d="M9 30 Q26 16 56 16 Q88 16 104 29 Q88 42 56 42 Q26 42 9 30 Z" fill="#7d7a4e"/>
    <path d="M16 34 Q46 44 80 41 Q96 39 102 31 Q90 42 56 42 Q30 42 16 34 Z" fill="#dcd8b0" opacity=".4"/>
    <g stroke="#454024" stroke-width="3" opacity=".38"><path d="M40 19 L38 40"/><path d="M54 18 L53 41"/><path d="M68 18 L68 40"/><path d="M82 20 L83 39"/></g>
    <path d="M34 16 Q48 4 62 14 L60 19 Q48 10 36 20 Z" fill="#6a6440"/>
    <path d="M70 15 Q82 9 92 17 L90 21 Q80 15 72 20 Z" fill="#6a6440"/>
    <path d="M50 41 Q60 50 72 42 Z" fill="#7a7448" opacity=".9"/>
    <path d="M10 30 L27 28" stroke="#3a361e" stroke-width="1.6"/>
    <circle cx="23" cy="25" r="5" fill="#cfe2ea"/><circle cx="21.5" cy="25" r="2.4" fill="#15130c"/>`},
  blackbass:{vb:'0 0 116 64', svg:`
    <path d="M96 32 L114 18 Q109 32 114 46 Z" fill="#3f6b3e"/>
    <path d="M14 33 Q28 13 56 13 Q84 13 98 32 Q84 52 56 52 Q28 52 14 33 Z" fill="#4f7b46"/>
    <path d="M20 40 Q46 51 74 48 Q88 46 96 36 Q84 52 56 52 Q34 52 20 40 Z" fill="#dfe3a8" opacity=".5"/>
    <path d="M22 30 Q50 33 86 31 L86 35 Q50 38 22 35 Z" fill="#27432a" opacity=".7"/>
    <g fill="#27432a" opacity=".5"><ellipse cx="34" cy="32" rx="3.5" ry="3"/><ellipse cx="48" cy="33" rx="4" ry="3.2"/><ellipse cx="62" cy="32" rx="4" ry="3.2"/><ellipse cx="76" cy="32" rx="3.5" ry="3"/></g>
    <path d="M30 15 Q52 5 78 14 L75 20 Q52 11 33 21 Z" fill="#3c6238"/>
    <path d="M44 51 Q54 62 68 52 Z" fill="#42683c"/>
    <path d="M14 33 Q7 30 9 37 Q14 41 22 40" fill="#2f4a30"/>
    <path d="M10 34 Q17 33 25 36" stroke="#1d3220" stroke-width="2" fill="none"/>
    <circle cx="28" cy="26" r="4.6" fill="#e9e7c0"/><circle cx="26.5" cy="26" r="2.4" fill="#15130c"/>`},
  wels:{vb:'0 0 140 60', svg:`
    <path d="M128 33 Q140 26 138 36 Q137 45 126 42 Z" fill="#454230"/>
    <path d="M9 30 Q14 18 36 18 Q72 17 106 25 Q126 29 132 35 Q124 47 100 47 Q60 49 30 44 Q14 42 9 33 Z" fill="#4d4a33"/>
    <path d="M20 38 Q60 48 100 44 Q118 42 126 37 Q116 47 96 47 Q56 49 26 42 Q18 41 20 38 Z" fill="#9a9670" opacity=".4"/>
    <g fill="#33301f" opacity=".5"><ellipse cx="50" cy="28" rx="6" ry="3"/><ellipse cx="74" cy="32" rx="7" ry="3.4"/><ellipse cx="96" cy="30" rx="6" ry="3"/><ellipse cx="62" cy="38" rx="6" ry="3"/></g>
    <path d="M40 45 Q80 56 118 47 L118 49 Q80 58 40 47 Z" fill="#3f3c28"/>
    <path d="M9 30 Q4 30 6 34 Q14 34 22 33" stroke="#26241a" stroke-width="2.4" fill="none"/>
    <g stroke="#3a3724" stroke-width="2" fill="none" stroke-linecap="round"><path d="M10 27 Q5 20 4 12"/><path d="M10 30 Q4 27 2 25"/><path d="M13 34 Q9 42 8 50"/><path d="M15 34 Q15 44 15 53"/></g>
    <circle cx="22" cy="24" r="2.8" fill="#e9e7c0"/><circle cx="21.4" cy="24" r="1.4" fill="#15130c"/>`},
  rapfen:{vb:'0 0 124 56', svg:`
    <path d="M104 28 L122 14 Q116 28 122 42 Z" fill="#9fb0bc"/>
    <path d="M8 29 Q24 18 54 17 Q86 17 102 28 Q86 39 54 39 Q24 39 8 29 Z" fill="#aeb9c2"/>
    <path d="M8 29 Q24 24 40 23 L100 26 Q86 22 54 22 Q26 23 8 29 Z" fill="#7f93a2" opacity=".5"/>
    <path d="M14 32 Q44 41 78 38 Q94 36 100 30 Q88 39 54 39 Q30 39 14 32 Z" fill="#f0f3f6" opacity=".55"/>
    <path d="M52 17 Q64 9 76 17 L74 21 Q64 14 54 21 Z" fill="#8fa1ad"/>
    <path d="M48 39 Q58 48 70 40 Z" fill="#9fb0bc"/>
    <path d="M8 29 Q3 31 7 27 L18 26" stroke="#5e7180" stroke-width="1.6" fill="none"/>
    <circle cx="22" cy="26" r="4.4" fill="#f2f5f7"/><circle cx="20.6" cy="26" r="2.2" fill="#15130c"/>`},
};
function fishIcon(sp,px){
  const a=FISHART[sp]; if(!a) return (SPECIES[sp]?SPECIES[sp].em:'🐟');
  const p=a.vb.split(' '), h=Math.round(px*(parseFloat(p[3])/parseFloat(p[2])));
  return `<svg class="fishicon" viewBox="${a.vb}" width="${px}" height="${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">${a.svg}</svg>`;
}

const TIMES = {
  morgen:{name:'Morgendämmerung', ic:'🌅', night:false,
          sky:'linear-gradient(180deg,#ffd9a0 0%,#e8956a 38%,#385066 100%)',
          mult:{hecht:1.3,barsch:1.1,zander:1.1,blackbass:1.1,rapfen:1.0,wels:0.8}},
  tag:   {name:'Tag', ic:'☀️', night:false,
          sky:'linear-gradient(180deg,#7fd0e8 0%,#2e7f9c 45%,#0d3a4c 100%)',
          mult:{hecht:1.4,barsch:1.4,rapfen:1.3,blackbass:1.3,zander:0.6,wels:0.4}},
  abend: {name:'Abenddämmerung', ic:'🌇', night:false,
          sky:'linear-gradient(180deg,#ffb877 0%,#d96b4a 40%,#2a3a52 100%)',
          mult:{zander:1.4,wels:1.2,hecht:1.1,blackbass:1.0,barsch:0.9,rapfen:0.9}},
  nacht: {name:'Nacht', ic:'🌙', night:true,
          sky:'linear-gradient(180deg,#1a2a52 0%,#152740 45%,#070f1e 100%)',
          mult:{zander:1.7,wels:1.8,hecht:0.7,blackbass:0.6,barsch:0.5,rapfen:0.3}},
};
const WEATHER = {
  sonnig:  {name:'Sonnig', ic:'☀️',  mult:{barsch:1.2,rapfen:1.3,blackbass:1.3,hecht:0.8,zander:0.8,wels:0.9}},
  bewoelkt:{name:'Bewölkt', ic:'☁️', mult:{hecht:1.3,zander:1.1,barsch:1.0,rapfen:1.0,blackbass:1.0,wels:1.0}},
  regen:   {name:'Regen', ic:'🌧️',  mult:{zander:1.3,wels:1.3,hecht:1.1,barsch:0.8,rapfen:0.7,blackbass:0.8}},
};

/* Jahreszeit – Aktivität je Fisch + Einfluss auf Wasserklarheit (clarity) */
const SEASONS = {
  fruehling:{name:'Frühling', ic:'🌱', clarity:-0.10, mult:{hecht:1.4,barsch:1.2,zander:1.2,rapfen:1.0,blackbass:0.7,wels:0.6}},
  sommer:   {name:'Sommer',   ic:'🌞', clarity:-0.05, mult:{blackbass:1.5,wels:1.5,rapfen:1.4,barsch:1.0,zander:0.9,hecht:0.7}},
  herbst:   {name:'Herbst',   ic:'🍂', clarity:0.05,  mult:{hecht:1.6,zander:1.3,barsch:1.3,wels:1.0,blackbass:0.9,rapfen:1.0}},
  winter:   {name:'Winter',   ic:'❄️', clarity:0.15,  mult:{zander:1.2,barsch:1.1,hecht:1.0,rapfen:0.5,blackbass:0.3,wels:0.3}},
};

/* Köderfarbe (globaler Reiz je nach Wasserklarheit & Licht) */
const COLORS = {
  naturell:{name:'Naturell',   ic:'🟫', desc:'Natürliche Farben – fängt besser bei klarem Wasser.'},
  grell:   {name:'Grell/Bunt', ic:'🟢', desc:'Auffällige Reizfarben (z. B. Firetiger) – top bei trübem Wasser.'},
  uv:      {name:'UV / Glow',  ic:'🟣', desc:'Leuchtet bei wenig Licht – top in der Dämmerung & nachts.'},
};

/* Schwierigkeitsgrade – aimSpeed: Tempo der Wurf-Anzeigen, hookWindow: Anschlag-Fenster, fishCalm: Wildheit im Drill */
const DIFFICULTY = {
  leicht:{name:'Leicht', ic:'🟢', aimSpeed:0.52, hookWindow:1.9, fishCalm:0.55,
          castTol:1.6, lureZone:0.45, followR:14, reactMul:1.9, drainMul:0.55,
          desc:'Sehr langsame Anzeigen, riesiges Anschlag-Fenster, ruhige Fische – ideal für Einsteiger.'},
  normal:{name:'Normal', ic:'🟡', aimSpeed:1.00, hookWindow:1.00, fishCalm:1.00,
          castTol:1.0, lureZone:0.30, followR:9, reactMul:1.0, drainMul:1.0,
          desc:'Ausgewogenes Spiel.'},
  schwer:{name:'Schwer', ic:'🔴', aimSpeed:1.45, hookWindow:0.62, fishCalm:1.28,
          castTol:0.9, lureZone:0.24, followR:8, reactMul:0.85, drainMul:1.15,
          desc:'Schnelle Anzeigen, knapper Anschlag, wilde Drills. Für Profis.'},
};

const LURES = {
  tauwurm:   {name:'Tauwurm', ic:'🪱', price:0, own:true,
              aff:{barsch:1.3,zander:0.7,hecht:0.3,rapfen:0.2,blackbass:0.5,wels:0.4},
              desc:'Natürlicher Allrounder für kleine Räuber. Dein Startköder.'},
  proshad:   {name:'Zander Pro Shad 10 cm', ic:'🎏', price:60, brand:'Fox Rage',
              handle:'fox-rage-zander-pro-shad-10-cm', realPrice:'ab 1,10 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Fox-Rage-Zander-Pro-Shad-Blue-Back.jpg?v=1759437380',
              aff:{zander:1.6,hecht:1.1,barsch:1.1,wels:0.5},
              desc:'Topseller-Gummifisch – der Klassiker fürs Zanderangeln am Grund.'},
  easyshiner:{name:'Easy Shiner 4" (10 cm)', ic:'🐠', price:90, brand:'Keitech',
              handle:'keitech-easy-shiner-4-10-cm', realPrice:'6,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/keitech-easy-shiner-alewife.jpg?v=1759437376',
              aff:{barsch:1.3,zander:1.3,hecht:1.0,blackbass:0.9},
              desc:'Universalgröße auf alle Raubfische – einer der fängigsten Shads der Welt.'},
  bigshiner: {name:'Easy Shiner 5" (12,5 cm)', ic:'🐟', price:140, brand:'Keitech',
              handle:'keitech-easy-shiner-5-12-5-cm', realPrice:'7,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Keitech-Easy-Shiner-5-inch-Alewife.jpg?v=1759437376',
              aff:{zander:1.5,hecht:1.2,wels:1.0,barsch:0.6},
              desc:'Perfekte Zandergröße – großvolumig genug, um auch Welse zu reizen.'},
  drunkbig:  {name:'Drunk Dancer 23 cm (Waller)', ic:'🐋', price:230, brand:'LMAB', home:true, action:0.6, kind:'soft',
              handle:'lmab-drunk-dancer-23-cm', realPrice:'8,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/LMAB-Drunk-Dancer-Angry-Alfred_2b6e5bb2-8b5e-4974-813d-ba8eff61a513.jpg?v=1774960342',
              aff:{wels:2.1,hecht:1.3,zander:0.5},
              desc:'Riesiger Doppelschwanz-Twister (23 cm) mit massiver Druckwelle – DER Köder fürs gezielte Wallerangeln.'},
  salmoperch:{name:'Perch 8 cm (Wobbler)', ic:'🐡', price:70, brand:'Salmo',
              handle:'salmo-perch-8-cm-floating', realPrice:'6,95 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Salmo-Perch-holographic-perch.jpg?v=1759437381',
              aff:{barsch:1.3,hecht:1.0,rapfen:0.8,zander:0.7},
              desc:'Laufstarker Hardbait im Barsch-Design – verführt Barsch & Hecht.'},
  zeckdundee:{name:'Dundee (Wobbler)', ic:'🎣', price:150, brand:'Zeck',
              handle:'zeck-dundee', realPrice:'17,95 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/zeck-dundee-1m-ayu.jpg?v=1771596077',
              aff:{hecht:1.5,zander:0.9,rapfen:1.0,barsch:0.7},
              desc:'Moderner Tiefläufer – gezieltes Hechtangeln mit ausgewogener Aktion.'},
  jigmaster: {name:'Jigmaster 8 g (Tail-Spinner)', ic:'🌀', price:80, brand:'SpinMad',
              handle:'spinmad-jigmaster-8-g', realPrice:'7,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/spinmad-jigmaster-ayu-8g_600x600_19896e62-79b5-4c3b-8727-68fa143e89e2.jpg?v=1759437385',
              aff:{barsch:1.5,rapfen:1.3,zander:0.6,hecht:0.5},
              desc:'Vibrierender Tail-Spinner – Barsch- und Rapfenmagnet auf Distanz.'},
  deracoup:  {name:'Deracoup 14 g (H&B Edition)', ic:'✨', price:120, brand:'Jackall', hb:true,
              handle:'illex-deracoup-14-g-1-2-oz-jig-spinner', realPrice:'14,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Illex-Deracoup-Aggressiv-Perch_08d3489e-f436-47a2-8394-fa6454713cc3.jpg?v=1759437397',
              aff:{barsch:1.5,rapfen:1.4,blackbass:1.3,zander:0.7},
              desc:'Legendärer Tailspinner – auch in der exklusiven HechtundBarsch-Sonderfarbe.'},
  uvspoon:   {name:'Ultra UV Spoon (Blinker)', ic:'💫', price:90, brand:'Fox Rage',
              handle:'fox-rage-ultra-uv-spoon', realPrice:'ab 8,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Fox-Rage-Ultra-UV-Spoon-Perch-01.jpg?v=1759437744',
              aff:{hecht:1.4,rapfen:1.3,wels:0.9,barsch:0.8,blackbass:0.7},
              desc:'UV-aktiver Metall-Blinker mit Flash – weite Würfe auf Hecht & Rapfen, am Grund auch auf Wels.'},
  busterjerk:{name:'Buster Jerk 15 cm (Jerkbait)', ic:'🦈', price:170, brand:'Strike Pro',
              handle:'strike-pro-buster-jerk-15-cm-sinking', realPrice:'ab 14,49 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/strike-pro-buster-jerk-black-okoboji-perch.jpg?v=1759437413',
              aff:{hecht:1.9,zander:0.8,wels:0.5},
              desc:'Jerk-Klassiker für kapitale Hechte – die Fangmaschine schlechthin.'},
  dropshot:  {name:'Easy Shiner 2" (Finesse)', ic:'🧷', price:120, brand:'Keitech',
              handle:'keitech-easy-shiner-2-5-4-cm', realPrice:'6,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Keitech-Easy-Shiner-2-inch-Alewife.jpg?v=1759437376',
              aff:{barsch:1.6,blackbass:1.6,zander:1.0},
              desc:'Kleinster Finesse-Shad fürs Drop-Shot – reizt vorsichtige Barsche & Bass.'},
  drunkdancer:{name:'Drunk Dancer 15 cm', ic:'🎣', price:150, brand:'LMAB', home:true, action:0.65, kind:'soft',
              handle:'lmab-drunk-dancer-15-cm', realPrice:'8,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/LMAB-Drunk-Dancer-Angry-Alfred_2b6e5bb2-8b5e-4974-813d-ba8eff61a513.jpg?v=1774960342',
              aff:{hecht:1.6,zander:1.0,wels:0.8,barsch:0.5},
              desc:'Doppelschwanz-Twister aus Berlin – fängt Hechte am laufenden Band.'},
  drunkmini: {name:'Drunk Dancer Mini 5 cm', ic:'🪱', price:70, brand:'LMAB', home:true, action:0.4, kind:'soft',
              handle:'lmab-drunk-dancer-mini', realPrice:'4,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/LMAB-Drunk-Dancer-Mini-Absinth-Andy.jpg?v=1770808934',
              aff:{barsch:1.5,zander:1.1,rapfen:0.7},
              desc:'Kleiner Doppelschwanz-Twister – Barsch- & Zandermagnet.'},
  multivibe: {name:'Multi Vibe 2.0 (Chatterbait)', ic:'🌀', price:120, brand:'LMAB', home:true, action:0.9, kind:'hard',
              handle:'lmab-multi-vibe-2-0', realPrice:'8,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/LMAB-Multivibe-2-Ayu_7a57109d-64d9-4e3d-befb-634c378d3a6b.jpg?v=1774957555',
              aff:{hecht:1.3,zander:1.2,barsch:1.1,rapfen:0.8},
              desc:'Vibrationsstarker Chatterbait – Reizköder bei trübem Wasser.'},
  kofivibe:  {name:'KØFI Real Vibe (Swimbait)', ic:'🦈', price:185, brand:'LMAB', home:true, action:0.85, kind:'hard',
              handle:'lmab-k-fi-real-vibe-180', realPrice:'22,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/K_yFI-Real-Vibe-Ayu-Produktbild.jpg?v=1759437372',
              aff:{hecht:1.8,zander:0.8,wels:0.5},
              desc:'Realistischer Swimbait mit „Hecht-Garantie".'},
  turbolui:  {name:'Turbo Lui (Jig-Spinner)', ic:'✨', price:90, brand:'Monkey Lures', home:true, action:0.8, kind:'hard',
              handle:'turbo-lui', realPrice:'7,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Monkey-Lures-Turbo-Lui-Carpe-Nostra.jpg?v=1759437350',
              aff:{barsch:1.5,rapfen:1.4,zander:0.8,hecht:0.6},
              desc:'Searchbait-Jigspinner – findet aktive Barsche & Rapfen blitzschnell.'},
  maxbait:   {name:'Max\'s Geheim-Prototyp', ic:'🧪', price:0, brand:'HechtundBarsch.de', excl:true, action:0.7, kind:'soft',
              aff:{hecht:1.6,zander:1.5,barsch:1.4,blackbass:1.4,rapfen:1.2,wels:1.2},
              desc:'Handgemachter Prototyp aus Max\'s Tacklebox – nicht im Handel erhältlich. Fängt einfach alles.'},
  babylui:   {name:'Baby Lui 3,5 cm (Finesse)', ic:'🧷', price:80, brand:'Monkey Lures', home:true, action:0.25, kind:'soft',
              handle:'monkey-lures-baby-lui-3-5-cm', realPrice:'ab 7,95 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Monkey-Lures-Baby-Lui-3-5-Apple-Bomb.jpg?v=1759437495',
              aff:{barsch:1.6,blackbass:1.3,zander:0.9},
              desc:'Winziges Brutfischimitat – perfekt für vorsichtige Barsche.'},
  finessecraw:{name:'Finesse Filet Craw 7 cm', ic:'🦀', price:90, brand:'LMAB', home:true, action:0.35, kind:'craw',
              handle:'lmab-finesse-filet-craw-7-cm', realPrice:'6,99 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/finesse-filet-craw-butter-craw_c2d0a151-380d-456e-afaf-64c148a29bc3.jpg?v=1759437409',
              aff:{barsch:1.8,blackbass:1.5,zander:1.4,hecht:0.4,rapfen:0.3,wels:0.4},
              desc:'Krebsimitat – DER Köder für kapitale Barsche, auch Zander lieben Krebse. Am besten am Grund führen. Eigenes Führungs-Spiel: lass den Krebs über Hindernisse springen!'},
  crabylui:  {name:'Craby Lui 7,5 cm', ic:'🦀', price:90, brand:'Monkey Lures', home:true, action:0.35, kind:'craw',
              handle:'monkey-lures-craby-lui-7-5-cm', realPrice:'7,95 €',
              img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/CRABY-BPGqurllX5OQfgh.jpg?v=1759437462',
              aff:{barsch:1.8,blackbass:1.4,zander:1.4,hecht:0.4},
              desc:'Detailgetreues Krebsimitat mit filigranen Scheren – unwiderstehlich für kapitale Barsche und Zander, am besten am Grund. Eigenes Führungs-Spiel: Sprünge über Hindernisse!'},
};
/* Köder-Aktion (0=passiv/dezent .. 1=viel Aktion) + Köderart (für Montagen-Passung) */
const LURE_TRAITS = {
  tauwurm:{action:0.10,kind:'natur'}, proshad:{action:0.50,kind:'soft'}, easyshiner:{action:0.50,kind:'soft'},
  bigshiner:{action:0.55,kind:'soft'}, salmoperch:{action:0.80,kind:'hard'}, zeckdundee:{action:0.85,kind:'hard'},
  jigmaster:{action:0.75,kind:'hard'}, deracoup:{action:0.70,kind:'hard'}, uvspoon:{action:0.80,kind:'hard'},
  busterjerk:{action:0.95,kind:'hard'}, dropshot:{action:0.20,kind:'soft'},
};
for(const k in LURE_TRAITS) Object.assign(LURES[k], LURE_TRAITS[k]);

const RODS = {
  teleskop: {name:'Teleskoprute', ic:'🥢', price:0, own:true, zone:0.30, power:2.2,
             desc:'Günstige Einsteigerrute. Wenig Kontrolle, bricht bei Großfisch.'},
  bigstart: {name:'Solution Start Rod', ic:'🎣', price:140, brand:'Big L', home:true, zone:0.37, power:3.0,
             handle:'big-l-solution-start-rod', realPrice:'99,99 €',
             img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/BigL-Starter-Kit-Barsch-rod_399e7d62-2f65-4923-aa97-654487ff707f.jpg?v=1763720522',
             desc:'Einsteigerfreundliche Allround-Rute mit Toray-Blank – sauberer Drill.'},
  bigstatement:{name:'Solution Statement', ic:'🪄', price:400, brand:'Big L', home:true, zone:0.47, power:3.7,
             handle:'big-l-solution-statement-by-big-l', realPrice:'ab 359 €',
             img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Solution-Statement.jpg?v=1759437465',
             desc:'High-End Zander-/Hechtrute – top Kontrolle und Rückgrat.'},
  dentist:  {name:'Beast „The Dentist" 255', ic:'🦷', price:520, brand:'Bullseye', zone:0.40, power:4.2,
             handle:'bullseye-beast-the-dentist-255-50-145-g', realPrice:'329 €',
             img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Bullseye-The-Dentist-255-50-145g_2.jpg?v=1759437376',
             desc:'Big-Bait-Rute bis 145 g – brachiale Power für kapitale Hechte.'},
  nazgul:   {name:'Nazgul (Wallerrute)', ic:'🛡️', price:650, brand:'Bullseye', zone:0.36, power:5.2,
             handle:'bullseye-nazgul', realPrice:'ab 199 €',
             img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Bullseye-Nazgul-185-cm-180-g-1.jpg?v=1759437467',
             desc:'High-End Wallerrute – Pflichtgerät, um Meterwelse zu bändigen.'},
};

const REELS = {
  basic:   {name:'Standard-Rolle', ic:'⚙️', price:0, own:true, speed:1.0, desc:'Einfache Frontbremsrolle.'},
  bigreel: {name:'Solution Start Reel', ic:'🔩', price:120, brand:'Big L', home:true, speed:1.22,
            handle:'big-l-solution-start-reel', realPrice:'39,99 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/big-l-solution-start-reel-main.jpg?v=1774618475',
            desc:'Solide Stationärrolle mit top Preis-Leistungs-Verhältnis.'},
  catana:  {name:'Catana FE', ic:'🔧', price:240, brand:'Shimano', speed:1.35,
            handle:'shimano-catana-fe', realPrice:'ab 35,95 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/catana-fe.jpg?v=1759437388',
            desc:'Premium-Technik zum kleinen Preis – geschmeidige Bremse.'},
  ultegra: {name:'Ultegra FD', ic:'🚀', price:380, brand:'Shimano', speed:1.5,
            handle:'shimano-ultegra-fd', realPrice:'ab 123,95 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Shimano-Ultegra-FD-1000-C2000-HG-C2500S-HG-2500-2500-HG-2500-SHG.jpg?v=1759437830',
            desc:'Flaggschiff der Mittelklasse – schnell, langlebig, elegant.'},
  vanquish:{name:'Vanquish FC', ic:'🏎️', price:600, brand:'Shimano', speed:1.7,
            handle:'shimano-vanquish-fc', realPrice:'ab 425,95 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Shimano-Vanquish-FC-1.jpg?v=1759437683',
            desc:'Ultimative Leichtgewichts-Spinnrolle – kompromisslose Performance.'},
};

const NETS = {
  klein:   {name:'Klappkescher', ic:'🪣', price:0, own:true, buffer:1.0, agility:5.5,
            desc:'Kleiner, träger Standardkescher – kleines Netz, lässt sich nur langsam führen.'},
  finezze: {name:'Pro Finezze Rubber Mesh', ic:'🥅', price:90, brand:'Savage Gear', buffer:1.25, agility:8,
            handle:'savage-gear-pro-finezze-rubber-mesh-net-kescher', realPrice:'29,99 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/SAVAGE-GEAR_Kescher-klein.jpg?v=1759437384',
            desc:'Fischschonender Gummikescher – wendig & sicher, mittleres Netz.'},
  folding: {name:'Pro Folding Rubber Mesh L', ic:'🧺', price:240, brand:'Savage Gear', buffer:1.6, agility:11,
            handle:'savage-gear-pro-folding-rubber-mesh-landing-net-kescher', realPrice:'ab 46,99 €',
            img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/savagegear-pro-folding-rubber-large-mesh-landing-net-kescher.jpg?v=1759437379',
            desc:'Großes, tiefes Netz – schnell am Fisch, ideal für springende Räuber.'},
};

const WATERS = {
  mueritz: {name:'Müritz', ic:'🏞️', unlock:0, desc:'Größter See der Mecklenburgischen Seenplatte – flach & krautig, top Barsch- & Hechtrevier.',
    pop:{barsch:55,hecht:28,zander:17}, sizeBias:0.85},
  bodensee: {name:'Bodensee', ic:'💎', unlock:0, desc:'Tiefer, glasklarer Alpensee – kapitale „Kretzer"-Barsche, Hechte & Rapfen.',
    pop:{barsch:44,hecht:24,zander:22,rapfen:10}, sizeBias:1.05},
  mittellandkanal: {name:'Mittellandkanal', ic:'🚢', unlock:0, desc:'Klassischer Kanal mit Steinpackungen – Deutschlands Zander-Hotspot.',
    pop:{zander:40,barsch:30,hecht:22,rapfen:8}, sizeBias:1.0},
  rhein: {name:'Rhein', ic:'🌊', unlock:3, desc:'Mächtiger Strom mit Buhnenfeldern – Zander & Rapfen im Strom, Wels in der Tiefe.',
    pop:{zander:28,barsch:22,rapfen:26,hecht:12,wels:12}, sizeBias:1.25},
  edersee: {name:'Edersee', ic:'⛰️', unlock:5, desc:'Tiefe Talsperre in Hessen – legendäres Revier für Großhechte und Barschschwärme.',
    pop:{hecht:46,barsch:28,zander:26}, sizeBias:1.4},
  ebro: {name:'Ebro-Stausee (Spanien)', ic:'🏆', unlock:8, travel:true, desc:'🌍 Reise-Gewässer · Mequinenza am Ebro – Welt-Trophäenrevier für Meterwelse und Black Bass.',
    pop:{wels:34,blackbass:24,zander:22,rapfen:20}, sizeBias:1.75},
  norwegen: {name:'Norwegen-Fjord', ic:'🇳🇴', unlock:10, travel:true, desc:'🌍 Reise-Gewässer · Tiefe Fjorde am Polarkreis – Dorsch, Köhler & der legendäre Heilbutt. Schweres Meeresgerät Pflicht.',
    pop:{dorsch:40,seelachs:34,heilbutt:26}, sizeBias:1.6},
};
/* Grund-Wasserklarheit je Gewässer (0=trüb .. 1=glasklar) */
const WATERCLARITY = { mueritz:0.55, bodensee:0.95, mittellandkanal:0.50, rhein:0.40, edersee:0.80, ebro:0.45, norwegen:0.88 };

/* Gewässer-Optik: Wasserfarbe + Szenerie-Typ */
const WATERSCENE = {
  mueritz:        {type:'see',       col:'linear-gradient(180deg,#2f8a72 0%,#0f4646 72%)'},
  bodensee:       {type:'bagger',    col:'linear-gradient(180deg,#22b6a4 0%,#0c3a46 76%)'},
  mittellandkanal:{type:'kanal',     col:'linear-gradient(180deg,#41606f 0%,#102e3a 82%)'},
  rhein:          {type:'fluss',     col:'linear-gradient(180deg,#4f7e55 0%,#143a2e 82%)'},
  edersee:        {type:'talsperre', col:'linear-gradient(180deg,#356691 0%,#0c2740 82%)'},
  ebro:           {type:'strom',     col:'linear-gradient(180deg,#b88a4e 0%,#4a2418 86%)'},
  norwegen:       {type:'see',       col:'linear-gradient(180deg,#1f6b8a 0%,#04243a 86%)'},
};

/* Montagen / Rigs */
const RIGS = {
  jigkopf: {name:'Jigkopf', ic:'🎯', desc:'Allround-Bleikopf zum aktiven Jiggen. Funktioniert fast überall – auch in Strömung.'},
  dropshot:{name:'Drop-Shot', ic:'📍', desc:'Finesse, vertikal. Stark bei klarem & kaltem Wasser und in der Tiefe (Barsch/Zander).'},
  texas:   {name:'Texas Rig', ic:'🌿', desc:'Weedless durchs Kraut. Top auf Bass & Hecht an Struktur, besonders im Sommer.'},
  carolina:{name:'Carolina Rig', ic:'⚓', desc:'Grund absuchen über Distanz. Top in Strömung & großen Gewässern (Zander/Wels).'},
  grund:   {name:'Naturköder-Grundmontage', ic:'🪨', desc:'Köder am Grund. Pflicht auf Wels, gut auf Zander bei Nacht.'},
  direkt:  {name:'Direkt (Hardbait)', ic:'➰', desc:'Köder direkt am Vorfach – für Wobbler, Jerkbaits, Spinner & Blinker.'},
};

/* Boote – ab hohem Level wählbar, deutlich besserer Fangerfolg (mit schwarzem, aber nettem Humor) */
const BOATS = {
  ruderboot:{name:'Ruderboot', ic:'🚣', price:450, biteMul:1.25, sizeMul:0.10,
    desc:'Quietscht, leckt ein bisschen – bringt dich aber raus, wo die Fische wohnen. Schwimmweste an, der See verzeiht keine zweite Chance.'},
  konsole:  {name:'Konsolenboot (Alu)', ic:'⛵', price:1100, biteMul:1.45, sizeMul:0.20,
    desc:'Solides Alu mit Echolot. Erreicht jede Kante – und jede Ausrede „die beißen heute nicht" stirbt hier ganz leise.'},
  bassboat: {name:'High-End Bassboat', ic:'🛥️', price:2200, biteMul:1.75, sizeMul:0.32,
    desc:'200 PS pure Überlegenheit. Die Fische geben quasi auf, bevor dein Köder überhaupt nass wird.'},
};
/* Angelguides – buchbar für einen „Tag" (3 Min. Echtzeit). Bringen dich an ihren Hotspot & liefern kapitale Zielfische. */
const GUIDE_MS=180000;
const GUIDES = {
  mario:{name:'Mario Sing', sp:'zander', water:'rhein', boat:true, price:600, biteMul:3.0, sizeBoost:0.5,
    spot:'Holland (Polder & Kanäle)', ig:'ms7angelguiding', igUrl:'https://www.instagram.com/ms7angelguiding/',
    bye:'Tot ziens! War mir ein Fest. Wenn du echte Großzander sehen willst – ich poste sie alle auf Insta.',
    desc:'Bootsprofi aus Holland – stellt dir die fettesten Zander nach. „Vertrau mir, der Köder muss auf den Grund."'},
  ihno:{name:'Ihno Tamminga', sp:'barsch', water:'mittellandkanal', boat:false, price:450, biteMul:3.0, sizeBoost:0.5,
    spot:'Niedersachsen (vom Ufer)', ig:'ihnoflamingo', igUrl:'https://www.instagram.com/ihnoflamingo/',
    bye:'Moin, ich muss weiter – neue Tackle-Videos drehen sich nicht von allein. Folg mir auf Insta, dann verpasst du nix!',
    desc:'Barsch-Flüsterer aus Niedersachsen – holt kapitale Barsche vom Ufer. Finesse pur, keine Ausreden.'},
  johannes:{name:'Johannes Gasser', sp:'hecht', water:'bodensee', boat:true, price:750, biteMul:3.0, sizeBoost:0.55,
    spot:'Bodensee (vom Boot)', ig:'johannes_gasser_', igUrl:'https://www.instagram.com/johannes_gasser_/',
    bye:'Stark gefischt! Ich muss zum nächsten Turnier. Auf Insta zeig ich dir, was am Bodensee (und mit LMAB) geht.',
    desc:'Hecht-Legende am Bodensee – jagt vom Boot die ganz großen Esox. Meterhechte sind hier Tagesgeschäft.'},
  daniel:{name:'Daniel Andriani', sp:'barsch', all:true, water:null, boat:false, price:500, biteMul:1.7, sizeBoost:-0.6,
    spot:'überall', target:'alle Arten',
    desc:'Der Allrounder – mit ihm beißt einfach alles, egal welche Art. Nur: die Kapitalen überlässt er meist anderen … es werden viele, aber eher kleine Fische.'},
};
/* Zubehör – passive Upgrades (einmal kaufen) */
const SHOPGEAR = {
  polbrille:{name:'Iris Polarisationsbrille', ic:'🕶️', price:220, brand:'LMAB', home:true,
    handle:'lmab-iris-polarisationsbrille', realPrice:'34,99 €',
    img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/lmab_iris-polbrillen-03.jpg?v=1759437675',
    desc:'Polbrille – du erkennst die Fische besser. Beim Auswerfen ist das Ziel deutlich größer (leichter zu treffen).'},
  stirnlampe:{name:'Headlamp 2026 / Kopflampe', ic:'🔦', price:160, brand:'LMAB', home:true,
    handle:'lampen-headlamp-2026-kopflampe', realPrice:'14,99 €',
    img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/lmab-kopflampe-main.jpg?v=1773669938',
    desc:'Stärkere Kopflampe – bei Nacht ein deutlich größerer Lichtkegel. Du siehst viel mehr vom Wasser.'},
  mueckenspray:{name:'Anti-Mücken-Spray', ic:'🧴', price:60, brand:'Outdoor',
    desc:'Hält die Plagegeister fern: Beim Zufalls-Event „Mückenalarm" bleibst du verschont – kein nerviges Mücken-Sirren mehr.'},
  haken:{name:'Scharfe Jighaken 1/0', ic:'🪝', price:40, brand:'Musaga',
    handle:'musaga-jighaken-classic-1-0-3er-pack', realPrice:'1,99 €',
    img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/musaga-jig-haken-fuer-gummikoeder-classic_76d6e22b-017e-4b3c-b4fb-d41253cf347b.jpg?v=1759437376',
    desc:'Ultrascharfe Sasame-Haken – günstig, aber stark: viel mehr Zeit für den perfekten Anschlag und der Fisch schlitzt im Drill seltener aus.'},
  sonarGeber:{name:'High-Def Geber (Schwinger)', ic:'🛰️', price:1200, brand:'Echolot-Upgrade',
    desc:'Besserer Schwinger fürs Echolot: zeigt MEHR Fische auf dem Sonar an → mehr Treffer möglich und eine höhere Chance auf einen Trophäen-Fisch beim nächsten Wurf.'},
  sonarMotor:{name:'Bugmotor (E-Motor)', ic:'🛥️', price:800, brand:'Echolot-Upgrade',
    desc:'Leiser Bugmotor hält das Boot ruhig: Der Scan-Strahl im Echolot bewegt sich deutlich LANGSAMER und ist leichter zu treffen.'},
  sonarDisplay:{name:'Großes Echolot-Display', ic:'🖥️', price:600, brand:'Echolot-Upgrade',
    desc:'Größerer Bildschirm: Die Fische werden auf dem Sonar GRÖSSER dargestellt – einfacher zu erkennen und zu treffen.'},
  livescope:{name:'Live-Scope Echolot', ic:'📡', price:9000, brand:'Deeper',
    handle:'deeper-chirp-3', realPrice:'319,00 €',
    img:'https://cdn.shopify.com/s/files/1/0548/9197/0669/files/Deeper-Chirp_-3_a2bf1041-839c-4271-bf69-da84e7c38c8d.jpg?v=1759437359',
    desc:'High-End Live-Echolot fürs Boot: Das Echolot-Minispiel ist damit JEDERZEIT verfügbar – kein 5-Minuten-Cooldown mehr. Richtig teuer, aber der Gipfel des Komforts.'},
};
function hasGear(k){ return (S.ownGear||[]).includes(k); }
const BOAT_LEVEL=7, COUPON_POINTS=10000, COUPON_CODE='DURCHGESPIELT', SHOP_LMAB='https://www.hechtundbarsch.de/collections/lmab';
const GAME_URL='https://www.hechtundbarsch.de/pages/angelspiel', NEWSLETTER_URL='https://www.hechtundbarsch.de/pages/newsletter';
const VERSION='1.24.0';   // Spielversion – nur auf der Startseite unten angezeigt
const IS_TOUCH=('ontouchstart' in window)||navigator.maxTouchPoints>0;
const COUPON_URL='https://www.hechtundbarsch.de/discount/DURCHGESPIELT?redirect=%2Fcollections%2Flmab';
const DANIEL_CODE='DASWARNIX', DANIEL_URL='https://www.hechtundbarsch.de/discount/DASWARNIX?redirect=%2Fcollections%2Flmab';
const BIGL_CODE='ZISCH-AB', BIGL_URL='https://www.hechtundbarsch.de/discount/ZISCH-AB?redirect=%2Fcollections%2Flmab';

/* Köder-Typ je Köder → bestimmt, welche Montagen erlaubt sind */
const LURETYPE = {
  tauwurm:'natur',
  proshad:'soft', easyshiner:'soft', bigshiner:'soft', drunkbig:'soft', dropshot:'soft', drunkdancer:'soft', drunkmini:'soft', babylui:'soft', maxbait:'soft',
  salmoperch:'hard', zeckdundee:'hard', busterjerk:'hard', kofivibe:'hard',
  jigmaster:'blade', deracoup:'blade', uvspoon:'blade', multivibe:'blade', turbolui:'blade',
  finessecraw:'craw', crabylui:'craw',
};
/* Welche Köder-Typen lassen sich auf welcher Montage fischen */
const RIGALLOW = {
  jigkopf: ['soft','natur','craw'],
  dropshot:['soft','natur','craw'],
  texas:   ['soft','craw'],
  carolina:['soft','natur','craw'],
  grund:   ['natur','soft','craw'],
  direkt:  ['hard','blade'],
};
function rigOK(rig,lureKey){ return (RIGALLOW[rig]||[]).indexOf(LURETYPE[lureKey])>=0; }
function defaultRigFor(lureKey){ const t=LURETYPE[lureKey]; return (t==='hard'||t==='blade')?'direkt':'jigkopf'; }
function typeLabel(t){ return t==='hard'?'Hardbait':t==='blade'?'Spinner/Blech':t==='soft'?'Gummiköder':t==='craw'?'Krebs':'Naturköder'; }
/* Kleiner Köder-Typ-Badge hinter dem Ködernamen (Inline-Styles → funktioniert auch ohne Template-CSS) */
function lureTypeTag(k){ const t=LURETYPE[k]; return ' <span style="display:inline-block;font-size:11px;font-weight:700;opacity:.82;background:rgba(255,255,255,.14);padding:1px 7px;border-radius:9px;vertical-align:middle;white-space:nowrap">'+typeLabel(t)+'</span>'; }
/* Eindeutige Köder-Grafik für die gesteuerte Spielfigur der Köderführungs-Minispiele (klar als Köder erkennbar) */
function lureGlyph(kind){
  if(kind==='soft') return '<svg viewBox="0 0 54 30" width="46" height="26" style="display:block;overflow:visible"><circle cx="9" cy="15" r="6.5" fill="#7cc05a" stroke="#34571f" stroke-width="1.2"/><path d="M13 15 Q27 3 45 11 Q50 15 45 19 Q27 27 13 15 Z" fill="#7cc05a" stroke="#34571f" stroke-width="1.2"/><circle cx="41" cy="12.5" r="1.7" fill="#10210a"/><path d="M22 23 c0 6 9 7 12 2" fill="none" stroke="#c9d2da" stroke-width="1.8" stroke-linecap="round"/></svg>';
  if(kind==='hard') return '<svg viewBox="0 0 58 30" width="48" height="25" style="display:block;overflow:visible"><path d="M45 15 l10 -5" stroke="#9aa7b3" stroke-width="2.6" stroke-linecap="round"/><ellipse cx="27" cy="15" rx="19" ry="7.5" fill="#e7a93f" stroke="#9c6b14" stroke-width="1.2"/><path d="M21 15 h12" stroke="#9c6b14" stroke-width="1" opacity=".55"/><circle cx="41" cy="12.5" r="1.8" fill="#222"/><path d="M14 22 c0 5 6 6 8 1 M28 22 c0 5 6 6 8 1" fill="none" stroke="#c9d2da" stroke-width="1.6" stroke-linecap="round"/></svg>';
  if(kind==='blade') return '<svg viewBox="0 0 30 46" width="26" height="40" style="display:block;overflow:visible"><circle cx="15" cy="5" r="2.4" fill="none" stroke="#828c97" stroke-width="1.4"/><ellipse cx="15" cy="21" rx="9" ry="13.5" fill="#d7dee5" stroke="#828c97" stroke-width="1.4"/><ellipse cx="12" cy="16" rx="2.4" ry="5" fill="#fff" opacity=".75"/><path d="M15 34 c-4 3 -3 9 0 11 c3 -2 4 -8 0 -11" fill="none" stroke="#9aa7b3" stroke-width="1.7"/></svg>';
  return '🎣';
}
/* Echte Pixel-Überlappung zweier Elemente (WYSIWYG-Trefferabfrage); inset verkleinert das Objekt-Rechteck (Emoji-Rand ignorieren) */
function rectHit(elObj, boxRect, inset){ if(!elObj||!boxRect) return false; const a=elObj.getBoundingClientRect(); const p=inset||0;
  return (a.left+p) < boxRect.right && (a.right-p) > boxRect.left && (a.top+p) < boxRect.bottom && (a.bottom-p) > boxRect.top; }

/* Humor – nett-makabere Sprüche */
function pick(a){ return a[Math.floor(Math.random()*a.length)]; }
const QUIPS = {
  catch:[
    'Der Fisch nimmt’s mit Fassung – er hat ja auch keine Wahl.',
    'Erwischt. Irgendwo macht jetzt ein Tauwurm den Triumphtanz.',
    'Gelandet. Wollte eh mal die Welt da oben sehen.',
    'Im Kescher! Seine Kumpels tun jetzt so, als kennen sie ihn nicht.',
    'Schwimmt gleich wieder – wir sind ja nett hier.',
    'Ein Foto, ein Lob, zurück ins Wasser. Therapiekosten übernimmt der Verein.',
  ],
  miss:[
    'Entkommen. Das erzählt er seinen Enkeln noch in zehn Jahren.',
    'Weg. Der Fisch lebt – wie unverschämt.',
    'Ausgeschlitzt. Er hat dich eiskalt ausgetrickst.',
    'Verloren. Da winkt jemand mit der Schwanzflosse.',
  ],
  tree:[
    '🌳 Hänger im Baum! Der Baum hatte eben auch Hunger.',
    '🌳 Im Geäst gelandet. Die Vögel sagen danke für den Köder.',
  ],
  bank:[
    '🪨 Im Grund versenkt. Bleibt jetzt da – als kleines Mahnmal.',
    '🌾 Direkt vor den Füßen im Kraut. Die Schnecken freuen sich.',
  ],
};

/* Guide-Wortgefecht (Monkey-Island-Stil): finde die schmeichelnde/clevere Antwort */
function fmt(s,g){ const f=g.all?'Fische':SPECIES[g.sp].name; return s.replace(/\{n\}/g,g.name.split(' ')[0]).replace(/\{f\}/g,f).replace(/\{s\}/g,g.spot); }
const ENCOUNTER = [
  { q:'Und warum sollte ich ausgerechnet mit DIR losziehen?',
    opts:[
      {t:'Weil ich von einem Meister wie dir lernen will – deine {f} sind Legende.', s:26, r:'Schmeichler… aber gut, ich hör zu.'},
      {t:'Ich hab halt Bock zu angeln, dachte, passt schon.', s:5, r:'Aha. Wie aufregend.'},
      {t:'Weil ich sowieso besser fange als du.', s:-22, r:'Ach? Dann brauchst du mich ja nicht.'} ]},
  { q:'Ich hab heut eigentlich keine Zeit für Anfänger.',
    opts:[
      {t:'Ein {s}-Profi macht aus jedem Anfänger einen Fänger – das trau ich nur dir zu.', s:26, r:'Na, wenn du meinst…'},
      {t:'Komm schon, nur ein, zwei Stündchen.', s:5, r:'Hmpf. Mal sehen.'},
      {t:'Anfänger? Ich häng dich locker ab.', s:-22, r:'Großes Mundwerk, kleiner Fang.'} ]},
  { q:'Was weißt du schon über {f}?',
    opts:[
      {t:'Genug, um zu wissen, dass DU der Beste darin bist.', s:26, r:'*grinst* Der Satz wirkt.'},
      {t:'So einiges, glaub ich.', s:5, r:'„Glaub ich." Beruhigend.'},
      {t:'Mehr als du vermutlich.', s:-22, r:'Dann viel Spaß – allein.'} ]},
  { q:'Köder ins Wasser werfen kann ja wohl jeder.',
    opts:[
      {t:'Klar – aber so kapitale {f} wie du fängt eben nicht jeder.', s:26, r:'Da ist was dran, muss ich sagen.'},
      {t:'Stimmt schon irgendwie.', s:5, r:'Eben.'},
      {t:'Genau, ist ja keine Kunst.', s:-22, r:'Dann zeig’s doch ohne mich.'} ]},
  { q:'Hm. Du redest gut. Aber meinst du das auch ernst?',
    opts:[
      {t:'Todernst. Mit dir wird das der Angeltag meines Lebens.', s:26, r:'Okay okay, fast hast du mich.'},
      {t:'Klar, sicher doch.', s:5, r:'Überzeugend klingt anders.'},
      {t:'War halt nur so ein Versuch.', s:-22, r:'Dann lassen wir’s.'} ]},
  { q:'Na gut, fast überzeugt. Ein letzter Satz – überzeug mich!',
    opts:[
      {t:'Wenn nicht du mir den {f} zeigst – wer dann? Bitte!', s:26, r:'*seufzt* Also gut!'},
      {t:'Bitte bitte, mit Tauwurm obendrauf?', s:6, r:'Du bist hartnäckig…'},
      {t:'Sonst frag ich halt wen anders.', s:-22, r:'Dann mach das mal.'} ]},
];
const ENCOUNTER_WIN = ['Na gut, du Schleimer – aber nur, weil du’s bist!','Überredet. Lass uns ein paar {f} ärgern!','Dein Charme ist zäher als meine alte Wathose. Komm mit!'];
const ENCOUNTER_FAIL = ['Schöner Versuch. Petri Heil – allein.','Such dir wen anders zum Anhimmeln.','Nö. Meine {f} bleiben heut meine {f}.'];
/* Anmachspruch (erste Wahl nach „Anquatschen") – generischer Fallback */
const ENCOUNTER_OPENER = { opts:[
  {t:'Hey, du bist doch {n} von HechtundBarsch, oder? Du fängst doch immer so dicke {f}! Geil, dass ich dich hier treffe.', s:30, r:'Haha, erkannt! Sympathisch.'},
  {t:'Hey, du siehst heute richtig gut aus – dein Gesicht kommt mir voll bekannt vor.', s:16, r:'Schleimer… aber weiter.'},
  {t:'Digga, was geht denn heute – schon was gefangen?', s:-14, r:'„Digga." Aha.'},
  {t:'Hey {n}, geilooo! Können wir ein Foto machen?', s:-14, r:'Erst mal langsam, ja?'} ]};
/* Pro Guide eigener Anmachspruch – passend zur Persönlichkeit */
const GUIDE_OPENERS = {
  mario:{ opts:[
    {t:'Mario Sing! Der Bootsprofi aus Holland – du stellst die fettesten Zander wie kein Zweiter. Nimm mich mit!', s:30, r:'Haha, du weisst Bescheid. Stap maar in.'},
    {t:'Hey, du fängst doch die Großzander in den Poldern, oder? Mega Respekt.', s:16, r:'Klopt. Erzähl weiter.'},
    {t:'Zander? Sind doch eh nur Hechte für Arme.', s:-20, r:'Zeg dat nog eens. Allein.'},
    {t:'Digga, kutscher mich mal mit dem Boot rum, ja?', s:-14, r:'Eerst Respekt, dann Boot.'} ]},
  ihno:{ opts:[
    {t:'Moin Ihno! Deine Tackle-Videos kenn ich alle auswendig – und die Modelfotos, ehrlich gesagt, auch. Doppelbegabung!', s:30, r:'Haha, ein Fan mit Geschmack. Weiter so.'},
    {t:'Moin! Dich kenn ich aus YouTube – deine Barsch-Tipps sind Gold wert.', s:16, r:'Schön, dass es ankommt.'},
    {t:'Ey, machst du mal ein Modelfoto mit mir fürs Insta?', s:-14, r:'Erst mal langsam, ja?'},
    {t:'Moin Digga, schon was am Kanal gerissen?', s:-16, r:'„Digga." Na herrlich.'} ]},
  johannes:{ opts:[
    {t:'Johannes Gasser?! Ich fische deine LMAB-Köder auf jedem Turnier – und am Bodensee bist du eh die Macht.', s:30, r:'Ein echter Kenner. Das hör ich gern.'},
    {t:'Hey, du angelst doch die großen Turniere am Bodensee, oder? Riesen Respekt.', s:16, r:'Danke, danke. Sprich weiter.'},
    {t:'Sag mal, kriegt man die LMAB-Köder von dir nicht irgendwie umsonst?', s:-16, r:'Frechheit zahlt sich selten aus.'},
    {t:'Turniere? Halt ich ehrlich für reine Glückssache.', s:-20, r:'Aha. Dann viel Glück – allein.'} ]},
  daniel:{ opts:[
    {t:'Daniel! Mann, kein Guide hat so viel Herzblut – du fischst wirklich JEDES Turnier mit. Das ist echte Leidenschaft!', s:30, r:'Ahh, du verstehen! Herz ist gross, Fisch ist manchmal klein. Aber wir machen!'},
    {t:'Hey Daniel, mit dir beißt angeblich einfach alles – zeigst du mir das?', s:16, r:'Ja ja, alles beissen! Gross nicht immer, aber viele. Komm, komm.'},
    {t:'Sag mal, so ein Turnier gewonnen hast du eigentlich noch nie, oder?', s:-18, r:'Ohh… du bist wie meine Frau. Aua. Tschüss vielleicht.'},
    {t:'Dein Deutsch ist ja immer noch… speziell, was?', s:-18, r:'Zwanzig Jahr hier! Und du? Kannst du Shona? Nein. Also.'} ]},
};
const TIPS = [
  'Schlag sofort beim Biss an – je besser der Anschlag, desto einfacher wird der Drill (mehr Spielraum, kein Schnurbruch).',
  'Beim Auswerfen den wandernden Fisch möglichst genau treffen. Daneben = Hänger und kein Wurf.',
  'Im Drill den Fisch im grünen Fenster halten. Große Fische kämpfen wilder – lass dich nicht abschütteln.',
  'Beim Keschern den Kescher auf den Fisch halten. Vorsicht: Er springt! Ein größerer/wendigerer Kescher hilft enorm.',
  'Köder, Montage, Gewässer, Tageszeit & Wetter bestimmen, was beißt – wirf einen Blick auf die Beiß-Vorschau.',
  'Stärkere Rute = mehr „Power" gegen Schnurbruch. Schnellere Rolle = flotteres Einkurbeln. Größerer Kescher = sichere Landung.',
  'Ab Level 7 vom Boot angeln – das bringt deutlich mehr & größere Fische. Und buch (oder überrede) mal einen Guide!',
];
/* Ausführliche Hilfe – nach Themen gruppiert (inkl. der neuen Features) */
const HELP_SECTIONS = [
  { h:'🎯 Auswerfen & Wurfplatz', t:'Triff beim Wurf den wandernden Fisch möglichst genau – je präziser, desto besser der Wurf. Die <b>Höhe</b>, auf der du landest, bestimmt den Spot: <b>Ufer/Schilf</b> (Hecht & Barsch), <b>Kante/Tiefe</b> (Zander & Wels) oder <b>Freiwasser</b> (Rapfen & Black Bass). Daneben = Hänger.' },
  { h:'🎣 Köderführung (Dartscheibe)', t:'Nach dem Wurf tippst du auf <b>„Köderführung starten"</b>. Dann hältst du den driftenden Köder mit Maus/Finger in der Mitte des Kreises. <b>Ganz innen = perfekt</b>, weiter außen = ok, außerhalb = schlecht. Gute Führung reizt den Fisch → <b>schnellerer Biss & größere Fische</b>. Danach tippst du auf <b>„Köder präsentieren"</b>.' },
  { h:'👀 Nachläufer (Reizen)', t:'Manchmal folgt ein Fisch dem Köder, statt sofort zu beißen. Führ den Köder dann <b>lebhaft & zügig durch die Punkte (1→Ende)</b>. Zwei Leisten zählen: <b>⏱️ Zeit</b> läuft ab – und <b>🐟 Interesse</b> steigt nur, wenn du den Köder ständig in Bewegung und nah am Fisch hältst. Stehst du still, bist zu schnell (Fisch hängt hinterher) oder zu langsam → Interesse sinkt, er dreht ab. Pfade & Punktzahl wechseln zufällig.' },
  { h:'⚡ Anschlag (Anhauen)', t:'Nach „Köder präsentieren" läuft es in Phasen: <b>1.</b> Köder wird präsentiert · <b>2.</b> ein Fisch nähert sich – bereithalten! · <b>3.</b> sobald der Button in der Mitte <b>GRÜN</b> wird („⚡ JETZT ANHAUEN!"), blitzschnell tippen/Leertaste. Nicht zu früh (auf Rot) anhauen! Je schneller deine Reaktion, desto besser hängt der Fisch – das macht den Drill leichter.' },
  { h:'💪 Drill', t:'Halte den Fisch im <b>grünen Fenster</b> (Halten = einkurbeln). Achte auf Reaktionen: bei <b>Kopfschlag/Sprung LOSLASSEN</b>, bei <b>Flucht HALTEN</b>. Große Fische & Legenden kämpfen wilder und <b>dauern länger</b>. Bessere Rute = mehr Power gegen Schnurbruch.' },
  { h:'🥅 Keschern', t:'Bewege den Kescher mit Maus/Finger auf den Fisch und halt ihn drauf – Vorsicht, er flüchtet in Sprüngen. Auf dem Handy schwebt der Kescher <b>über deinem Finger</b>, damit du den Fisch siehst. Größerer/wendigerer Kescher = sichere Landung.' },
  { h:'📡 Echolot (vom Boot)', t:'Nur <b>vom Boot</b> verfügbar und <b>alle 5 Minuten</b> nutzbar. Du hast <b>5 Versuche</b>, mit dem Scan-Strahl die 3 Fische zu treffen. Mehr Treffer = <b>schnellerer Biss & größere Fische beim nächsten Wurf</b>.' },
  { h:'🤲 Schonmaß & Catch & Release', t:'Untermaßige Fische werden automatisch <b>schonend zurückgesetzt</b> (kein Verkauf, dafür ☯️ Karma & Naturschutz). Du kannst außerdem <b>jeden Fang freiwillig zurücksetzen</b> – das bringt ebenfalls Karma.' },
  { h:'☯️ Karma', t:'Karma steigt durch Zurücksetzen von Fischen und gute Taten. Hohes Karma <b>verbessert deine Fänge</b> (größere Fische) und <b>begünstigt positive Events</b> (du findest Geld, Tackle u. v. m.). Dein Karma siehst du oben in der Leiste.' },
  { h:'🐉 Legenden / Trophäen-Fische', t:'In jedem Gewässer lauern <b>2–3 benannte Riesen</b> (z. B. „Der Graf vom Edersee"). Sie steigen selten im Drill ein – die Chance steigt mit gutem Wurf, Echolot, Boot & Guide. Gelandete Legenden kannst du als besonderes <b>Trophäenbild</b> teilen.' },
  { h:'🏆 Challenges & 🏁 Turniere', t:'Challenges sind Aufgaben mit Zeitlimit. Turniere kosten Startgeld – fange im Zeitlimit das <b>höchste Gesamtgewicht</b> und schlag das Teilnehmerfeld um Preisgeld (Platz 1–3).' },
  { h:'🎯 Profi-Setups', t:'Fertige Köder-/Montage-/Farb-Kombis je Zielfisch – mit einem Tipp im Spiel ausrüsten und die passenden <b>echten Produkte</b> im HechtundBarsch-Shop entdecken.' },
  { h:'🌅 Bedingungen', t:'Gewässer, Tageszeit, Wetter, Jahreszeit, Köderfarbe & Montage entscheiden, was beißt – wirf einen Blick auf die <b>Beiß-Vorschau</b>. Nachts beißen mehr Zander & Wels; dann hilft eine Kopflampe.' },
  { h:'🛒 Ausrüstung & Belohnungen', t:'Bessere Rute (Power), Rolle (Speed) und Kescher (Landung) zahlen sich aus. Boote & Guides bringen mehr & größere Fische. Bei 10.000 Punkten (ab „Normal") gibt’s einen echten Gutschein. Tipp oben auf „✎ Ändern", um schnell umzustellen.' },
];
/* Challenges – Aufgaben an einem Gewässer mit Zeitlimit */
const CHALLENGES = [
  { id:'mix', name:'Bunte Strecke', water:'mueritz', mins:7, diff:'Mittel', reward:350,
    goal:'Fange 3 Zander, 2 Barsche & 1 Hecht', need:{zander:3,barsch:2,hecht:1},
    desc:'Mischstrecke an der Müritz. Wechsle Köder & Tageszeit clever (Zander mag Dämmerung).' },
  { id:'perch5', name:'Barsch-Marathon', water:'bodensee', mins:5, diff:'Mittel', reward:350,
    goal:'Fange 5 Barsche', need:{barsch:5},
    desc:'Barsch satt am Bodensee – Finesse & Naturfarben bei klarem Wasser zahlen sich aus.' },
  { id:'crawking', name:'Krebs-König', water:'bodensee', mins:7, diff:'Schwer', reward:650, lureKind:'craw',
    goal:'Fange NUR mit Krebs-Köder 3 Barsche & 2 Zander', need:{barsch:3,zander:2},
    desc:'Krebse sind DER Köder für kapitale Barsche – und Zander stehen ebenfalls drauf! Rüste einen Krebs-Köder aus (LMAB Finesse Filet Craw oder Monkey Lures Craby Lui, im Angelladen) und führ ihn am Grund. Nur Fänge mit dem Krebs zählen!' },
  { id:'len10', name:'10-Meter-Strecke', water:'edersee', mins:7, diff:'Mittel', reward:450,
    goal:'Fange Fische mit zusammen 10 m Gesamtlänge', len:10,
    desc:'Masse zählt – aber ein Großhecht bringt dich schnell voran.' },
  { id:'slam', name:'Fluss-Slam', water:'rhein', mins:9, diff:'Schwer', reward:900,
    goal:'Fange JEDE Rhein-Art mind. 1× (Zander, Barsch, Rapfen, Hecht, Wels)', needAll:true,
    desc:'Alle Arten – jede braucht den passenden Köder. Der Wels verlangt schweres Gerät.' },
  { id:'bigpike', name:'Großhecht-Duo', water:'edersee', mins:8, diff:'Schwer', reward:1000,
    goal:'Fange 2 Hechte über je 9 kg', bigNeed:{sp:'hecht',kg:9,n:2},
    desc:'Nur mit Top-Rute & guter Rolle (und besser vom Boot/Guide) machbar.' },
  { id:'monster', name:'Wels-Monster', water:'ebro', mins:10, diff:'Brutal', reward:2000,
    goal:'Fange einen Wels über 35 kg', bigNeed:{sp:'wels',kg:35,n:1},
    desc:'Das Endgame am Ebro. Wallerrute, Big-Pit-Rolle & XL-Kescher sind Pflicht – am besten mit Boot.' },
  { id:'night', name:'Nachtschicht', water:'rhein', mins:8, diff:'Schwer', reward:850, night:true,
    goal:'Fange im Dunkeln 3 Zander & 1 Wels', need:{zander:3,wels:1},
    desc:'Nur bei Nacht – Kopflampe an! In der Dunkelheit jagen Zander & Wels am Rhein. (Tageszeit bleibt fixiert.) Eine LMAB Stirnlampe hilft enorm.' },
];
let CH=null;
/* ========================= TURNIER-MODUS ========================= */
let TOURNEY=null;
const TOURNEYS=[
  { id:'kanal-cup', name:'Kanal-Cup', water:'mittellandkanal', mins:5, fee:100,
    desc:'Schnelles Zander- & Barsch-Wettangeln am Kanal. Höchstes Gesamtgewicht gewinnt.',
    field:[['Tom',2.4],['Lena',3.1],['Basti',1.8],['Mareike',2.7]] },
  { id:'bodensee-classic', name:'Bodensee Classic', water:'bodensee', mins:6, fee:200,
    desc:'Edles Barsch- & Hechtturnier am glasklaren Bodensee.',
    field:[['Johannes',4.6],['Sabine',3.4],['Kilian',2.9],['Wddo',3.8]] },
  { id:'ebro-masters', name:'Ebro Masters', water:'ebro', mins:8, fee:400,
    desc:'Internationales Trophäen-Turnier am Ebro. Hier zählt jedes Kilo.',
    field:[['Mario',9.5],['Big L',12.0],['Pablo',7.5],['Hendrik',8.4]] },
  { id:'fjord-open', name:'Fjord Open (Norwegen)', water:'norwegen', mins:9, fee:600,
    desc:'Meeresturnier im Fjord – Dorsch, Köhler, Heilbutt. Nur für Profis mit schwerem Gerät.',
    field:[['Lars',16],['Ingrid',13],['Ole',19],['Sven',14]] },
];
function tourneyActive(){ return !!TOURNEY; }
function startTourney(id){ const d=TOURNEYS.find(t=>t.id===id); if(!d) return;
  if(S.money<d.fee){ toast('💶 Startgeld reicht nicht ('+d.fee+' 💶)'); return; }
  S.money-=d.fee; TOURNEY={ def:d, deadline:Date.now()+d.mins*60000, score:0 }; S.water=d.water; save(); go('fish'); }
function tourneyEnd(){ if(!TOURNEY) return; const d=TOURNEY.def, mine=TOURNEY.score; TOURNEY=null;
  const board=d.field.map(([nm,skill])=>[nm, Math.max(0.2, skill*(0.6+Math.random()*0.8))]);
  board.push(['DU 🫵', mine]); board.sort((a,b)=>b[1]-a[1]);
  const place=board.findIndex(x=>x[0]==='DU 🫵')+1;
  const prizes=[d.fee*4, d.fee*2, d.fee, 0], prize=prizes[place-1]||0;
  if(place===1) S.tourWins=(S.tourWins||0)+1;
  S.money+=prize; if(prize>0) addXp(Math.round(prize*0.4)); save(); syncTop(); place<=3?sfx.win():sfx.lose();
  const rows=board.map((x,i)=>`<div style="display:flex;justify-content:space-between;padding:5px 8px;border-radius:8px;${x[0]==='DU 🫵'?'background:rgba(49,133,218,.25);font-weight:800':''}"><span>${i+1}. ${x[0]}</span><span>${x[1].toFixed(2)} kg</span></div>`).join('');
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon" style="background:${place===1?'var(--gold)':'var(--accent)'};color:${place===1?'#3a2a00':'#04222c'}">🏁 ${d.name} – Platz ${place}</div>
    <div style="font-size:50px">${place===1?'🥇':place===2?'🥈':place===3?'🥉':'🎣'}</div>
    <div class="fname">${place===1?'TURNIERSIEG!':'Platz '+place+' von '+board.length}</div>
    <div class="sub" style="margin:8px 6px">Dein Gewicht: <b>${mine.toFixed(2)} kg</b>${prize>0?` · Preisgeld: <b>+${prize} 💶</b>`:' · leider kein Preisgeld'}</div>
    <div class="card" style="text-align:left;margin:4px 0">${rows}</div>
    <button class="btn full gold" id="tEndGo">Weiter</button>
    <button class="btn ghost full" id="tEndMore" style="margin-top:8px">🏁 Weitere Turniere</button></div>`;
  document.body.appendChild(ov); checkBadges();
  ov.querySelector('#tEndGo').onclick=()=>{ ov.remove(); armIdle(); };
  ov.querySelector('#tEndMore').onclick=()=>{ ov.remove(); go('tourneys'); };
}
function tourneyTimeLeft(){ const ms=Math.max(0,(TOURNEY?TOURNEY.deadline:0)-Date.now()); const s=Math.ceil(ms/1000); return Math.floor(s/60)+':'+String(s%60).padStart(2,'0'); }
function renderTourneys(){
  let h=topBack()+`<h2>🏁 Turniere</h2><p class="sub">Zahle Startgeld und fange im Zeitlimit das höchste Gesamtgewicht. Schlage das Teilnehmerfeld – Platz 1–3 bringt Preisgeld!</p><div class="grid">`;
  for(const d of TOURNEYS){
    h+=`<div class="pick" style="cursor:default">
      <div class="ttl"><span class="ic">${WATERS[d.water].ic}</span> ${d.name}</div>
      <div class="brandline">${WATERS[d.water].name} · ⏱️ ${d.mins} Min · Startgeld ${d.fee} 💶 · Sieg ${d.fee*4} 💶</div>
      <div class="meta">${d.desc}<br><b>Feld:</b> ${d.field.map(f=>f[0]).join(', ')}</div>
      <div style="margin-top:10px"><button class="btn gold" data-to="${d.id}" style="padding:9px 14px;font-size:14px">▶ Antreten (${d.fee} 💶)</button></div>
    </div>`; }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h;
  screen.querySelectorAll('[data-to]').forEach(b=>b.onclick=()=>startTourney(b.dataset.to));
  wireBack('start');
}
function challengeActive(){ return !!CH; }
function startChallenge(id){
  const d=CHALLENGES.find(c=>c.id===id); if(!d) return;
  CH={ def:d, deadline:Date.now()+d.mins*60000, counts:{}, len:0, big:0 };
  S.water=d.water; if(d.night) S.time='nacht'; save();
  go('fish');
}
function challengeMet(d){
  if(d.need) return Object.keys(d.need).every(k=>(CH.counts[k]||0)>=d.need[k]);
  if(d.needAll) return Object.keys(WATERS[d.water].pop).every(k=>(CH.counts[k]||0)>=1);
  if(d.len) return CH.len>=d.len;
  if(d.bigNeed) return (CH.big||0)>=d.bigNeed.n;
  return false;
}
function challengeProgress(d){
  if(d.need) return Object.keys(d.need).map(k=>fishIcon(k,14)+Math.min(CH.counts[k]||0,d.need[k])+'/'+d.need[k]).join(' ');
  if(d.needAll){ return Object.keys(WATERS[d.water].pop).map(k=>(CH.counts[k]?'✅':'⬜')+SPECIES[k].name.slice(0,3)).join(' '); }
  if(d.len) return Math.min(CH.len,d.len).toFixed(1)+' / '+d.len+' m';
  if(d.bigNeed) return (CH.big||0)+'/'+d.bigNeed.n+' · '+SPECIES[d.bigNeed.sp].name+' > '+d.bigNeed.kg+' kg';
  return '';
}
function challengeOnCatch(sp,weight){
  if(!CH) return; const d=CH.def;
  if(d.lureKind && LURETYPE[S.lure]!==d.lureKind){ toast('🦀 Nur Fänge mit Krebs-Köder zählen für diese Challenge!'); return; }   // Krebs-Challenge: nur Krebs-Fänge zählen
  CH.counts[sp]=(CH.counts[sp]||0)+1;
  CH.len += lengthEst(sp,weight)/100;
  if(d.bigNeed && sp===d.bigNeed.sp && weight>=d.bigNeed.kg) CH.big=(CH.big||0)+1;
  if(challengeMet(d)) setTimeout(challengeWin,50);
}
function challengeWin(){ if(!CH) return; const d=CH.def; CH=null;
  S.money+=d.reward; addXp(Math.round(d.reward*0.7));
  if(!S.chDone) S.chDone=[]; const firstTime=!S.chDone.includes(d.id); if(firstTime) S.chDone.push(d.id);
  save(); syncTop(); sfx.win();
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="text-align:center;max-width:400px">
    <div class="ribbon">🏆 CHALLENGE GESCHAFFT!</div>
    <div style="font-size:56px">🎉</div>
    <div class="fname">${d.name}</div>
    <div class="sub" style="margin:8px 6px">${d.goal} – erledigt! Belohnung: <b>+${d.reward} 💶</b> & <b>+${Math.round(d.reward*0.7)} Punkte</b>.${firstTime?' <span style="color:var(--accent2)">Neu abgeschlossen! ✅</span>':''}</div>
    <div class="card" style="margin:10px 0 4px;text-align:left">
      <b>📤 Erfolg teilen</b>
      <div class="sub" style="margin:6px 0">Zeig deinen Angelkumpels, dass du „${d.name}" (${d.diff}) geknackt hast.</div>
      ${shareRowHTML()}
    </div>
    <button class="btn full gold" id="chGo">Weiter</button>
    <button class="btn ghost full" id="chMore" style="margin-top:8px">🏆 Weitere Challenges</button></div>`;
  document.body.appendChild(ov);
  wireShare(ov, ()=>challengeShareText(d));
  ov.querySelector('#chGo').onclick=()=>{ ov.remove(); armIdle(); };
  ov.querySelector('#chMore').onclick=()=>{ ov.remove(); go('challenges'); };
}
function challengeFail(){ if(!CH) return; const d=CH.def; CH=null; sfx.lose();
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="text-align:center;max-width:380px">
    <div style="font-size:52px">⏰</div>
    <div class="fname" style="color:var(--danger)">Zeit abgelaufen!</div>
    <div class="sub" style="margin:8px 6px">Challenge „${d.name}" nicht geschafft. Vielleicht mit besserem Tackle, Guide oder Boot?</div>
    <button class="btn full gold" id="chGo">Nochmal versuchen</button>
    <button class="btn ghost full" id="chGo2" style="margin-top:8px">Zurück zum Spiel</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#chGo').onclick=()=>{ ov.remove(); go('challenges'); };
  ov.querySelector('#chGo2').onclick=()=>{ ov.remove(); armIdle(); };
}
function chTimeLeft(){ const ms=Math.max(0,(CH?CH.deadline:0)-Date.now()); const s=Math.ceil(ms/1000); return Math.floor(s/60)+':'+String(s%60).padStart(2,'0'); }

/* Allgemeine Tipps, die zwischendurch beim Angeln eingeblendet werden */
const GAMETIPS = [
  'Du kannst im Angelladen einen Guide buchen – das erhöht deine Chance auf einen kapitalen Fisch enorm.',
  'Manche Köder sind top auf Hecht, andere auf Zander. Wähle den Köder passend zum Gewässer und den Fischen dort.',
  'Im Shop gibt’s Boote – vom Boot beißt es deutlich besser und du fängst mehr Fische.',
  'Triffst du am Wasser zufällig einen Guide, überrede ihn im Wortgefecht, mit dir zu angeln!',
  'Sammle 10.000 Punkte (mind. Schwierigkeit „Normal") – dann bekommst du einen echten Gutschein für HechtundBarsch.de!',
  'Tipp oben auf die Info-Leiste „✎ Ändern", um Köder, Montage, Wetter & Gewässer schnell zu wechseln.',
  'Köderführung: Halte den Köder mit Maus/Finger in der Mitte des Kreises – ganz innen = perfekt → schnellerer Biss & größere Fische.',
  'Die Wurfhöhe bestimmt den Spot: Ufer/Schilf bringt Hecht & Barsch, die Kante Zander & Wels, das Freiwasser Rapfen & Bass.',
  'Folgt dir ein Fisch (Nachläufer): führ den Köder lebhaft & zügig durch alle Punkte, bevor die Zeit abläuft – und halt die Interesse-Leiste oben (Bewegung & Nähe), sonst dreht er ab.',
  'Vom Boot kannst du das Echolot nutzen (alle 5 Minuten, 5 Versuche): Treffer orten Hotspots → der nächste Wurf läuft besser.',
  'Untermaßige Fische werden schonend zurückgesetzt – das bringt kein Geld, aber ☯️ Karma. Du kannst jeden Fisch freiwillig releasen.',
  'Hohes Karma verbessert deine Fänge und beschert dir mehr Glück (Geldfunde, gefundenes Tackle, gute Events).',
  'Im Drill kommen Kopfschlag & Sprung (dann LOSLASSEN!) und Fluchten (dann HALTEN!). Richtig reagieren bringt dich näher zur Landung.',
  'Große Fische dauern im Drill länger und kämpfen wilder – bleib geduldig im grünen Fenster.',
  'In jedem Gewässer lauern 2–3 Legenden – riesige, benannte Fische. Mit etwas Glück (und gutem Wurf) steigt eine im Drill ein!',
  'Für Wels lohnt sich ein großer Köder wie der Drunk Dancer 23 cm – Blinker am Grund gehen ebenfalls auf Waller.',
  'Probier die Turniere: zahle Startgeld, fange im Zeitlimit das meiste Gewicht und schlag das Teilnehmerfeld um Preisgeld.',
  'Unter „Profi-Setups" findest du fertige Kombis je Zielfisch – im Spiel ausrüsten & passende echte Produkte im Shop entdecken.',
  'Bei Nacht trägst du eine Kopflampe – führe den Lichtkegel übers Wasser. Eine LMAB Stirnlampe macht ihn deutlich größer.',
  '🕐 Tageszeit zählt: In der Dämmerung (Morgen & Abend) ist die beste Beißzeit – Hecht und Zander sind dann besonders aktiv.',
  '🌙 Nachts beißen vor allem Zander & Wels. Tagsüber sind die Sichtjäger Barsch & Rapfen aktiver.',
  '☀️ Bei praller Sonne beißt es zäher (Fische stehen tief/im Schatten) – bei Regen & bedecktem Himmel werden Raubfische aktiver.',
  '📅 Jahreszeit wirkt: Im Frühjahr & Herbst läuft es am besten, im Sommer gut, im Winter zäh – dafür dann oft besonders kapitale Fische.',
  '💧 Wassertrübung: Bei klarem Wasser natürliche Farben, bei trübem Wasser grelle Reizfarben wählen (oben unter „✎ Ändern").',
  '🎯 Der Wurf bestimmt die Fischgröße: ein präziser Treffer UND ein weiter Wurf (Freiwasser) bringen tendenziell größere Fische.',
  '🪝 Scharfe Haken aus dem Spiele-Shop geben dir mehr Zeit beim Anhauen und der Fisch schlitzt seltener aus.',
  '⏱️ Drill-Tipp: Der Haken-Halt-Balken oben zeigt, wie fest der Fisch sitzt – wird er rot, reißt der Fisch gleich aus.',
  '📡 Fürs Echolot gibt es im Angelladen (Zubehör) Upgrades: ein Geber zeigt mehr Fische (+Trophäen-Chance), ein Bugmotor verlangsamt den Strahl, ein größeres Display zeigt die Fische größer.',
  '🦀 Krebse sind DER Köder für Barsche – gerade kapitale Barsche lieben sie, und auch Zander stehen drauf! Rüste einen Krebs-Köder (LMAB Finesse Filet Craw oder Monkey Lures Craby Lui) aus und führ ihn am Grund.',
  '🦀 Tipp: Mit einem Krebs-Köder fängst du tendenziell größere Barsche & Zander. Probier auch die „Krebs-König"-Challenge!',
];

/* ---------- Spielstand ---------- */
const SAVE_KEY='raubfisch_angeln_v3';
const defaultSave=()=>({
  money:60, xp:0, level:1, sound:true,
  rod:'teleskop', reel:'basic', net:'klein', lure:'tauwurm', water:'mueritz', time:'tag', weather:'sonnig',
  season:'sommer', color:'naturell', rig:'jigkopf', difficulty:'normal',
  ownRods:['teleskop'], ownReels:['basic'], ownNets:['klein'], ownLures:['tauwurm'],
  boats:[], boat:null, fromBoat:false, couponEarned:false, guideKey:null, guideUntil:0, guideCatch:null, tipsSeen:false, biglCoupon:false, ownGear:[], nextBigFish:false,
  chDone:[], eventSeen:{}, nightSeen:false, buddySeen:false, buddyUntil:0, buddyGear:null, spookedUntil:0, goodSpotUntil:0, netHardUntil:0, shopDiscUntil:0, bluntHooks:false, nextBadFish:false,
  lureXp:{}, badges:[], daily:null, nightCatch:0, releases:0, bosses:{}, tourWins:0, rainbowUntil:0, karma:0, echoUntil:0,
  hook:{n:0,sum:0,best:9999,fast:0,streak:0,bestStreak:0,awardedStreak:0},
  netBroken:false,
  book:{}, totalCatch:0,
});
let S=load();
function load(){ try{ const d=JSON.parse(localStorage.getItem(SAVE_KEY)); return d?{...defaultSave(),...d}:defaultSave(); }catch(e){ return defaultSave(); } }
function save(){ try{ localStorage.setItem(SAVE_KEY,JSON.stringify(S)); }catch(e){} }
function fmtMMSS(ms){ const s=Math.max(0,Math.ceil(ms/1000)); return Math.floor(s/60)+':'+String(s%60).padStart(2,'0'); }
function addKarma(n){ S.karma=Math.max(0,(S.karma||0)+n); }
function karmaP(){ return Math.min(1,(S.karma||0)/50); }   // 0..1 Skala (50 Karma = max Wirkung)
const levelForXp=xp=>Math.floor(Math.sqrt(xp/40))+1;
function addXp(n){ const pl=S.level; S.xp+=n; S.level=levelForXp(S.xp); if(S.level>pl) setTimeout(()=>sfx.levelup(),500); }
/* Köder „einfischen": je öfter ein Köder fängt, desto eingespielter (Lvl 1–3) → minimal größere Fische */
const LURE_TIERS=[0,15,40,80];
function lureUses(k){ return (S.lureXp&&S.lureXp[k])||0; }
function lureLevel(k){ const u=lureUses(k); let lv=0; for(let i=1;i<LURE_TIERS.length;i++) if(u>=LURE_TIERS[i]) lv=i; return lv; }
function lureStars(k){ const lv=lureLevel(k); return lv>0?'★'.repeat(lv):''; }

/* ---------- Sound ---------- */
let actx=null;
function beep(freq=440,dur=.08,type='sine',vol=.2){
  if(!S.sound) return;
  try{ actx=actx||new (window.AudioContext||window.webkitAudioContext)();
    const o=actx.createOscillator(),g=actx.createGain();
    o.type=type;o.frequency.value=freq;o.connect(g);g.connect(actx.destination);
    g.gain.setValueAtTime(vol,actx.currentTime); g.gain.exponentialRampToValueAtTime(.001,actx.currentTime+dur);
    o.start();o.stop(actx.currentTime+dur);
  }catch(e){}
}
const sfx={
  cast:()=>beep(300,.14,'triangle'),
  whoosh:()=>{beep(520,.08,'sine',.12);setTimeout(()=>beep(360,.1,'sine',.1),60);},
  splash:()=>beep(180,.12,'sine',.15),
  bite:()=>{beep(700,.06,'square');setTimeout(()=>beep(900,.06,'square'),70);vib(70);},
  reel:()=>beep(220,.03,'sawtooth',.05),
  perfect:()=>{[660,990,1320].forEach((f,i)=>setTimeout(()=>beep(f,.08,'triangle'),i*60));vib([0,30,40,30]);},
  win:()=>{[523,659,784,1046].forEach((f,i)=>setTimeout(()=>beep(f,.12,'triangle'),i*90));vib([0,50,60,100]);},
  lose:()=>{beep(200,.25,'sawtooth',.18);setTimeout(()=>beep(140,.3,'sawtooth',.18),120);vib(220);},
  buy:()=>{beep(880,.05);setTimeout(()=>beep(1200,.08),60);},
  click:()=>beep(440,.025,'sine',.06),
  levelup:()=>{[523,659,784,1046,1318].forEach((f,i)=>setTimeout(()=>beep(f,.10,'triangle',.18),i*70));},
  coupon:()=>{[784,1047,1319,1568,2093].forEach((f,i)=>setTimeout(()=>beep(f,.11,'triangle',.16),i*80));},
  tip:()=>{beep(988,.06,'sine',.1);setTimeout(()=>beep(1319,.07,'sine',.09),70);},
  big:()=>{beep(150,.22,'sine',.18);setTimeout(()=>beep(220,.2,'sine',.14),110);vib(150);},
  brake:()=>beep(1700+Math.random()*700,.018,'square',.05),   // Ratschen-Klick der Rollenbremse
  netfill:(c)=>beep(540+(c||0)*520,.05,'sine',.05),           // sanftes Füll-Blip beim Keschern (steigt mit Fortschritt)
  land:()=>{[659,880,1175,1568].forEach((f,i)=>setTimeout(()=>beep(f,.13,'sine',.16),i*85)); vib([0,40,30,90]);},  // „Erfolg!" – Fisch gelandet
};
/* Haptik (Vibration) auf Touch-Geräten – an den Sound-Schalter gekoppelt */
function vib(p){ if(S.sound && navigator.vibrate){ try{ navigator.vibrate(p); }catch(e){} } }
/* Sanftes Wasser-Ambiente während des Angelns (leises, gefiltertes Rauschen) */
let ambSrc=null, ambGain=null;
function ambientStart(){ if(!S.sound) return;
  try{ actx=actx||new (window.AudioContext||window.webkitAudioContext)(); if(ambSrc) return;
    const n=Math.floor(2*actx.sampleRate), buf=actx.createBuffer(1,n,actx.sampleRate), d=buf.getChannelData(0);
    for(let i=0;i<n;i++) d[i]=Math.random()*2-1;
    const src=actx.createBufferSource(); src.buffer=buf; src.loop=true;
    const lp=actx.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=430; lp.Q.value=0.5;
    const g=actx.createGain(); g.gain.value=0.014;
    src.connect(lp); lp.connect(g); g.connect(actx.destination); src.start();
    ambSrc=src; ambGain=g;
  }catch(e){}
}
function ambientStop(){ try{ if(ambSrc){ ambSrc.stop(); ambSrc.disconnect(); } if(ambGain) ambGain.disconnect(); }catch(e){} ambSrc=null; ambGain=null; }
/* Bedrohliche „Spannungs"-Musik fürs Nachläufer-Spiel: tiefer, schwebender Drone + pochender Puls */
let susNodes=null;
function suspenseStart(){ if(!S.sound) return;
  try{ actx=actx||new (window.AudioContext||window.webkitAudioContext)(); if(susNodes) return;
    const g=actx.createGain(); g.gain.value=0.055; g.connect(actx.destination);
    const lp=actx.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=300; lp.Q.value=0.7; lp.connect(g);
    const o1=actx.createOscillator(); o1.type='sawtooth'; o1.frequency.value=55;      // tiefer Grundton
    const o2=actx.createOscillator(); o2.type='sawtooth'; o2.frequency.value=58.4;    // leichte Schwebung → unheimlich
    o1.connect(lp); o2.connect(lp);
    const lfo=actx.createOscillator(); lfo.type='sine'; lfo.frequency.value=1.9;       // pochender Puls
    const lfoG=actx.createGain(); lfoG.gain.value=0.042; lfo.connect(lfoG); lfoG.connect(g.gain);
    o1.start(); o2.start(); lfo.start();
    susNodes={o1,o2,lfo,g,lp,lfoG};
  }catch(e){}
}
function suspenseStop(){ try{ if(susNodes){ ['o1','o2','lfo'].forEach(k=>{ try{susNodes[k].stop();}catch(e){} }); Object.values(susNodes).forEach(n=>{ try{n.disconnect();}catch(e){} }); } }catch(e){} susNodes=null; }
/* Nerviges Mücken-Sirren (Event „Mückenalarm") – hohes, schwirrendes Vibrato, läuft eine Weile */
let moskNodes=null, moskTimer=null;
function mosquitoStart(ms){ if(!S.sound) return;
  try{ actx=actx||new (window.AudioContext||window.webkitAudioContext)(); if(moskNodes) return;
    const g=actx.createGain(); g.gain.value=0.0001; g.connect(actx.destination);
    g.gain.exponentialRampToValueAtTime(0.05, actx.currentTime+0.4);
    const hp=actx.createBiquadFilter(); hp.type='highpass'; hp.frequency.value=420; hp.connect(g);
    const o1=actx.createOscillator(); o1.type='sawtooth'; o1.frequency.value=600;
    const o2=actx.createOscillator(); o2.type='sawtooth'; o2.frequency.value=613;   // leicht verstimmt → noch nerviger
    o1.connect(hp); o2.connect(hp);
    const vibo=actx.createOscillator(); vibo.type='sine'; vibo.frequency.value=8.5;  // Mücken-Schwirren
    const vibG=actx.createGain(); vibG.gain.value=60; vibo.connect(vibG); vibG.connect(o1.frequency); vibG.connect(o2.frequency);
    const trem=actx.createOscillator(); trem.type='sine'; trem.frequency.value=0.55; // näher/weiter
    const tremG=actx.createGain(); tremG.gain.value=0.03; trem.connect(tremG); tremG.connect(g.gain);
    o1.start(); o2.start(); vibo.start(); trem.start();
    moskNodes={o1,o2,vibo,trem,g,hp,vibG,tremG};
    moskTimer=setTimeout(mosquitoStop, ms||30000);
  }catch(e){}
}
function mosquitoStop(){ if(moskTimer){ clearTimeout(moskTimer); moskTimer=null; }
  try{ if(moskNodes){ const nodes=moskNodes; try{ nodes.g.gain.cancelScheduledValues(actx.currentTime); nodes.g.gain.setTargetAtTime(0.0001, actx.currentTime, 0.08); }catch(e){}
    setTimeout(()=>{ ['o1','o2','vibo','trem'].forEach(k=>{ try{nodes[k].stop();}catch(e){} }); Object.values(nodes).forEach(n=>{ try{n.disconnect();}catch(e){} }); }, 250); } }catch(e){} moskNodes=null; }

/* ---------- UI Helper ---------- */
const $=s=>document.querySelector(s);
const screen=$('#screen');
function toast(m){ const t=$('#toast'); t.textContent=m; t.classList.add('show'); clearTimeout(t._t); t._t=setTimeout(()=>t.classList.remove('show'),1900); }
function syncTop(){ $('#hudMoney').textContent=S.money; $('#hudLevel').textContent=S.level; const p=$('#hudPoints'); if(p)p.textContent=S.xp; const k=$('#hudKarma'); if(k)k.textContent=(S.karma||0); $('#soundBtn').textContent=S.sound?'🔊':'🔇'; }
$('#soundBtn').onclick=()=>{ S.sound=!S.sound; save(); syncTop(); if(S.sound){ beep(660,.08); if(route==='fish') ambientStart(); } else { ambientStop(); mosquitoStop(); } };
let route='start', fishFresh=false, slipStreak=0, normalPlaySec=0, challengePrompted=false;
function go(r){ if(route==='fish'){ stopAll(); if(CH && r!=='fish') CH=null; if(TOURNEY && r!=='fish') TOURNEY=null; } if(r==='fish'&&route!=='fish') fishFresh=true; route=r; render(); }
function esc(s){ return (s||'').replace(/"/g,'&quot;'); }
function thumb(it){
  if(it.img) return `<span class="thumb"><img src="${esc(it.img)}" alt="" loading="lazy" onerror="this.parentNode.classList.add('noimg')"><span class="emoji">${it.ic}</span></span>`;
  return `<span class="ic">${it.ic}</span>`;
}
/* ---- Highscore teilen ---- */
function shareText(){
  let best='', bw=0; for(const k in S.book){ if(S.book[k].bestW>bw){ bw=S.book[k].bestW; best=SPECIES[k]?SPECIES[k].name:k; } }
  const bestStr = best? `Bester Fang: ${best} ${bw>=1?bw.toFixed(2)+' kg':Math.round(bw*1000)+' g'}. ` : '';
  return `🎣 Level ${S.level} bei „Petri – Das Angelspiel" von HechtundBarsch.de · ${S.totalCatch} Fänge! ${bestStr}Schaffst du mehr? Und erspiele dir einen Gutschein für den HechtundBarsch.de Shop! 🛒 Jetzt mitspielen: ${GAME_URL}`;
}
function challengeShareText(d){
  return `🏆 Challenge „${d.name}" gemeistert bei „Petri – Das Angelspiel" von HechtundBarsch.de! Aufgabe: ${d.goal} – geschafft (${d.diff}, ${d.mins} Min)! 🎣 Schaffst du das auch? Spiel mit & erspiel dir einen Gutschein für den Shop: ${GAME_URL}`;
}
function copyShare(t){ t=t||shareText();
  if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(t).then(()=>toast('📋 Spruch kopiert – einfügen & posten!')).catch(()=>toast('Kopieren nicht möglich')); }
  else toast('Kopieren nicht möglich'); }
function shareNative(t){ t=t||shareText();
  if(navigator.share){ navigator.share({title:'Petri – Das Angelspiel', text:t, url:GAME_URL}).catch(()=>{}); } else copyShare(t); }
function openShare(net,t){
  const u=encodeURIComponent(GAME_URL); t=encodeURIComponent(t||shareText());
  if(net==='whatsapp') window.open('https://wa.me/?text='+t,'_blank','noopener');
  else if(net==='facebook') window.open('https://www.facebook.com/sharer/sharer.php?u='+u+'&quote='+t,'_blank','noopener');
  else if(net==='instagram'){ copyShare(decodeURIComponent(t)); window.open('https://www.instagram.com/','_blank','noopener'); }
  else if(net==='tiktok'){ copyShare(decodeURIComponent(t)); window.open('https://www.tiktok.com/','_blank','noopener'); }
}
/* Wiederverwendbare Share-Button-Reihe (Highscore & Challenge-Erfolg) */
function shareRowHTML(){ return `
      <button class="btn full" data-sh="native" style="margin-bottom:8px">📤 Teilen / posten</button>
      <div class="btnrow" style="margin-top:0;flex-wrap:wrap">
        <button class="btn ghost" style="flex:1;min-width:46%" data-sh="whatsapp">💬 WhatsApp</button>
        <button class="btn ghost" style="flex:1;min-width:46%" data-sh="facebook">📘 Facebook</button>
        <button class="btn ghost" style="flex:1;min-width:46%" data-sh="instagram">📸 Instagram</button>
        <button class="btn ghost" style="flex:1;min-width:46%" data-sh="tiktok">🎵 TikTok</button>
      </div>
      <div class="footnote" style="margin-top:8px">Bei Instagram & TikTok wird dein Spruch in die Zwischenablage kopiert – einfach in Story/Caption einfügen.</div>`; }
function wireShare(scope, textFn){
  const f=textFn||shareText;
  scope.querySelectorAll('[data-sh]').forEach(b=>{ const k=b.dataset.sh;
    b.onclick=()=> k==='native'? shareNative(f()) : openShare(k, f()); });
}

function render(){
  syncTop();
  { const vf=$('#verfoot'); if(vf) vf.style.display=(route==='start')?'':'none'; }   // Versionszeile nur auf der Startseite
  { const ap=$('#app'); if(ap) ap.classList.toggle('fishing', route==='fish'); }     // beim Angeln: Spielname aus, Statusleiste kompakt
  if(route==='start') return renderStart();
  if(route==='water') return renderWater();
  if(route==='gear')  return renderGear();
  if(route==='shop')  return renderShop();
  if(route==='book')  return renderBook();
  if(route==='challenges') return renderChallenges();
  if(route==='badges') return renderBadges();
  if(route==='loadouts') return renderLoadouts();
  if(route==='tourneys') return renderTourneys();
  if(route==='fish')  return renderFishing();
}

function renderStart(){
  ensureDaily(); checkBadges();
  const caught=Object.keys(S.book).length, total=Object.keys(SPECIES).length;
  screen.innerHTML=`
    <div class="start-hero">
      <div class="big">🎣🐟</div>
      <h1>Petri – Das Angelspiel</h1>
      <p>von HechtundBarsch.de</p>
      <div class="feat">
        <span class="tag good">🐟 6 Zielfische</span>
        <span class="tag good">🎯 Wurf-Minispiel</span>
        <span class="tag good">🎣 Echte Köder & Ruten</span>
        <span class="tag good">🌅 Tag/Nacht & Wetter</span>
      </div>
    </div>
    <div class="card">
      <div class="statline">
        <div><div class="v">${S.level}</div><div class="l">Level</div></div>
        <div><div class="v">${S.totalCatch}</div><div class="l">Fänge</div></div>
        <div><div class="v">${caught}/${total}</div><div class="l">Arten</div></div>
      </div>
      <div style="margin:4px 2px 6px;font-weight:800;font-size:13px;color:var(--muted)">🎚️ Schwierigkeit</div>
      <div class="condrow" style="margin-bottom:6px">${diffPicker()}</div>
      <div class="sub" style="margin:6px 2px 12px">${DIFFICULTY[S.difficulty].desc}</div>
      <button class="btn full gold" id="goPlay">▶  Losangeln</button>
      <div class="btnrow">
        <button class="btn ghost" style="flex:1" id="goShop">🛒 Angelladen</button>
        <button class="btn ghost" style="flex:1" id="goBook">📖 Fangbuch</button>
      </div>
      <div class="btnrow">
        <button class="btn ghost" style="flex:1" id="goChal">🏆 Challenges</button>
        <button class="btn ghost" style="flex:1" id="goBadges">🏅 Erfolge</button>
      </div>
      <div class="btnrow">
        <button class="btn ghost" style="flex:1" id="goTourneys">🏁 Turniere</button>
        <button class="btn ghost" style="flex:1" id="goLoadouts">🎯 Profi-Setups</button>
      </div>
      <div class="btnrow">
        <button class="btn ghost" style="flex:1" id="goTips">💡 Tipps & Hilfe</button>
      </div>
    </div>
    ${dailyCardHTML()}
    ${hookStatCard()}
    ${S.couponEarned?`<div class="card" style="margin-top:10px;border-color:var(--gold)">
      <b>🏆 Dein Gutschein</b>
      <div class="sub" style="margin:6px 0">5% auf alle LMAB-Köder im echten Shop mit Code <b style="color:var(--gold);letter-spacing:1px">${COUPON_CODE}</b> – für 10.000 Punkte auf mind. „Normal". Die Fische gönnen’s dir.</div>
      <a class="btn full gold" href="${COUPON_URL}" target="_blank" rel="noopener" style="text-decoration:none">🛒 Im Shop einlösen ↗</a>
    </div>`:''}
    ${S.biglCoupon?`<div class="card" style="margin-top:10px;border-color:var(--gold)">
      <b>🤘 Big L's Gutschein</b>
      <div class="sub" style="margin:6px 0">5% auf alle Monkey-Lures & Big-L Produkte mit Code <b style="color:var(--gold);letter-spacing:1px">${BIGL_CODE}</b> – verdient durch Big Ls Respekt.</div>
      <a class="btn full gold" href="${BIGL_URL}" target="_blank" rel="noopener" style="text-decoration:none">🛒 Im Shop einlösen ↗</a>
    </div>`:''}
    ${activeGuide()?`<div class="card" style="margin-top:10px;border-color:var(--gold)">
      <b>🎣 Guide aktiv: ${activeGuide().name}</b>
      <div class="sub" style="margin:4px 0">Noch ${guideRemaining()} · ${guideTargetName(activeGuide())} · ${activeGuide().spot}. Nichts wie raus ans Wasser!</div></div>`:''}
    <div class="card" style="margin-top:10px">
      <b>✉️ Newsletter & 15% Rabatt</b>
      <div class="sub" style="margin:6px 0">Sichere dir <b style="color:var(--gold)">15% auf Angelköder</b> – einfach den HechtundBarsch-Newsletter abonnieren. (Petri Dank inklusive.)</div>
      <a class="btn full gold" href="${NEWSLETTER_URL}" target="_blank" rel="noopener" style="text-decoration:none;background:#ffb71b;color:#3a2a00">✉️ Newsletter abonnieren ↗</a>
    </div>
    <div class="card" style="margin-top:10px">
      <b>📤 Highscore teilen</b>
      <div class="sub" style="margin:6px 0">Fordere deine Angelkumpels heraus: Level ${S.level}, ${S.totalCatch} Fänge. Mal sehen, wer mehr Fische ärgert.</div>
      ${shareRowHTML()}
    </div>
    <div class="footnote">Köder, Gewässer, Tageszeit, Wetter & dein Wurf entscheiden, was beißt.<br>
      Ausrüstung mit echten Produkten von <a href="https://www.hechtundbarsch.de" target="_blank" rel="noopener">HechtundBarsch.de</a> · Spielstand wird lokal gespeichert.<br>
      Frage, Anregung & Feedback an <a href="mailto:kevin@hechtundbarsch.de">kevin@hechtundbarsch.de</a></div>`;
  $('#goPlay').onclick=()=>go('water');
  $('#goShop').onclick=()=>go('shop');
  $('#goBook').onclick=()=>go('book');
  $('#goTips').onclick=showTips;
  $('#goChal').onclick=()=>go('challenges');
  $('#goBadges').onclick=()=>go('badges');
  $('#goLoadouts').onclick=()=>go('loadouts');
  $('#goTourneys').onclick=()=>go('tourneys');
  { const cd=$('#claimDaily'); if(cd) cd.onclick=claimDaily; }
  screen.querySelectorAll('[data-diff]').forEach(el=>el.onclick=()=>{S.difficulty=el.dataset.diff;save();renderStart();});
  wireShare(screen);
}

function backBtn(){ return `<button class="btn ghost js-back">← Zurück</button><button class="btn ghost js-home">🏠 Home</button>`; }
function topBack(){ return `<button class="btn ghost js-back" style="padding:8px 14px;font-size:14px;margin:4px 2px 2px">← Zurück</button>`; }
function wireBack(to){ screen.querySelectorAll('.js-back').forEach(b=>b.onclick=()=>go(to)); screen.querySelectorAll('.js-home').forEach(b=>b.onclick=()=>go('start')); }

function renderWater(){
  let html=topBack()+`<h2>🏞️ Gewässer wählen</h2><p class="sub">Jedes Gewässer hat eigene Fischarten und Bestände.</p><div class="grid">`;
  for(const [k,w] of Object.entries(WATERS)){
    const locked=S.level<w.unlock, sel=S.water===k?'sel':'';
    const total=Object.values(w.pop).reduce((a,b)=>a+b,0);
    const popHtml=Object.entries(w.pop).sort((a,b)=>b[1]-a[1]).map(([sp,v])=>{
      const s=SPECIES[sp], pct=Math.round(v/total*100);
      return `<div class="barrow"><b>${fishIcon(sp,16)} ${s.name}</b><div class="meter"><i style="width:${pct}%"></i></div><span>${pct}%</span></div>`;
    }).join('');
    html+=`<div class="pick ${sel}" data-w="${k}">
        <div class="ttl"><span class="ic">${w.ic}</span> ${w.name}</div>
        <div class="meta">${w.desc}</div><div class="bars">${popHtml}</div>
        ${locked?`<div class="lock">🔒<div>Ab Level ${w.unlock} freigeschaltet</div></div>`:''}
      </div>`;
  }
  html+=`</div><div class="btnrow">${backBtn()}<button class="btn gold" style="flex:2" id="next">Weiter zur Ausrüstung →</button></div>`;
  screen.innerHTML=html;
  screen.querySelectorAll('.pick').forEach(el=>el.onclick=()=>{ const k=el.dataset.w;
    if(S.level<WATERS[k].unlock){toast('🔒 Erst ab Level '+WATERS[k].unlock);return;} S.water=k; save(); renderWater(); });
  wireBack('start'); $('#next').onclick=()=>go('gear');
}

function meterRow(label,val,max){ const pct=Math.max(6,Math.min(100,Math.round(val/max*100)));
  return `<div class="barrow"><b>${label}</b><div class="meter"><i style="width:${pct}%"></i></div></div>`; }

function gearPickHTML(catKey,items,ownArr,sel,statRows){
  let h='';
  for(const [k,it] of Object.entries(items)){
    const owned=ownArr.includes(k), isSel=sel===k?'sel':'';
    h+=`<div class="pick ${isSel}" data-cat="${catKey}" data-k="${k}">
        <div class="ttl">${thumb(it)} <span>${it.name}${catKey==='lure'?lureTypeTag(k):''} ${isSel?'✅':''}</span></div>
        ${it.brand?`<div class="brandline">${it.brand}${it.hb?' · H&B Edition':''}</div>`:''}
        <div class="meta">${it.desc}</div><div class="bars">${statRows(it)}</div>
        ${owned?'':`<div class="lock">🔒<div>Im Angelladen kaufen<br><span class="price">${priceLbl(it.price)}</span></div></div>`}
      </div>`;
  }
  return h;
}
function diffPicker(){
  return Object.entries(DIFFICULTY).map(([k,v])=>`<div class="condchip ${S.difficulty===k?'sel':''}" data-diff="${k}"><span class="ce">${v.ic}</span>${v.name}</div>`).join('');
}
function condPicker(){
  const t=Object.entries(TIMES).map(([k,v])=>`<div class="condchip ${S.time===k?'sel':''}" data-time="${k}"><span class="ce">${v.ic}</span>${v.name}</div>`).join('');
  const se=Object.entries(SEASONS).map(([k,v])=>`<div class="condchip ${S.season===k?'sel':''}" data-season="${k}"><span class="ce">${v.ic}</span>${v.name}</div>`).join('');
  const w=Object.entries(WEATHER).map(([k,v])=>`<div class="condchip ${S.weather===k?'sel':''}" data-weather="${k}"><span class="ce">${v.ic}</span>${v.name}</div>`).join('');
  return `<h2>🌅 Tageszeit</h2><div class="condrow">${t}</div>
          <h2>📅 Jahreszeit</h2><div class="condrow">${se}</div>
          <h2>🌦️ Wetter</h2><div class="condrow">${w}</div>`;
}
function colorPicker(){
  return Object.entries(COLORS).map(([k,v])=>`<div class="condchip ${S.color===k?'sel':''}" data-color="${k}"><span class="ce">${v.ic}</span>${v.name}</div>`).join('');
}
function rigPicker(){
  return Object.entries(RIGS).map(([k,v])=>{
    const ok=rigOK(k,S.lure);
    return `<div class="pick ${S.rig===k?'sel':''} ${ok?'':'rigbad'}" data-rig="${k}">
      <div class="ttl"><span class="ic">${v.ic}</span> ${v.name} ${S.rig===k?'✅':(ok?'':'🚫')}</div>
      <div class="meta">${ok?v.desc:'🚫 Passt nicht zu '+LURES[S.lure].name+' ('+typeLabel(LURETYPE[S.lure])+').'}</div></div>`;
  }).join('');
}
function renderGear(){
  const w=WATERS[S.water], lure=LURES[S.lure];
  let h=topBack()+`<h2>🎒 Ausrüstung</h2><p class="sub">Gewässer: <b>${w.ic} ${w.name}</b>. Köder, Gerät, Tageszeit & Wetter beeinflussen den Fang!</p>`;
  h+=`<h2>🎚️ Schwierigkeit</h2><div class="condrow">${diffPicker()}</div><p class="sub" style="margin:6px 4px 0">${DIFFICULTY[S.difficulty].desc}</p>`;
  h+=condPicker();
  h+=`<h2>🎣 Köder</h2><div class="grid">`+gearPickHTML('lure',LURES,S.ownLures,S.lure,it=>{
    const top=Object.entries(it.aff).sort((a,b)=>b[1]-a[1]).slice(0,3).map(([sp,v])=>`<span class="tag ${v>=1.2?'good':''}">${fishIcon(sp,14)} ${SPECIES[sp].name}</span>`).join('');
    const act=(it.action??0.4); const al=act>=0.75?'⚡ viel Aktion':act>=0.45?'〰️ mittlere Aktion':'· dezent/Finesse';
    return `<div class="tagrow">${top}<span class="tag">${al}</span></div>`; })+`</div>`;
  h+=`<h2>🎨 Köderfarbe</h2><div class="condrow">${colorPicker()}</div>`;
  h+=`<h2>🪝 Montage</h2><p class="sub" style="margin:2px 4px 8px">Wirkt je nach Gewässer, Jahreszeit, Wetter & Köderart.</p><div class="grid cols2">${rigPicker()}</div>`;
  h+=`<h2>🪄 Rute</h2><div class="grid cols2">`+gearPickHTML('rod',RODS,S.ownRods,S.rod,it=>meterRow('Kontrolle',it.zone,0.5)+meterRow('Power',it.power,5.2))+`</div>`;
  h+=`<h2>⚙️ Rolle</h2><div class="grid cols2">`+gearPickHTML('reel',REELS,S.ownReels,S.reel,it=>meterRow('Speed',it.speed,1.7))+`</div>`;
  h+=`<h2>🥅 Kescher</h2><div class="grid cols2">`+gearPickHTML('net',NETS,S.ownNets,S.net,it=>meterRow('Landung',it.buffer,1.8))+`</div>`;
  // Angelplatz: Ufer vs. Boot
  if(S.level>=BOAT_LEVEL){
    h+=`<h2>🚣 Angelplatz</h2><div class="condrow">
      <div class="condchip ${!S.fromBoat?'sel':''}" data-boatmode="ufer"><span class="ce">🏞️</span>Vom Ufer</div>
      <div class="condchip ${S.fromBoat?'sel':''}" data-boatmode="boot"><span class="ce">🚣</span>Vom Boot</div></div>`;
    h+= S.boats.length
      ? `<div class="condrow" style="margin-top:6px">`+S.boats.map(k=>`<div class="condchip ${S.boat===k?'sel':''}" data-boat="${k}"><span class="ce">${BOATS[k].ic}</span>${BOATS[k].name}</div>`).join('')+`</div>`
      : `<p class="sub" style="margin:6px 4px">Noch kein Boot – im Angelladen (Tab „Boote") kaufen. Vom Boot beißt es deutlich besser, versprochen.</p>`;
  } else {
    h+=`<h2>🚣 Angelplatz</h2><p class="sub" style="margin:2px 4px">🔒 „Vom Boot angeln" ab Level ${BOAT_LEVEL} – dann kommst du an die wirklich fetten Fische (und sie nicht mehr ans Ufer).</p>`;
  }
  h+=`<div class="card" style="margin-top:14px"><b>🔮 Beiß-Vorschau</b>
       <div class="sub" style="margin:6px 0 2px">${LURES[S.lure].ic} ${lure.name} · ${COLORS[S.color].ic} ${COLORS[S.color].name} · ${RIGS[S.rig].ic} ${RIGS[S.rig].name}</div>
       <div class="sub" style="margin:0 0 6px">${SEASONS[S.season].ic} ${SEASONS[S.season].name} · ${TIMES[S.time].ic} ${TIMES[S.time].name} · ${WEATHER[S.weather].ic} ${WEATHER[S.weather].name} · 💧 Wasser: <b>${clarityLabel()}</b></div>
       <div class="bars">${bitePreview()}</div></div>`;
  h+=`<div class="btnrow">${backBtn()}<button class="btn gold" style="flex:2" id="start">🎣 Angeln starten</button></div>`;
  screen.innerHTML=h;
  screen.querySelectorAll('[data-diff]').forEach(el=>el.onclick=()=>{S.difficulty=el.dataset.diff;save();renderGear();});
  screen.querySelectorAll('[data-time]').forEach(el=>el.onclick=()=>{S.time=el.dataset.time;save();renderGear();});
  screen.querySelectorAll('[data-season]').forEach(el=>el.onclick=()=>{S.season=el.dataset.season;save();renderGear();});
  screen.querySelectorAll('[data-weather]').forEach(el=>el.onclick=()=>{S.weather=el.dataset.weather;save();renderGear();});
  screen.querySelectorAll('[data-color]').forEach(el=>el.onclick=()=>{S.color=el.dataset.color;save();renderGear();});
  screen.querySelectorAll('.pick').forEach(el=>el.onclick=()=>{
    const cat=el.dataset.cat,k=el.dataset.k; if(!cat) return;   // Rig-Picks (data-rig) überspringen
    const ownMap={lure:S.ownLures,rod:S.ownRods,reel:S.ownReels,net:S.ownNets};
    if(!ownMap[cat].includes(k)){ toast('🔒 Erst im Angelladen kaufen'); return; }
    if(cat==='lure'){ S.lure=k; if(!rigOK(S.rig,S.lure)){ S.rig=defaultRigFor(S.lure); toast('🪢 Montage automatisch auf '+RIGS[S.rig].name+' umgestellt – passt zu '+LURES[S.lure].name+'.'); } }
    if(cat==='rod')S.rod=k; if(cat==='reel')S.reel=k; if(cat==='net'){ S.net=k; S.netBroken=false; } save(); renderGear();
  });
  screen.querySelectorAll('[data-rig]').forEach(el=>el.onclick=()=>{ const rk=el.dataset.rig;
    if(!rigOK(rk,S.lure)){ toast('🚫 '+typeLabel(LURETYPE[S.lure])+' lässt sich nicht als '+RIGS[rk].name+' fischen.'); return; }
    S.rig=rk; save(); renderGear(); });
  screen.querySelectorAll('[data-boatmode]').forEach(el=>el.onclick=()=>{ const m=el.dataset.boatmode;
    if(m==='boot'){ if(!S.boats.length){ toast('🚣 Erst ein Boot im Angelladen kaufen'); return; } if(!S.boat)S.boat=S.boats[0]; S.fromBoat=true; } else S.fromBoat=false;
    save(); renderGear(); });
  screen.querySelectorAll('[data-boat]').forEach(el=>el.onclick=()=>{ S.boat=el.dataset.boat; S.fromBoat=true; save(); renderGear(); });
  wireBack('water'); $('#start').onclick=()=>go('fish');
}

// Wasserklarheit & Licht
function clarityVal(){
  let c = WATERCLARITY[S.water] ?? 0.6;
  c += (S.weather==='sonnig'?0.10 : S.weather==='regen'?-0.25 : 0);
  c += SEASONS[S.season].clarity;
  return Math.max(0,Math.min(1,c));
}
function clarityLabel(){ const c=clarityVal(); return c>0.7?'klar':c>0.45?'leicht trüb':'trüb'; }
function lightVal(){ // 0 dunkel .. 1 hell
  let b = S.time==='nacht'?0.06 : (S.time==='morgen'||S.time==='abend')?0.45 : 1;
  if(S.weather==='bewoelkt') b*=0.7; if(S.weather==='regen') b*=0.55;
  return b;
}
// Köderfarbe: globaler Reiz-Multiplikator
function colorMult(){
  const c=clarityVal();
  if(S.color==='naturell') return 0.65 + c*0.70;   // klar gut, trüb schlecht
  if(S.color==='grell')    return 1.35 - c*0.70;   // trüb gut, klar schlecht
  return 0.85 + (1-lightVal())*0.55;               // UV/Glow: wenig Licht = gut
}
// Köder-Aktion (Angler-Mythos): viel Aktion → Hecht; Finesse → Barsch/Zander
function actionMult(sp,lure){
  const a=lure.action??0.4;
  if(sp==='hecht')  return 0.55 + a*0.95;
  if(sp==='rapfen') return 0.70 + a*0.55;
  if(sp==='barsch'||sp==='zander') return 1.20 - a*0.35;
  if(sp==='wels')   return 1.10 - a*0.20;
  return 1; // Black Bass: ausgewogen
}
// Montagen-Passung zur Köderart
function rigKindMatch(rig,lure){
  const k=lure.kind;
  if(rig==='direkt')  return k==='hard'?1.10 : 0.80;
  if(rig==='grund')   return k==='natur'?1.15 : k==='soft'?1.00 : 0.65;
  if(rig==='jigkopf') return k==='soft'?1.05 : k==='natur'?0.90 : 0.90;
  return k==='soft'?1.05 : k==='natur'?0.85 : 0.70;   // dropshot/texas/carolina
}
// Montage: situativer Multiplikator je Fisch
function rigMult(sp){
  const r=S.rig, water=S.water, se=S.season, clar=clarityVal(), lure=LURES[S.lure];
  if(!rigOK(r,S.lure)) return 0;   // unmögliche Köder/Montage-Kombi → kein Biss (Sicherheitsnetz)
  const current = (water==='fluss'||water==='grossstrom');
  const deep      = (water==='baggersee'||water==='kanal'||water==='talsperre');
  const structure = (water==='vereinssee'||water==='baggersee');
  let m=1;
  if(r==='jigkopf'){ if(sp==='zander')m*=1.10; if(sp==='barsch')m*=1.05; }
  else if(r==='dropshot'){
    m *= (sp==='barsch'||sp==='zander')?1.35 : sp==='blackbass'?1.20 : 0.65;
    if(clar>0.70) m*=1.15; if(se==='winter'||se==='fruehling') m*=1.15;
    if(deep) m*=1.10; if(current) m*=0.70;
  } else if(r==='texas'){
    m *= sp==='blackbass'?1.50 : sp==='hecht'?1.20 : 0.90;
    if(structure) m*=1.20; if(se==='sommer') m*=1.20; if(current) m*=0.85;
  } else if(r==='carolina'){
    m *= (sp==='zander'||sp==='wels')?1.30 : sp==='barsch'?1.15 : 0.90;
    m *= current?1.25:0.95; if(se==='fruehling'||se==='herbst') m*=1.15;
  } else if(r==='grund'){
    m *= sp==='wels'?1.80 : sp==='zander'?1.15 : 0.50;
    if(S.time==='nacht') m*=1.20;
  } else if(r==='direkt'){
    m *= (sp==='hecht'||sp==='rapfen')?1.15 : 1.0;
  }
  return m;
}
function biteWeights(){
  const w=WATERS[S.water], lure=LURES[S.lure];
  const tm=TIMES[S.time].mult, wm=WEATHER[S.weather].mult, sm=SEASONS[S.season].mult, cm=colorMult();
  const bm=(S.fromBoat&&S.boat&&BOATS[S.boat])?BOATS[S.boat].biteMul:1;   // Boot = deutlich besserer Fangerfolg
  const g=activeGuide();   // gebuchter Guide pusht seinen Zielfisch massiv
  const spm=spotMult();   // gewählter Wurfplatz (Ufer/Kante/Freiwasser) beeinflusst die Arten
  const out={}; let sum=0;
  for(const [sp,pop] of Object.entries(w.pop)){
    const a=(sp in lure.aff)? lure.aff[sp] : (SPECIES[sp].sea? seaAff(LURETYPE[S.lure]) : 0);
    if(a<=0){ out[sp]=0; continue; }
    const gm=g?(g.all?g.biteMul:(g.sp===sp?g.biteMul:1)):1;
    const weight = pop*a*(tm[sp]??1)*(wm[sp]??1)*(sm[sp]??1)*actionMult(sp,lure)*rigMult(sp)*cm*bm*gm*(spm[sp]??1);
    out[sp]=weight; sum+=weight;
  }
  return {out,sum};
}
/* Wurfplatz: Landeposition (bottom%) → Ufer/Schilf, Kante/Tiefe oder Freiwasser */
function spotMult(){
  if(!game||game.castBottom==null) return {};
  const b=game.castBottom;
  if(b<=30) return {hecht:1.5,barsch:1.4,blackbass:1.25,zander:0.85,rapfen:0.8,wels:0.7};   // Ufer/Schilf
  if(b<=45) return {zander:1.5,wels:1.35,barsch:1.1,hecht:1.1,rapfen:0.9,blackbass:0.9};     // Kante/Tiefe
  return {rapfen:1.6,blackbass:1.4,barsch:1.2,zander:0.9,hecht:0.9,wels:0.95};                // Freiwasser
}
function spotName(b){ return b<=30?'🌾 Ufer/Schilf':b<=45?'⬇️ Kante/Tiefe':'🌊 Freiwasser'; }
/* Pro Zone: erwartete Beißmenge & Durchschnittsgröße (für die Fischschatten-Hinweise & passend zur Fang-Logik) */
function spotStats(b){
  if(!game) return {ab:0,big:0};
  const prev=game.castBottom; game.castBottom=b;
  const {out,sum}=biteWeights(); game.castBottom=prev;
  let big=0; for(const sp in out){ if(out[sp]>0) big+=out[sp]*SPECIES[sp].trophy; }
  big = sum>0? big/sum : 0;
  const farB=Math.max(0,Math.min(1,(b-30)/26)); big*=(1+farB*0.35);   // weiter draußen → tendenziell größere Fische
  return {ab:sum, big};
}
function hideCastShadows(){ const c=$('#castshadows'); if(c){ c.style.display='none'; c.innerHTML=''; } }
const CSH_FISH='<svg viewBox="0 0 100 42" preserveAspectRatio="none"><path d="M8 21 C24 5 60 5 73 15 L96 4 L88 21 L96 38 L73 27 C60 37 24 37 8 21 Z" fill="rgba(3,12,18,.62)"/></svg>';
function renderCastShadows(){
  const c=$('#castshadows'); if(!c) return;
  const bands=[{b:25,bottom:26},{b:39,bottom:39},{b:52,bottom:51}];   // Ufer / Kante / Freiwasser
  const stats=bands.map(z=>spotStats(z.b));
  const maxAb=Math.max(1e-6,...stats.map(s=>s.ab));
  let html='';
  bands.forEach((z,i)=>{
    const s=stats[i]; if(s.ab<=0) return;
    const farT=Math.max(0,Math.min(1,(z.b-25)/27));                   // 0 = Ufer … 1 = Freiwasser (weit draußen)
    const count=2+Math.round((s.ab/maxAb)*3);                          // mehr Schatten = mehr Fisch (Beißmenge)
    const w=Math.round(24+farT*32);                                    // weiter draußen = größere Fische (bessere Spots)
    for(let k=0;k<count;k++){
      const left=6+Math.random()*82, by=(z.bottom+(Math.random()*5-2.5)).toFixed(1), dur=(10+Math.random()*8).toFixed(1);
      const rightward=(k%2===0), cls=rightward?'swimL':'swimR', flip=rightward?';transform:scaleX(-1)':'';
      html+='<div class="csh '+cls+'" style="--d:'+dur+'s;width:'+w+'px;height:'+Math.round(w*0.42)+'px;left:'+left+'%;bottom:'+by+'%;animation-delay:'+(-Math.random()*dur).toFixed(1)+'s'+flip+'">'+CSH_FISH+'</div>';
    }
  });
  c.innerHTML=html; c.style.display='block';
}
/* Meeresfische beißen auf die meisten Kunstköder (Pilker-Logik) – Fallback-Affinität nach Ködertyp */
function seaAff(t){ return ({hard:1.1,blade:1.2,soft:1.05,natur:0.5})[t]||0.4; }
function bitePreview(){
  const {out,sum}=biteWeights();
  if(sum<=0) return `<div class="barrow"><b>—</b><div class="meter"><i style="width:0"></i></div><span>Kein passender Köder! Hier beißt nichts.</span></div>`;
  return Object.entries(out).filter(([,v])=>v>0).sort((a,b)=>b[1]-a[1]).map(([sp,v])=>{
    const pct=Math.round(v/sum*100);
    return `<div class="barrow"><b>${fishIcon(sp,16)} ${SPECIES[sp].name}</b><div class="meter"><i style="width:${pct}%"></i></div><span>${pct}%</span></div>`;
  }).join('');
}

/* ---------- Shop ---------- */
let shopTab='lure';
function renderShop(){
  let h=`<h2>🛒 Angelladen</h2><p class="sub">Echte Produkte von HechtundBarsch.de. Besseres Gerät = größere & seltenere Fische landbar.</p>`;
  if(shopDiscActive()) h+=`<div class="card" style="border-color:var(--gold);margin:4px 0 8px;text-align:center"><b>🏷️ Micha-Rabatt aktiv: −20%</b> · noch ${Math.ceil((S.shopDiscUntil-Date.now())/1000)} s</div>`;
  h+=`<div class="tabbar">
    <button data-t="lure" class="${shopTab==='lure'?'on':''}">Köder</button>
    <button data-t="rod"  class="${shopTab==='rod'?'on':''}">Ruten</button>
    <button data-t="reel" class="${shopTab==='reel'?'on':''}">Rollen</button>
    <button data-t="net"  class="${shopTab==='net'?'on':''}">Kescher</button>
    <button data-t="boat" class="${shopTab==='boat'?'on':''}">Boote</button>
    <button data-t="gear" class="${shopTab==='gear'?'on':''}">Zubehör</button>
    <button data-t="guide" class="${shopTab==='guide'?'on':''}">Guides</button></div>`;
  if(shopTab==='guide'){
    const ag=activeGuide();
    h+=`<p class="sub" style="margin:6px 4px">Buche einen Profi für einen „Tag" (3 Min. Echtzeit). Er bringt dich an seinen Hotspot – und liefert kapitale Zielfische.</p>`;
    if(ag) h+=`<div class="card" style="border-color:var(--gold);margin-bottom:10px"><b>🎣 Aktiv: ${ag.name}</b><div class="sub" style="margin:4px 0">Noch ${guideRemaining()} · ${guideTargetName(ag)} läuft heiß!</div></div>`;
    h+=`<div class="grid">`;
    for(const [k,g] of Object.entries(GUIDES)){
      h+=`<div class="pick" style="cursor:default">
        <div class="ttl">${guideIcon(g,22)} <span>${g.name}</span></div>
        <div class="brandline">${g.spot} · ${guideTargetName(g)}${g.all?' · Allrounder':(g.boat?' · 🚣 Boot':' · 🏞️ Ufer')}</div>
        <div class="meta">${g.desc}</div>
        <div style="margin-top:10px">${ag?`<span class="owned">⏳ Guide aktiv…</span>`:`<button class="btn gold" data-guide="${k}" style="padding:9px 14px;font-size:14px">Buchen · ${priceLbl(g.price)}</button>`}</div>
      </div>`;
    }
    h+=`</div><div class="btnrow">${backBtn()}</div>`;
    screen.innerHTML=h;
    screen.querySelectorAll('.tabbar button').forEach(b=>b.onclick=()=>{shopTab=b.dataset.t;renderShop();});
    screen.querySelectorAll('[data-guide]').forEach(b=>b.onclick=()=>bookGuide(b.dataset.guide));
    wireBack('start');
    return;
  }
  const map={lure:[LURES,S.ownLures],rod:[RODS,S.ownRods],reel:[REELS,S.ownReels],net:[NETS,S.ownNets],boat:[BOATS,S.boats],gear:[SHOPGEAR,S.ownGear]};
  const [items,own]=map[shopTab];
  h+=`<div class="grid cols2">`;
  for(const [k,it] of Object.entries(items)){
    if(it.excl) continue;   // exklusive Köder (z. B. Max's Prototyp) gibt's nicht im Shop
    const owned=own.includes(k); let stats='';
    if(shopTab==='lure'){ stats=Object.entries(it.aff).sort((a,b)=>b[1]-a[1]).slice(0,3).map(([sp,v])=>`<span class="tag ${v>=1.2?'good':''}">${fishIcon(sp,14)} ${SPECIES[sp].name}</span>`).join(''); stats=`<div class="tagrow">${stats}</div>`; }
    else if(shopTab==='rod') stats=meterRow('Kontrolle',it.zone,0.5)+meterRow('Power',it.power,5.2);
    else if(shopTab==='reel') stats=meterRow('Speed',it.speed,1.7);
    else if(shopTab==='net') stats=meterRow('Landung',it.buffer,1.8);
    else if(shopTab==='boat') stats=meterRow('Fangbonus',it.biteMul,1.8)+meterRow('Größe',1+it.sizeMul,1.4);
    else stats='';
    h+=`<div class="pick" style="cursor:default">
      ${it.img?`<img class="shopimg" src="${esc(it.img)}" alt="" loading="lazy" onerror="this.style.display='none'">`:''}
      <div class="ttl">${it.img?'':`<span class="ic">${it.ic}</span>`}<span>${it.name}${shopTab==='lure'?lureTypeTag(k):''}</span></div>
      ${it.brand?`<div class="brandline">${it.brand}${it.hb?' · H&B Edition':''}</div>`:''}
      <div class="meta">${it.desc}</div><div class="bars">${stats}</div>
      ${it.realPrice?`<div class="realprice">Shop-Preis: <b>${it.realPrice}</b></div>`:''}
      ${it.handle?`<a class="shoplink" href="${SHOP}${it.handle}" target="_blank" rel="noopener">🛒 Im Shop ansehen ↗</a>`:''}
      <div style="margin-top:10px">${owned?`<span class="owned">✅ Im Besitz</span>`:`<button class="btn gold" data-buy="${k}" style="padding:9px 14px;font-size:14px">Kaufen · ${priceLbl(it.price)}</button>`}</div>
    </div>`;
  }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h;
  screen.querySelectorAll('.tabbar button').forEach(b=>b.onclick=()=>{shopTab=b.dataset.t;renderShop();});
  screen.querySelectorAll('[data-buy]').forEach(b=>b.onclick=()=>buy(shopTab,b.dataset.buy));
  wireBack('start');
}
/* Micha-Rabatt: 20% auf alle Angelladen-Preise, solange aktiv */
function shopDiscActive(){ return (S.shopDiscUntil||0) > Date.now(); }
function shopPrice(p){ return shopDiscActive() ? Math.round(p*0.8) : p; }
function priceLbl(p){ return shopDiscActive() ? ('<s style="opacity:.55">'+p+'</s> '+shopPrice(p)+' 💶 🏷️') : (p+' 💶'); }
function buy(cat,k){
  const map={lure:[LURES,S.ownLures],rod:[RODS,S.ownRods],reel:[REELS,S.ownReels],net:[NETS,S.ownNets],boat:[BOATS,S.boats],gear:[SHOPGEAR,S.ownGear]};
  const [items,own]=map[cat], it=items[k];
  if(own.includes(k)) return;
  const price=shopPrice(it.price);
  if(S.money<price){ toast('💶 Nicht genug Münzen – fang erst mehr Fische!'); return; }
  S.money-=price; own.push(k); if(cat==='boat'&&!S.boat) S.boat=k;
  if(cat==='net'){ S.net=k; S.netBroken=false; }   // neuer Kescher ersetzt einen beschädigten und wird direkt angelegt
  if(k==='haken'){ S.bluntHooks=false; }            // frische scharfe Haken → stumpfe Haken ersetzt
  sfx.buy(); save(); syncTop();
  toast(cat==='boat'?'⚓ '+it.name+' gekauft – ab auf’s Wasser!':(cat==='net'?'✅ '+it.name+' gekauft & angelegt':'✅ '+it.name+' gekauft')); renderShop();
}

/* ---- Angelguides ---- */
function activeGuide(){ return (S.guideKey && S.guideUntil && Date.now()<S.guideUntil) ? GUIDES[S.guideKey] : null; }
function guideTargetName(g){ return g.all?'alle Arten':SPECIES[g.sp].name; }
function guideIcon(g,px){ return g.all? '<span style="font-size:'+Math.round(px*0.85)+'px;line-height:1">🎣</span>' : fishIcon(g.sp,px); }
function startGuideSession(){ S.guideCatch={n:0,kg:0,bigW:0,bigSp:null,bySp:{}}; }
/* Verabschiedung eines Guides nach Ablauf der Zeit – mit Fang-Zusammenfassung + Instagram-Promo */
function showGuideEnd(key, gc){
  const g=GUIDES[key]; if(!g) return;
  gc=gc||{n:0,kg:0,bigW:0,bigSp:null,bySp:{}};
  const fname=g.name.split(' ')[0];
  // Fang-Zusammenfassung aufbauen
  let summary;
  if(gc.n>0){
    const bySp=Object.entries(gc.bySp).map(([sp,n])=>`${fishIcon(sp,15)} ${n}× ${SPECIES[sp].name}`).join(' · ');
    const big=gc.bigSp?`${SPECIES[gc.bigSp].name} mit <b>${fmtW(gc.bigW)}</b>`:'–';
    summary=`<div class="lurebox" style="display:block;text-align:left">
      <div class="nm">📋 Eure gemeinsame Strecke</div>
      <div class="statline" style="margin:8px 0 4px">
        <div><div class="v">${gc.n}</div><div class="l">Fänge</div></div>
        <div><div class="v">${fmtW(gc.kg)}</div><div class="l">Gesamt</div></div>
        <div><div class="v">${gc.bigSp?fishIcon(gc.bigSp,22):'–'}</div><div class="l">Bester</div></div>
      </div>
      <div class="sub2" style="margin:2px 0">🏆 Größter Fisch: ${big}</div>
      <div class="sub2" style="margin:2px 0">${bySp}</div></div>`;
  } else {
    summary=`<div class="lurebox" style="display:block;text-align:center">
      <div class="nm">📋 Eure gemeinsame Strecke</div>
      <div class="sub2" style="margin:4px 0">Heute lief leider nichts ins Netz – das Wasser war wohl in Beißpause. Beim nächsten Mal!</div></div>`;
  }
  // Instagram-Promo (falls hinterlegt)
  const igBox = g.igUrl ? `<div class="lurebox" style="display:block;text-align:center;border-color:var(--accent)">
      <div class="nm">📸 Folge ${fname} auf Instagram</div>
      <div class="sub2" style="margin:4px 0">@${g.ig} – noch mehr fette Fische & Tipps</div>
      <a class="btn full" href="${g.igUrl}" target="_blank" rel="noopener" style="margin-top:6px;text-decoration:none;background:linear-gradient(120deg,#833ab4,#fd1d1d,#fcb045);color:#fff">📸 @${g.ig} folgen ↗</a></div>` : '';
  // Daniel: Gutschein als „Wiedergutmachung"
  const danBox = key==='daniel' ? `<div class="lurebox" style="display:block;text-align:center;border-color:var(--gold)">
      <div class="nm">🎟️ Wiedergutmachung von Daniel</div>
      <div class="sub2" style="margin:4px 0">15% auf alle LMAB-Artikel mit Code:</div>
      <div style="font-weight:900;font-size:20px;letter-spacing:2px;color:var(--gold)">${DANIEL_CODE}</div>
      <a class="btn full gold" href="${DANIEL_URL}" target="_blank" rel="noopener" style="margin-top:8px;text-decoration:none">🛒 Einlösen ↗</a></div>` : '';
  const byeLine = g.bye || (key==='daniel'
    ? 'Ahh, Zeit vorbei! War schön mit dir. Daniel ist kein Glücksbringer, ich weiss… aber Herz war gross!'
    : 'Die gemeinsame Zeit ist vorbei – das war ein schöner Angeltag!');
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="bigfish">${guideIcon(g,64)}</div>
    <div class="fname">Tschüss, ${fname}! 👋</div>
    <div class="sub" style="margin:8px 6px">„${byeLine}"</div>
    ${summary}
    ${igBox}
    ${danBox}
    <button class="btn full gold" id="gEndGo" style="margin-top:10px">Petri Dank!</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#gEndGo').onclick=()=>ov.remove();
}
function guideRemaining(){ const ms=Math.max(0,(S.guideUntil||0)-Date.now()); const s=Math.ceil(ms/1000); return Math.floor(s/60)+':'+String(s%60).padStart(2,'0'); }
function bookGuide(k){
  const g=GUIDES[k]; if(!g) return;
  if(activeGuide()){ toast('🎣 Du hast schon einen Guide gebucht.'); return; }
  const gp=shopPrice(g.price);
  if(S.money<gp){ toast('💶 Nicht genug Münzen für den Guide'); return; }
  S.money-=gp; S.guideKey=k; S.guideUntil=Date.now()+GUIDE_MS; startGuideSession();
  if(g.water) S.water=g.water; S.fromBoat=!!g.boat;
  sfx.buy(); save(); syncTop();
  toast('🎣 '+g.name+' gebucht – 3 Min. Guiding auf '+guideTargetName(g)+'!'); renderShop();
}
/* Zufällige Guide-Begegnung am Wasser + Überzeugungs-Wortgefecht */
function maybeGuideEncounter(chance){
  if(activeGuide()) return false;
  if(Math.random()>=chance) return false;
  const pop=WATERS[S.water].pop;
  const cands=Object.keys(GUIDES).filter(k=>(GUIDES[k].all || pop[GUIDES[k].sp]!==undefined) && eventReady('guide_'+k));
  if(!cands.length) return false;
  const k=cands[Math.floor(Math.random()*cands.length)];
  markEvent('guide_'+k);
  startEncounter(k);
  return true;
}
function startEncounter(k){
  const g=GUIDES[k];
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:430px"></div>`;
  document.body.appendChild(ov);
  const M=()=>ov.querySelector('.modal');
  const st={meter:30, round:0, pool:[], cur:null, opts:[], reply:'', opener:true};
  const shuffle=a=>{ for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));const x=a[i];a[i]=a[j];a[j]=x;} return a; };
  function setEx(ex){ st.cur=ex; st.opts=shuffle(ex.opts.slice()); }
  function nextExchange(){ if(!st.pool.length) st.pool=shuffle(ENCOUNTER.map((_,i)=>i)); setEx(ENCOUNTER[st.pool.pop()]); }
  function intro(){
    M().innerHTML=`<div style="text-align:center">
      <div class="bigfish">${guideIcon(g,72)}</div>
      <div class="fname">${g.name}</div><div class="fsci">${g.spot} · ${g.all?'Allrounder':SPECIES[g.sp].name+'-Profi'}</div>
      <div class="sub" style="margin:8px 0">Du triffst ${g.name.split(' ')[0]} zufällig am Wasser! Überrede ihn im Wortgefecht, den „Tag" (3 Min.) mit dir zu angeln – such die schmeichelnde, clevere Antwort.</div>
      <button class="btn full gold" id="enStart">😏 Anquatschen</button>
      <button class="btn ghost full" id="enSkip" style="margin-top:8px">Lieber nicht</button></div>`;
    M().querySelector('#enStart').onclick=()=>{ setEx(GUIDE_OPENERS[k]||ENCOUNTER_OPENER); st.opener=true; step(); };
    M().querySelector('#enSkip').onclick=()=>ov.remove();
  }
  function step(){
    const pct=Math.max(0,Math.min(100,st.meter));
    const line = st.opener ? (g.name.split(' ')[0]+' schaut dich an: „Na, wer bist denn du?"') : fmt(st.cur.q,g);
    M().innerHTML=`<div>
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:6px">${guideIcon(g,38)}<div><div style="font-weight:800">${g.name}</div><div style="font-size:11px;color:var(--muted)">Überzeugung ${Math.round(pct)}%</div></div></div>
      <div class="convometer"><i style="width:${pct}%"></i></div>
      ${st.reply?`<div class="speechreply">💬 ${g.name.split(' ')[0]}: „${st.reply}"</div>`:''}
      <div class="speech"><span class="spk">🗣️ ${g.name.split(' ')[0]} sagt</span>${line}</div>
      <div class="answhead">👉 Deine Antwort:</div>
      ${st.opts.map((o,i)=>`<button class="btn ghost full enopt" data-i="${i}">› ${fmt(o.t,g)}</button>`).join('')}
    </div>`;
    M().querySelectorAll('.enopt').forEach(b=>b.onclick=()=>choose(st.opts[+b.dataset.i]));
  }
  function choose(o){
    st.meter+=o.s; st.round++; st.reply=fmt(o.r,g); st.opener=false;
    if(o.s>=18) sfx.perfect(); else if(o.s<0) sfx.lose(); else sfx.reel();
    if(st.meter>=100) return win();
    if(st.meter<=0 || st.round>=8) return fail();
    nextExchange(); step();
  }
  function win(){
    S.guideKey=k; S.guideUntil=Date.now()+GUIDE_MS; startGuideSession(); save(); syncTop(); sfx.win();
    M().innerHTML=`<div style="text-align:center">
      <div class="ribbon">🤝 ÜBERREDET!</div>
      <div class="bigfish">${guideIcon(g,72)}</div>
      <div class="fname">${g.name} macht mit!</div>
      <div class="sub" style="margin:8px 0">„${fmt(pick(ENCOUNTER_WIN),g)}" – 3 Minuten gemeinsames Guiding auf ${guideTargetName(g)}!</div>
      <button class="btn full gold" id="enGo">🎣 Loslegen</button></div>`;
    M().querySelector('#enGo').onclick=()=>{ ov.remove(); renderFishing(); };
  }
  function fail(){
    sfx.lose();
    M().innerHTML=`<div style="text-align:center">
      <div class="bigfish" style="filter:grayscale(1);opacity:.7">${guideIcon(g,72)}</div>
      <div class="fname">${g.name} zieht weiter…</div>
      <div class="sub" style="margin:8px 0">„${fmt(pick(ENCOUNTER_FAIL),g)}"</div>
      <button class="btn ghost full" id="enClose">Schade.</button></div>`;
    M().querySelector('#enClose').onclick=()=>ov.remove();
  }
  intro();
}

/* ---------- Big L: Geheim-Begegnung (nicht überredbar, aber Respekt = Belohnung) ---------- */
const BIGL_OPENER = { opts:[
  {t:'Momento – bist du nicht Big L?! Gründer von Monkey-Lures! Salud, Hombre – darf ich aus der großen Flasche mitnippen?', s:24, r:'Haha! Ein Mann mit Manieren. Y con sed.'},
  {t:'Hey, dich kenn ich – die halbe Welt fischt deine Monkey-Lures.', s:8, r:'Sí, sí. Wird schon noch.'},
  {t:'Ey, schenkst du mir ein paar Köder? Und ’n Schluck aus der Pulle?', s:-16, r:'Dreist. La botella bleibt meine.'},
  {t:'Digga, mach mal Platz, ich will hier angeln.', s:-18, r:'Bro. ¿En serio?'} ]};
const BIGL_EX = [
  { q:'Und du denkst, du kannst mit MIR mithalten?', opts:[
    {t:'Mithalten? Niemals. Ich will nur von der Legende lernen.', s:20, r:'Hah, ehrlich. Mag ich.'},
    {t:'Klar, warum nicht.', s:4, r:'„Warum nicht." Süß.'},
    {t:'Locker, ich fang mehr als du.', s:-18, r:'Der war gut. Zisch ab.'} ]},
  { q:'Weißt du überhaupt, wer ich bin?', opts:[
    {t:'Big L – die halbe Köderbox trägt deine Handschrift.', s:20, r:'Respekt für die Recherche.'},
    {t:'Klar, vom Plakat.', s:4, r:'Vom Plakat. Na gut.'},
    {t:'Sollte ich?', s:-18, r:'Autsch. Nächster.'} ]},
  { q:'Was willst du eigentlich von mir?', opts:[
    {t:'Nur kurz deine Aura tanken – und vielleicht einen Tipp.', s:18, r:'*lacht* Frech, aber ok.'},
    {t:'Ein Selfie?', s:3, r:'Später vielleicht.'},
    {t:'Deine Geheim-Spots. Jetzt.', s:-18, r:'Träum weiter.'} ]},
  { q:'Beeindruck mich. Ein Satz.', opts:[
    {t:'Ohne Typen wie dich wäre Angeln in Deutschland nur halb so geil.', s:22, r:'…ok, das sitzt.'},
    {t:'Ich bin echt nett?', s:3, r:'Mhm.'},
    {t:'Ich hab mehr Follower.', s:-18, r:'Tschüss.'} ]},
];
function startBigL(){
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:430px"></div>`;
  document.body.appendChild(ov);
  const M=()=>ov.querySelector('.modal');
  const st={meter:18, round:0, pool:[], cur:null, opts:[], reply:'', opener:true};
  const shuffle=a=>{ for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));const x=a[i];a[i]=a[j];a[j]=x;} return a; };
  function setEx(ex){ st.cur=ex; st.opts=shuffle(ex.opts.slice()); }
  function nextExchange(){ if(!st.pool.length) st.pool=shuffle(BIGL_EX.map((_,i)=>i)); setEx(BIGL_EX[st.pool.pop()]); }
  function intro(){
    M().innerHTML=`<div style="text-align:center">
      <div style="font-size:64px">😎🎣</div>
      <div class="fname">Big L</div><div class="fsci">Die lebende Köder-Legende</div>
      <div class="sub" style="margin:8px 0">Krass – du triffst <b>Big L</b> höchstpersönlich! Überreden lässt er sich nicht … aber wenn du dir seinen <b>Respekt</b> verdienst, springt was raus.</div>
      <button class="btn full gold" id="blStart">😏 Ansprechen</button>
      <button class="btn ghost full" id="blSkip" style="margin-top:8px">Lieber cool bleiben</button></div>`;
    M().querySelector('#blStart').onclick=()=>{ setEx(BIGL_OPENER); st.opener=true; step(); };
    M().querySelector('#blSkip').onclick=()=>ov.remove();
  }
  function step(){
    const pct=Math.max(0,Math.min(100,st.meter));
    const line = st.opener ? 'Big L mustert dich: „Und du bist…?"' : st.cur.q;
    M().innerHTML=`<div>
      <div style="display:flex;align-items:center;gap:10px;margin-bottom:6px"><span style="font-size:34px">😎</span><div><div style="font-weight:800">Big L</div><div style="font-size:11px;color:var(--muted)">Respekt ${Math.round(pct)}%</div></div></div>
      <div class="convometer"><i style="width:${pct}%"></i></div>
      ${st.reply?`<div class="speechreply">💬 Big L: „${st.reply}"</div>`:''}
      <div class="speech"><span class="spk">🗣️ Big L sagt</span>${line}</div>
      <div class="answhead">👉 Deine Antwort:</div>
      ${st.opts.map((o,i)=>`<button class="btn ghost full enopt" data-i="${i}">› ${o.t}</button>`).join('')}
    </div>`;
    M().querySelectorAll('.enopt').forEach(b=>b.onclick=()=>choose(st.opts[+b.dataset.i]));
  }
  function choose(o){
    st.meter+=o.s; st.round++; st.reply=o.r; st.opener=false;
    if(o.s>=18) sfx.perfect(); else if(o.s<0) sfx.lose(); else sfx.reel();
    if(st.meter>=75) return respect();
    if(st.meter<=0 || st.round>=7) return fail();
    nextExchange(); step();
  }
  function respect(){
    const pool=['turbolui','drunkdancer','multivibe','jigmaster','deracoup'];
    let gift=pool.find(x=>!S.ownLures.includes(x))||'turbolui';
    if(!S.ownLures.includes(gift)) S.ownLures.push(gift);
    S.biglCoupon=true; save(); syncTop(); sfx.coupon();
    M().innerHTML=`<div style="text-align:center">
      <div class="ribbon">🤘 RESPEKT VERDIENT!</div>
      <div style="font-size:60px">😎👊</div>
      <div class="fname">Big L nickt anerkennend</div>
      <div class="sub" style="margin:8px 0">„Nicht schlecht, Kid. Hier – nimm den ${LURES[gift].name} mit. Und das hier ist für den echten Shop."</div>
      <div class="lurebox" style="display:block;text-align:center;border-color:var(--gold)">
        <div class="nm">🎁 Geschenk: ${LURES[gift].name}</div>
        <div class="sub2" style="margin:4px 0">5% auf alle Monkey-Lures & Big-L Produkte mit Code:</div>
        <div style="font-weight:900;font-size:20px;letter-spacing:2px;color:var(--gold)">${BIGL_CODE}</div>
        <a class="btn full gold" href="${BIGL_URL}" target="_blank" rel="noopener" style="margin-top:8px;text-decoration:none">🛒 Einlösen ↗</a></div>
      <div class="lurebox" style="display:block;text-align:center;border-color:var(--accent)">
        <div class="nm">📸 Folge Big L auf Instagram</div>
        <div class="sub2" style="margin:4px 0">@big_l_fishing – Monkey-Lures, Big-L & jede Menge Action</div>
        <a class="btn full" href="https://www.instagram.com/big_l_fishing/" target="_blank" rel="noopener" style="margin-top:6px;text-decoration:none;background:linear-gradient(120deg,#833ab4,#fd1d1d,#fcb045);color:#fff">📸 @big_l_fishing folgen ↗</a></div>
      <button class="btn full" id="blGo" style="margin-top:10px">🤙 Stark!</button></div>`;
    M().querySelector('#blGo').onclick=()=>{ ov.remove(); if(route==='fish') renderFishing(); };
  }
  function fail(){
    sfx.lose();
    M().innerHTML=`<div style="text-align:center">
      <div style="font-size:60px;filter:grayscale(.4)">😎✌️</div>
      <div class="fname">Big L zischt ab</div>
      <div class="sub" style="margin:8px 0">„War nett. Aber heute nicht, Kid." Er steigt ins Bassboat und braust davon.</div>
      <button class="btn ghost full" id="blClose">Respekt is' schwer verdient…</button></div>`;
    M().querySelector('#blClose').onclick=()=>ov.remove();
  }
  intro();
}
function maybeBigL(chance){ if(activeGuide())return false; if(!eventReady('bigl'))return false; if(Math.random()>=chance)return false; markEvent('bigl'); startBigL(); return true; }

/* ---------- Fangbuch ---------- */
function renderBook(){
  let h=`<h2>📖 Fangbuch</h2><p class="sub">Deine Rekorde. Gefangen: ${Object.keys(S.book).length}/${Object.keys(SPECIES).length} Arten.</p><div class="bookgrid">`;
  for(const [k,sp] of Object.entries(SPECIES)){
    const rec=S.book[k];
    if(rec) h+=`<div class="bookcard"><div class="em">${fishIcon(k,46)}</div><div class="info"><div class="n">${sp.name} ${sp.special?'⭐':''}</div><div class="d">${sp.sci}</div><div class="r">🏆 ${rec.bestW.toFixed(2)} kg · ${rec.count}× gefangen</div></div></div>`;
    else h+=`<div class="bookcard locked"><div class="em">❓</div><div class="info"><div class="n">${sp.special?'??? (Spezialfisch)':'Unbekannt'}</div><div class="d">Noch nicht gefangen</div></div></div>`;
  }
  h+=`</div>`;
  // Legenden / Trophäen-Fische je Gewässer
  const legs=allBosses(), got=(S.bosses||{});
  const gotN=legs.filter(b=>got[b.name]).length;
  h+=`<h2 style="margin-top:14px">🐉 Legenden <span class="donebadge" style="vertical-align:middle">${gotN}/${legs.length}</span></h2>
      <p class="sub">Riesige, benannte Trophäen-Fische – 2–3 pro Gewässer. Mit Glück steigt eine im Drill ein.</p><div class="bookgrid">`;
  for(const b of legs){ const has=!!got[b.name];
    h+= has
      ? `<div class="bookcard"><div class="em">${fishIcon(b.sp,46)}</div><div class="info"><div class="n">🐉 ${b.name}</div><div class="d">${WATERS[b.water].name} · ${SPECIES[b.sp].name}</div><div class="r">🏆 ~${b.kg.toFixed(1)} kg · gelandet ✅</div></div></div>`
      : `<div class="bookcard locked"><div class="em">❓</div><div class="info"><div class="n">??? (Legende)</div><div class="d">${WATERS[b.water].name}</div><div class="r">Noch nicht gelandet</div></div></div>`;
  }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h; wireBack('start');
}

function renderChallenges(){
  const doneN=(S.chDone||[]).filter(id=>CHALLENGES.some(c=>c.id===id)).length;
  let h=topBack()+`<h2>🏆 Challenges <span class="donebadge" style="vertical-align:middle">${doneN}/${CHALLENGES.length} ✅</span></h2><p class="sub">Erfülle eine Aufgabe an einem Gewässer im Zeitlimit. Tipp: Köder & Tageszeit anpassen – schwere Challenges schaffst du nur mit Top-Tackle (oder Boot/Guide).</p><div class="grid">`;
  const done=S.chDone||[];
  for(const c of CHALLENGES){
    const dc = c.diff==='Brutal'?'var(--danger)':c.diff==='Schwer'?'var(--gold)':'var(--accent2)';
    const isDone=done.includes(c.id);
    h+=`<div class="pick${isDone?' chdone':''}" style="cursor:default">
      <div class="ttl"><span class="ic">${WATERS[c.water].ic}</span> ${c.name} ${isDone?'<span class="donebadge">✅ Abgeschlossen</span>':''}</div>
      <div class="brandline">${WATERS[c.water].name} · ⏱️ ${c.mins} Min · <span style="color:${dc}">${c.diff}</span> · 💶 ${c.reward}</div>
      <div class="meta"><b>Ziel:</b> ${c.goal}<br>${c.desc}</div>
      <div style="margin-top:10px"><button class="btn ${isDone?'ghost':'gold'}" data-ch="${c.id}" style="padding:9px 14px;font-size:14px">${isDone?'🔁 Nochmal spielen':'▶ Challenge starten'}</button></div>
    </div>`;
  }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h;
  screen.querySelectorAll('[data-ch]').forEach(b=>b.onclick=()=>startChallenge(b.dataset.ch));
  wireBack('start');
}

/* =========================================================================
   ANGELN – Wurf-Minispiel + Drill
   Zustände: idle → aimPower → aimDir → flying → waiting → bite → fight → done
   ========================================================================= */
let game=null;

/* Regen: wenige sanft fallende Tropfen + aufklingende Tropfen-Ringe auf dem Wasser (augenschonend) */
const RAIN_HTML = (()=>{
  const falls=[[12,1.05,0],[28,1.3,.5],[44,1.1,.9],[60,1.35,.25],[76,1.15,1.2],[88,1.25,.7],[20,1.4,1.5],[68,1.05,1.8]];
  const rips=[[18,58,0],[34,64,.7],[50,55,1.3],[64,67,.4],[78,61,1.9],[26,69,2.4],[58,63,1.0],[44,71,1.6]];
  let h='';
  for(const [l,dur,del] of falls) h+=`<span class="fall" style="left:${l}%;animation-duration:${dur}s;animation-delay:${del}s"></span>`;
  for(const [l,tp,del] of rips) h+=`<span class="ripple" style="left:${l}%;top:${tp}%;animation-duration:2.7s;animation-delay:${del}s"></span>`;
  return h;
})();

function renderFishing(){
  if(game&&game.guideIv) clearInterval(game.guideIv);
  if(game&&game.tipIv) clearInterval(game.tipIv);
  if(game&&game.chIv) clearInterval(game.chIv);
  ambientStart();
  if(!S.buddySeen) startBuddy();   // Einstieg: bester Angelkumpel leiht Top-Tackle für 5 Min
  const w=WATERS[S.water], t=TIMES[S.time], we=WEATHER[S.weather];
  const cloudy=(we.name==='Bewölkt'||we.name==='Regen');
  const scn=WATERSCENE[S.water];
  const _ag=activeGuide(); const boatActive = S.fromBoat || (_ag && _ag.boat);
  screen.innerHTML=`
    <div id="scene" class="w-${scn.type}${boatActive?' boatmode':''}${we.name==='Regen'?' raining':''}">
      <div class="sky" style="background:${t.sky}"></div>
      <div class="sun" style="opacity:${t.night?0:.95}"></div>
      <div class="moon" style="opacity:${t.night?1:0}"></div>
      <div class="clouds" style="opacity:${cloudy?1:0}"></div>
      <div class="rainbow" id="rainbow"></div>
      <div class="nightveil" style="opacity:${t.night?0.32:0}"></div>
      <div class="dam"></div>
      <div class="waterband" style="background:${scn.col}"></div>
      <div class="flow"></div><div class="gravel"></div>
      <div class="cwall left"></div><div class="cwall right"></div>
      <div class="shimmer"></div>
      <div class="fishshadow s1"></div><div class="fishshadow s2"></div><div class="fishshadow s3"></div>
      <div class="rain" style="opacity:${we.name==='Regen'?1:0}">${we.name==='Regen'?RAIN_HTML:''}</div>
      <div class="headlamp" id="headlamp"></div>
      <div class="nightmask" id="nightmask"></div>

      <div id="castshadows"></div>
      <div id="spotzones">
        <div class="sz" style="bottom:50%">🌊 Freiwasser</div>
        <div class="sz" style="bottom:38%">⬇️ Kante / Tiefe</div>
        <div class="sz" style="bottom:26%">🌾 Ufer / Schilf</div>
      </div>
      <div id="hotspot"><div class="ring"></div><div class="fishic">🐟</div><div class="lbl">treffen!</div></div>

      <div class="bank"></div>
      <div class="reeds left"></div><div class="reeds right"></div>
      <div class="boathull"><svg viewBox="0 0 220 70" preserveAspectRatio="xMidYMax meet" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12 L216 12 L194 58 Q110 72 26 58 Z" fill="#2a3742"/>
        <path d="M4 12 L216 12 L208 26 L12 26 Z" fill="#3c4d5a"/>
        <rect x="150" y="2" width="34" height="12" rx="3" fill="#46596a"/></svg></div>
      <svg class="rigline" id="rigline" preserveAspectRatio="none"><line class="rline" id="rline" x1="58%" y1="46%" x2="58%" y2="46%" style="display:none"/></svg>
      <svg class="angler" id="angler" viewBox="0 0 150 320" preserveAspectRatio="xMidYMax meet" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="72" cy="313" rx="46" ry="7" fill="#000" opacity=".22"/>
        <path d="M56 314 L60 250 L73 250 L71 314 Z" fill="#26313f"/>
        <path d="M75 314 L75 250 L88 250 L92 314 Z" fill="#212c39"/>
        <rect x="50" y="306" width="25" height="12" rx="4" fill="#161f29"/>
        <rect x="74" y="306" width="25" height="12" rx="4" fill="#161f29"/>
        <path d="M46 256 Q40 196 74 190 Q108 196 102 256 Z" fill="#3f5d3c"/>
        <path d="M74 192 L74 256" stroke="#2d4730" stroke-width="2.4" opacity=".5"/>
        <path d="M58 197 Q74 185 90 197 Q74 205 58 197 Z" fill="#2d4730"/>
        <rect x="67" y="172" width="14" height="16" rx="5" fill="#c69a72"/>
        <circle cx="74" cy="166" r="16" fill="#c89c74"/>
        <path d="M55 164 Q74 144 93 164 Q93 156 74 153 Q55 156 55 164 Z" fill="#1f6f48"/>
        <path d="M55 164 Q74 169 93 164 L93 160 Q74 165 55 160 Z" fill="#19583a"/>
        <path d="M62 222 Q92 208 116 192" stroke="#3f5d3c" stroke-width="12" fill="none" stroke-linecap="round"/>
        <path d="M96 214 Q120 196 128 178" stroke="#3f5d3c" stroke-width="13" fill="none" stroke-linecap="round"/>
        <circle cx="118" cy="190" r="7" fill="#c89c74"/><circle cx="128" cy="180" r="7" fill="#c89c74"/>
        <circle cx="120" cy="198" r="6" fill="#15181c"/>
        <path id="rod" d="M118 192 L139 30" stroke="#6b4a2a" stroke-width="5" fill="none" stroke-linecap="round"/>
      </svg>
      <svg class="guidefig" id="guidefig" viewBox="0 0 120 260" preserveAspectRatio="xMidYMax meet" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="60" cy="254" rx="38" ry="6" fill="#000" opacity=".22"/>
        <path d="M46 256 L50 198 L62 198 L60 256 Z" fill="#23303f"/>
        <path d="M62 256 L62 198 L74 198 L78 256 Z" fill="#1e2a37"/>
        <rect x="40" y="248" width="22" height="11" rx="4" fill="#141d27"/>
        <rect x="62" y="248" width="22" height="11" rx="4" fill="#141d27"/>
        <path d="M38 204 Q34 150 60 145 Q86 150 82 204 Z" fill="#2c5aa0"/>
        <path d="M48 150 Q60 140 72 150 Q60 157 48 150 Z" fill="#214b86"/>
        <rect x="53" y="126" width="13" height="15" rx="5" fill="#c69a72"/>
        <circle cx="60" cy="120" r="15" fill="#c89c74"/>
        <path d="M45 118 Q60 100 75 118 Q75 110 60 107 Q45 110 45 118 Z" fill="#b53a2f"/>
        <path d="M50 170 Q66 158 80 150" stroke="#2c5aa0" stroke-width="10" fill="none" stroke-linecap="round"/>
        <path d="M70 168 Q92 150 104 130" stroke="#2c5aa0" stroke-width="11" fill="none" stroke-linecap="round"/>
        <path d="M102 132 L118 28" stroke="#5a3e22" stroke-width="4" fill="none" stroke-linecap="round"/>
      </svg>
      <div class="anglerbubble" id="anglerbubble"></div>
      <div class="bobber" id="bobber"><svg width="18" height="26" viewBox="0 0 18 26" xmlns="http://www.w3.org/2000/svg"><ellipse cx="9" cy="24" rx="6.5" ry="2.2" fill="rgba(0,0,0,.25)"/><path d="M9 2 Q15 6 15 12 Q15 18 9 20 Q3 18 3 12 Q3 6 9 2 Z" fill="#ededf2"/><path d="M9 2 Q15 6 15 12 L3 12 Q3 6 9 2 Z" fill="#e0533d"/><circle cx="9" cy="12" r="1.5" fill="#2a2a2a"/></svg></div>
      <div id="approachfish"></div>
      <div id="netfish"></div>
      <div id="netcatcher"><div class="nethandle"></div><div class="netring"></div><div class="capfill" id="capfill"></div></div>

      <div class="hudtop">
        <span class="chip" style="background:var(--accent);color:#04222c;font-weight:800">✎ Ändern</span>
        <span class="chip">${w.ic} ${w.name}</span>
        ${S.fromBoat?`<span class="chip">🚣 ${BOATS[S.boat]?BOATS[S.boat].name:'Boot'}</span>`:''}
        ${activeGuide()?`<span class="chip" id="guidechip">🎣 ${activeGuide().name.split(' ')[0]} · ${guideRemaining()}</span>`:''}
        <span class="chip">${DIFFICULTY[S.difficulty].ic} ${SEASONS[S.season].ic} ${t.ic} ${we.ic}</span>
        <span class="chip">💧 ${clarityLabel()}</span>
        <span class="chip" id="lurechip">${LURES[S.lure].ic} ${LURES[S.lure].name}</span>
        <span class="chip" id="techchip">${COLORS[S.color].ic} · ${RIGS[S.rig].ic} ${RIGS[S.rig].name}</span>
        ${S.netBroken?`<span class="chip" style="border-color:var(--danger);color:#ffd0c8">🥅⚠️ Kescher beschädigt</span>`:''}
      </div>
      ${(CH||TOURNEY)?`<div id="chbar"></div>`:''}

      <div id="hookmeter">
        <div class="glabel">ANSCHLAG – je früher, desto besser!</div>
        <div class="htrack"><div class="hneedle" id="hneedle"></div></div>
        <div class="hzones"><span>perfekt</span><span>gut</span><span>ok</span><span>schlecht</span></div>
      </div>

      <div id="followpath"></div>
      <div id="hookhold"><span class="hh-lbl"><span class="hh-ic">🪝</span><span class="hh-txt">Haken sitzt fest</span></span><div class="hh-track"><i id="hhfill"></i></div></div>
      <div id="followbars">
        <div class="fb-row"><span class="fb-lbl">⏱️ Zeit</span><div class="fb-track" id="fbTime"><i></i></div></div>
        <div class="fb-row"><span class="fb-lbl">🐟 Interesse</span><div class="fb-track" id="fbInt"><i></i></div></div>
      </div>
      <button id="centerbtn"></button>
      <div class="lchead" id="lchead"><div class="lc-h1">🎣 Köderführung</div><div class="lc-h2">Halte den Köder in der Mitte des Kreises</div></div>
      <div id="lurecircle">
        <div class="lc-ring" style="width:60%;height:60%"></div>
        <div class="lc-bull"></div>
        <svg class="lc-link" viewBox="0 0 100 100" preserveAspectRatio="none"><line id="lcline" x1="50" y1="50" x2="50" y2="50"/></svg>
        <div class="lc-cursor" id="lccursor">✛</div>
        <div class="lc-fish" id="lcfish">🎣</div>
      </div>
      <div id="retmini"></div>

      <div id="netmeter">
        <div class="glabel">🥅 KESCHERN – triff den grünen Bereich!</div>
        <div class="ntrack"><div class="nzone" id="nzone"></div><div class="nneedle" id="nneedle"></div></div>
      </div>

      <div id="fight">
        <div class="track" id="track"><div class="pbar"><i id="pfill" style="height:0%"></i></div><div class="zone" id="zone"></div><div class="fishmark" id="fmark"></div></div>
        <button class="reelbtn" id="reelbtn">HALTEN<br>zum Kurbeln</button>
      </div>

      <div class="hud" id="hud">
        <div class="msg" id="msg">Tippe „Auswerfen" und triff dann den wandernden Fisch möglichst genau.</div>
        <button class="btn full gold" id="actBtn">🎯 Auswerfen</button>
        ${S.fromBoat?`<button class="btn full" id="echoBtn" style="margin-top:8px">${echoReady()?'📡 Echolot – Hotspot orten':'📡 Echolot lädt … '+fmtMMSS((S.echoUntil||0)-Date.now())}</button>`:''}
        <div class="btnrow" id="idlebtns" style="margin-top:0">
          <button class="btn ghost" style="flex:1;font-size:13px;padding:11px 6px" id="tackleBtn">🎒 Tackle</button>
          <button class="btn ghost" style="flex:1;font-size:13px;padding:11px 6px" id="shopBtn">🛒 Laden</button>
          <button class="btn ghost" style="flex:1;font-size:13px;padding:11px 6px" id="leaveBtn">← Ausrüstung</button>
        </div>
      </div>
    </div>`;
  game={state:'idle'};
  $('#actBtn').onclick=(e)=>{ e.stopPropagation(); onAct(); };
  $('#leaveBtn').onclick=(e)=>{ e.stopPropagation(); go('gear'); };
  { const sb=$('#shopBtn'); if(sb) sb.onclick=(e)=>{ e.stopPropagation(); go('shop'); }; }
  $('#tackleBtn').onclick=(e)=>{ e.stopPropagation(); if(game.state==='idle'||game.state==='done') openTackle(); };
  { const cb=$('#centerbtn'); if(cb) cb.onclick=(e)=>{ e.stopPropagation(); onAct(); }; }
  { const eb=$('#echoBtn'); if(eb){ eb.onclick=(e)=>{ e.stopPropagation(); if(game.state==='idle'||game.state==='done') showSonar(); };
      const updEcho=()=>{ const b=$('#echoBtn'); if(!b){ if(game&&game.echoIv){clearInterval(game.echoIv);game.echoIv=null;} return; }
        if(echoReady()){ b.disabled=false; b.textContent='📡 Echolot – Hotspot orten'; }
        else { b.disabled=true; b.textContent='📡 Echolot lädt … '+fmtMMSS((S.echoUntil||0)-Date.now()); } };
      updEcho(); game.echoIv=setInterval(updEcho,1000); } }
  // Tippen aufs Wasser: beim Auswerfen = Ziel treffen, sonst Aktion
  game.sceneTap=(e)=>{
    if(game.state==='bite'){ strike(); return; }                       // Biss: Klick/Tipp überall = Anschlag
    if(game.state==='toretrieve'){ if(!e.target.closest('.hud')&&!e.target.closest('.hudtop')) beginRetrieve(); return; }  // Bestätigung: Köderführung starten
    if(game.state==='waiting'){ return; }  // Köderführung läuft per Cursor (Maus/Finger bewegen)
    if(game.state==='presink'){ if(!e.target.closest('.hud')&&!e.target.closest('.hudtop')) armReadyBite(); return; } // Köder präsentieren
    if(game.state==='tofight'){ if(!e.target.closest('.hud')&&!e.target.closest('.hudtop')) beginDrill(); return; }   // Bestätigung: Drill starten
    if(game.state==='landing'){ return; }   // Keschern NUR über den Button (genau treffen) – Klick daneben ignorieren
    if(game.state==='follow'){ return; } // Nachläufer: per Cursor durch die S-Kurve führen
    if(game.state==='aiming'){ if(!e.target.closest('.hud')&&!e.target.closest('.hudtop')) resolveCastTap(e); return; }
    if(e.target.closest('.hud')||e.target.closest('.hudtop')||e.target.closest('#fight')||e.target.closest('#hookmeter')||e.target.closest('#netmeter')) return;
    onAct();
  };
  $('#scene').addEventListener('click',game.sceneTap);
  // Versteckte Test-Funktion: Klick auf Sonne/Mond erzwingt ein Zufalls-Event
  { const onCel=(e)=>{ e.stopPropagation(); forceRandomEvent(); };
    ['.sun','.moon'].forEach(sel=>{ const el=document.querySelector('#scene '+sel); if(el){ el.style.pointerEvents='auto'; el.style.cursor='pointer'; el.style.zIndex='6'; el.addEventListener('click',onCel); } }); }
  const hudtop=document.querySelector('.hudtop');
  if(hudtop){ hudtop.style.cursor='pointer'; hudtop.onclick=()=>{ if(game&&(game.state==='idle'||game.state==='done')) openTackle(); }; }
  if(activeGuide()){ const gf=$('#guidefig'); if(gf) gf.style.display='block'; }
  // Nacht: Kopflampe mit Lichtkegel, der dem Zeiger folgt
  if(t.night){
    const nm=$('#nightmask'), hl=$('#headlamp'); if(nm) nm.style.display='block'; if(hl) hl.style.display='block';
    const rad=hasGear('stirnlampe')?205:120;
    const setCone=(px,py)=>{ if(nm) nm.style.background='radial-gradient(circle '+rad+'px at '+px+'px '+py+'px, transparent 0%, transparent 52%, rgba(2,6,16,.94) 80%)'; };
    const sc=$('#scene'), r0=sc.getBoundingClientRect(); setCone(r0.width*0.55, r0.height*0.45);
    game.nightMove=(e)=>{ const r=$('#scene').getBoundingClientRect(); const cx=(e.touches&&e.touches[0]?e.touches[0].clientX:e.clientX), cy=(e.touches&&e.touches[0]?e.touches[0].clientY:e.clientY); if(cx==null)return; setCone(cx-r.left, cy-r.top); };
    sc.addEventListener('pointermove',game.nightMove); sc.addEventListener('touchmove',game.nightMove,{passive:true});
    maybeNightIntro();
  }
  // Regenbogen (3 Min nach dem Regenbogen-Event)
  { const rb=$('#rainbow'); if(rb){ const left=(S.rainbowUntil||0)-Date.now();
      if(left>0){ rb.style.opacity=.85; clearTimeout(game.rainbowT); game.rainbowT=setTimeout(()=>{ const r=$('#rainbow'); if(r) r.style.opacity=0; }, left); }
      else rb.style.opacity=0; } }
  game.tipN=0;
  game.tipIv=setInterval(()=>{ if(game&&game.state==='idle'&&!CH&&!TOURNEY){ setMsg('💡 '+GAMETIPS[game.tipN%GAMETIPS.length]); game.tipN++; sfx.tip(); } }, 13000);
  if(CH){ const upd=()=>{ const cb=$('#chbar'); if(!cb||!CH){ clearInterval(game.chIv); return; }
      if(Date.now()>CH.deadline){ clearInterval(game.chIv); challengeFail(); return; }
      cb.innerHTML='🏆 '+CH.def.name+' · ⏱️ '+chTimeLeft()+'<br>'+challengeProgress(CH.def); };
    upd(); game.chIv=setInterval(upd,1000); }
  if(TOURNEY){ const upd=()=>{ const cb=$('#chbar'); if(!cb||!TOURNEY){ clearInterval(game.toIv); return; }
      if(Date.now()>TOURNEY.deadline){ clearInterval(game.toIv); tourneyEnd(); return; }
      cb.innerHTML='🏁 '+TOURNEY.def.name+' · ⏱️ '+tourneyTimeLeft()+'<br>Dein Gewicht: '+TOURNEY.score.toFixed(2)+' kg'; };
    upd(); game.toIv=setInterval(upd,1000); }
  if(activeGuide()){ game.guideIv=setInterval(()=>{ const c=$('#guidechip'), g=activeGuide(); if(!c) return;
    if(!g){ c.remove(); clearInterval(game.guideIv); } else c.textContent='🎣 '+g.name.split(' ')[0]+' · '+guideRemaining(); }, 1000); }
  armIdle();
  if(fishFresh){ fishFresh=false; setTimeout(rollArrivalEvents, 700); }
}
function setMsg(t){ const m=$('#msg'); if(m) m.textContent=t; }
function showHead(h1,h2){ const hd=$('#lchead'); if(!hd) return; const a=hd.querySelector('.lc-h1'), b=hd.querySelector('.lc-h2'); if(a)a.textContent=h1; if(b)b.textContent=h2; hd.style.display='block'; }
function flashBig(text,color,top,dur){ const sc=$('#scene'); if(!sc) return; const d=document.createElement('div'); d.className='bigflash'; d.textContent=text; if(color) d.style.color=color; if(top) d.style.top=top; if(dur) d.style.animationDuration=dur+'ms'; sc.appendChild(d); setTimeout(()=>{ if(d.parentNode) d.remove(); },(dur||1100)+50); }
function showCenter(text,cls){ const b=$('#centerbtn'); if(!b) return; b.className=''; if(cls) b.classList.add(cls); b.textContent=text; b.style.top=''; b.style.animation=''; b.style.pointerEvents=''; b.style.display='block'; }
function hideCenter(){ const b=$('#centerbtn'); if(b){ b.style.display='none'; b.style.animation=''; b.classList.remove('redwait','greenflash'); } }
/* Center-Button sanft einblenden und kurz gegen versehentliche Klicks sperren */
function fadeInCenter(armMs){ const b=$('#centerbtn'); if(!b) return; b.style.pointerEvents='none'; b.style.animation='cbfade .45s ease';
  setTimeout(()=>{ if(b){ b.style.pointerEvents=''; b.style.animation=''; } }, armMs||500); }
const DRILL_SHOUTS=['Wow, sehr guter Fisch!','MONSTER!','Bleib dran, bleib dran!','Halt ihn, halt ihn!','Der ist kapital!','Nicht abreißen lassen!'];
function anglerSay(text,ms){ const b=$('#anglerbubble'); if(!b) return; b.textContent=text; b.style.display='block'; clearTimeout(b._t); b._t=setTimeout(()=>{ if(b)b.style.display='none'; }, ms||1900); }
// Rutenspitze (in %) aus der Angler-Grafik berechnen; Schnur dorthin verankern
function rodTipPct(){
  const a=document.getElementById('angler'), s=document.getElementById('scene');
  if(!a||!s) return {x:58,y:46};
  const ar=a.getBoundingClientRect(), sr=s.getBoundingClientRect();
  const vb=(game&&game.tipVB)?game.tipVB:{x:139,y:30};
  return { x:(ar.left+vb.x/150*ar.width - sr.left)/sr.width*100,
           y:(ar.top+vb.y/320*ar.height - sr.top)/sr.height*100 };
}
function setLine(L,B){ const t=rodTipPct(), r=$('#rline'); if(!r) return;
  r.setAttribute('x1',t.x+'%'); r.setAttribute('y1',t.y+'%'); r.setAttribute('x2',L+'%'); r.setAttribute('y2',(100-B)+'%'); r.style.display='block'; }
function hideLine(){ const r=$('#rline'); if(r) r.style.display='none'; }

function onAct(){
  if(!game) return;
  if(game.state==='idle'||game.state==='done') startCastAim();
  else if(game.state==='toretrieve') beginRetrieve();
  else if(game.state==='presink') armReadyBite();
  else if(game.state==='tofight') beginDrill();
  else if(game.state==='landing') beginNetting();
  else if(game.state==='bite') strike();
}

function armIdle(roll){
  game.state='idle'; game.echoBonus=0; game.echoGeber=0; game.boss=null;
  { const sc=$('#scene'); if(sc) sc.classList.remove('playing'); }   // idle: Setup-Chips wieder zeigen
  clearTimeout(game.biteTimer); clearTimeout(game.strikeTimer); clearTimeout(game.followTimer); clearTimeout(game.greenTimer); clearTimeout(game.presentT1); clearTimeout(game.presentT2); clearTimeout(game.chanceHintT); clearTimeout(game.preDiveTimer); clearTimeout(game.tofightT); clearTimeout(game.landT);
  cancelAnimationFrame(game.tRAF); cancelAnimationFrame(game.hookRAF); cancelAnimationFrame(game.retrRAF); netCleanup();
  $('#fight').style.display='none'; $('#hookmeter').style.display='none'; $('#netmeter').style.display='none'; $('#hotspot').style.display='none';
  { const sz=$('#spotzones'); if(sz) sz.style.display='none'; } hideCastShadows();
  { const fp=$('#followpath'); if(fp) fp.style.display='none'; }
  { clearInterval(game.fcIv); game.fcIv=null; const fc=$('#followcount'); if(fc) fc.remove(); }
  endRetMini();
  { const hd=$('#lchead'); if(hd) hd.style.display='none'; }
  const lb0=$('#lurecircle'); if(lb0) lb0.style.display='none';
  hideCenter();
  { const ab=$('#actBtn'); if(ab) ab.classList.remove('redwait','greenflash'); }
  $('#scene').classList.remove('waiting');
  const b=$('#bobber'); b.style.display='none'; b.classList.remove('bite','rest','twitch'); hideLine(); hideApproachFish();
  game.tipVB={x:139,y:30}; const rodEl=$('#rod'); if(rodEl) rodEl.setAttribute('d','M118 192 L139 30');
  const angEl=$('#angler'); if(angEl) angEl.style.transform='translateX(-50%)';
  const ab=$('#anglerbubble'); if(ab) ab.style.display='none';
  const act=$('#actBtn'); act.classList.remove('hidden'); act.disabled=false; act.textContent='🎯 Auswerfen';
  $('#idlebtns').classList.remove('hidden'); { const eb=$('#echoBtn'); if(eb) eb.classList.remove('hidden'); }
  // Nach jedem Wurf-Zyklus: allgemeinen Spiel-Tipp auf dem Auswerfen-Screen zeigen (Spiel besser verstehen)
  if(roll){ game.tipN=Math.floor(Math.random()*GAMETIPS.length); setMsg('💡 '+GAMETIPS[game.tipN]); game.tipN++; }
  // Nach jedem Wurf-Zyklus (Fang/Verlust/Hänger): Chance auf ein Zufalls-Event (race-free, synchron)
  if(roll && route==='fish' && game.state==='idle' && !document.querySelector('.overlay')) rollArrivalEvents();
}

function startCastAim(){
  game.state='aiming';
  { const sc=$('#scene'); if(sc) sc.classList.add('playing'); }   // aktives Spiel: Setup-Chips ausblenden
  game.followDone=false; game.pendingFollow=false; game.lureWork=0; game.castBottom=null;   // pro Wurf zurücksetzen
  { const sz=$('#spotzones'); if(sz) sz.style.display='block'; }
  renderCastShadows();   // Fischschatten je Zone (Menge & Größe als Hinweis)
  const spd=DIFFICULTY[S.difficulty].aimSpeed, base=20*spd, ang=Math.random()*6.283;
  game.tgt={ x:20+Math.random()*60, y:22+Math.random()*30, vx:Math.cos(ang)*base, vy:Math.sin(ang)*base*0.6 };
  game.castBig = hasGear('polbrille');   // Polbrille = größeres, leichter zu treffendes Ziel
  const hs=$('#hotspot'); hs.style.display='block'; hs.style.left=game.tgt.x+'%'; hs.style.bottom=game.tgt.y+'%';
  hs.style.transform='translate(-50%,50%) scale('+(game.castBig?1.7:1)+')';
  $('#actBtn').classList.add('hidden'); $('#idlebtns').classList.add('hidden'); { const eb=$('#echoBtn'); if(eb) eb.classList.add('hidden'); }
  setMsg('🎯 Triff den Fisch 🐟 – die Schatten zeigen, wo viele & große Fische stehen. Weite Würfe (Freiwasser) sind schwerer, bringen aber größere Fische!');
  game.tlast=performance.now(); sfx.whoosh();
  game.tRAF=requestAnimationFrame(castTargetLoop);
}
function castTargetLoop(now){
  if(!game||game.state!=='aiming') return;
  const dt=Math.min(0.05,(now-(game.tlast||now))/1000); game.tlast=now;
  const t=game.tgt;
  // Je weiter der Wurf (höher = Freiwasser), desto schneller & kleiner das Ziel
  const farT=Math.max(0,Math.min(1,(t.y-22)/32));
  const spd=DIFFICULTY[S.difficulty].aimSpeed, targetSpeed=20*spd*(1+farT*1.0);
  { let cur=Math.hypot(t.vx,t.vy); if(!(cur>0.001)){ const a=Math.random()*6.283; t.vx=Math.cos(a); t.vy=Math.sin(a)*0.6; cur=Math.hypot(t.vx,t.vy)||1; } const k=targetSpeed/cur; t.vx*=k; t.vy*=k; }   // Ziel bewegt sich immer (nie eingefroren)
  t.x+=t.vx*dt; t.y+=t.vy*dt;
  if(t.x<14){t.x=14;t.vx=Math.abs(t.vx);} if(t.x>86){t.x=86;t.vx=-Math.abs(t.vx);}
  if(t.y<20){t.y=20;t.vy=Math.abs(t.vy);} if(t.y>54){t.y=54;t.vy=-Math.abs(t.vy);}
  if(Math.random()<dt*0.7){ const sp=Math.hypot(t.vx,t.vy)||1, a=Math.random()*6.283; t.vx=Math.cos(a)*sp; t.vy=Math.sin(a)*sp*0.6; }
  const sizeMul=(game.castBig?1.7:1)*(1-farT*0.45);   // weit weg → kleineres Ziel
  game.castSizeMul=sizeMul;
  const hs=$('#hotspot'); hs.style.left=t.x+'%'; hs.style.bottom=t.y+'%'; hs.style.transform='translate(-50%,50%) scale('+sizeMul.toFixed(3)+')';
  game.tRAF=requestAnimationFrame(castTargetLoop);
}
function resolveCastTap(e){
  cancelAnimationFrame(game.tRAF); hideCastShadows();
  const r=$('#scene').getBoundingClientRect();
  const cx=(e.touches&&e.touches[0]?e.touches[0].clientX:e.clientX);
  const cy=(e.touches&&e.touches[0]?e.touches[0].clientY:e.clientY);
  const tapX=((cx-r.left)/r.width)*100, tapTop=((cy-r.top)/r.height)*100, tapBottom=100-tapTop;
  const dist=Math.hypot(tapX-game.tgt.x, tapBottom-game.tgt.y);
  const ct=DIFFICULTY[S.difficulty].castTol||1;
  const farT=Math.max(0,Math.min(1,(game.tgt.y-22)/32)), sizeF=1-farT*0.45;   // weiter Wurf → kleineres Ziel → weniger Toleranz
  const tol=(game.castBig?40:26)*ct*sizeF, snag=(game.castBig?44:30)*ct*sizeF;   // Polbrille + Schwierigkeit + Entfernung
  if(tapTop<40) return castSnag(pick(QUIPS.tree), Math.max(8,Math.min(92,tapX)), 58);
  if(tapTop>84) return castSnag(pick(QUIPS.bank), Math.max(8,Math.min(92,tapX)), 18);
  if(dist>snag) return castSnag(pick(QUIPS.bank), Math.max(8,Math.min(92,tapX)), Math.max(18,Math.min(56,tapBottom)));
  game.castScore=Math.max(0,Math.min(1,1-dist/tol));
  flyCast(Math.max(8,Math.min(92,tapX)), Math.max(18,Math.min(56,tapBottom)));
}
function castSnag(msg,left,bottom){
  game.state='snag';
  $('#hotspot').style.display='none'; { const sz=$('#spotzones'); if(sz) sz.style.display='none'; } hideCastShadows(); $('#actBtn').classList.add('hidden'); hideLine();
  const tip=rodTipPct(), b=$('#bobber'); b.style.display='block'; b.classList.remove('rest','bite');
  b.style.transition='none'; b.style.left=tip.x+'%'; b.style.bottom=(100-tip.y)+'%'; void b.offsetWidth;
  b.style.transition='left .5s ease-out, bottom .5s ease-out';
  b.style.left=left+'%'; b.style.bottom=bottom+'%';
  setLine(left,bottom);
  sfx.lose(); setMsg(msg);
  game.biteTimer=setTimeout(()=>armIdle(true),1700);
}
function spawnSplash(left,bottom){
  const sc=$('#scene'); const s=document.createElement('div'); s.className='splash';
  s.style.left=left+'%'; s.style.bottom=bottom+'%'; sc.appendChild(s);
  setTimeout(()=>s.remove(),950);
}
function flyCast(left,bottom){
  game.state='flying';
  $('#actBtn').classList.add('hidden'); $('#hotspot').style.display='none'; { const sz=$('#spotzones'); if(sz) sz.style.display='none'; } hideLine();
  const tip=rodTipPct(), b=$('#bobber'); b.style.display='block'; b.classList.remove('rest','bite');
  b.style.transition='none'; b.style.left=tip.x+'%'; b.style.bottom=(100-tip.y)+'%';
  void b.offsetWidth;
  b.style.transition='left .55s ease-out, bottom .55s cubic-bezier(.3,-0.35,.6,1)';
  b.style.left=left+'%'; b.style.bottom=bottom+'%';
  sfx.cast();
  setTimeout(()=>{
    game.land={left,bottom}; game.castBottom=bottom; setLine(left,bottom);
    spawnSplash(left,bottom); sfx.splash();
    const cs=game.castScore, spn=spotName(bottom);
    const farT=Math.max(0,Math.min(1,(bottom-30)/26));   // weit draußen (Freiwasser) → größere Fische
    const bigWord=farT>0.5?'großen ':'';
    let ft,fc,chance;
    if(cs>=0.85){ setMsg('🎯 PERFEKTER WURF – '+spn+'!'); sfx.perfect(); ft='🎯 Perfekter Wurf!'; fc='var(--accent2)'; chance='Top-Chance auf einen '+bigWord+'Fisch!'; }
    else if(cs>=0.6){ setMsg('👍 Guter Wurf – '+spn+'.'); ft='👍 Guter Wurf!'; fc='#9fe06a'; chance='gute Chance auf einen '+bigWord+'Fisch'; }
    else if(cs>=0.35){ setMsg('🆗 Solider Wurf – '+spn+'.'); ft='🆗 Solider Wurf'; fc='var(--gold)'; chance='mäßige Chance auf einen Fisch'; }
    else { setMsg('💨 Weit am Fisch vorbei – '+spn+'.'); ft='💨 Weit daneben'; fc='var(--danger)'; chance='schlechtere Chance – beim nächsten Wurf genauer treffen!'; }
    // Wurf-Feedback im „Drill, Baby, drill"-Stil: Spot-Treffer & Auswirkung auf die Fang-Chance
    flashBig(ft+' · '+spn,fc,'29%',1700);
    setTimeout(()=>{ if(game&&game.state==='flying') flashBig('📈 '+chance, fc, '44%', 1600); }, 700);
    setTimeout(beginWait,1350);
  },560);
}
function beginWait(){
  if(!game||game.state!=='flying') return;
  game.state='waiting';
  $('#scene').classList.add('waiting');
  $('#hotspot').style.display='none';
  $('#bobber').classList.add('rest');
  const {out,sum}=biteWeights();
  if(sum<=0){
    game.biteTimer=setTimeout(()=>{ if(game.state!=='waiting')return;
      $('#scene').classList.remove('waiting'); setMsg('🚫 Hier beißt unter diesen Bedingungen nichts. Köder/Zeit/Wetter ändern!'); armIdle(true); },1400);
    return;
  }
  if(game.castScore<0.15 && Math.random()<0.55){
    game.biteTimer=setTimeout(()=>{ if(game.state!=='waiting')return;
      $('#scene').classList.remove('waiting'); setMsg('🪨 Der Wurf landete im Niemandsland – nichts rührt sich. Neu auswerfen!'); armIdle(true); },1700);
    return;
  }
  game.bw={out,sum};
  const attract=Math.min(2.4,sum/40)*(0.55+game.castScore*0.95)*(1+(game.echoBonus||0)*0.6);   // Echolot → schnellerer Biss
  game.retrWait=(900+Math.random()*3000/Math.max(0.4,attract))*2 + 2000;   // mehr Zeit für die Köderführung (+2 s)
  // Sanfter Übergang: Köderführung erst per Klick starten (Biss-Timer läuft erst dann)
  game.state='toretrieve';
  setMsg('🎣 Köder liegt im Wasser – tippe „Köderführung starten"!');
  showCenter('🎣 Köderführung starten','');
}
function beginRetrieve(){
  if(!game||game.state!=='toretrieve') return;
  hideCenter(); game.state='waiting';
  game.biteTimer=setTimeout(()=>triggerBite(game.bw.out,game.bw.sum), game.retrWait||3000);
  startRetrieve();   // Köderführung-Minispiel (additiv – Bonus, Biss kommt auch ohne Mitwirken)
}
/* ---- Köderführung: je nach Ködertyp ein anderes Minispiel ---- */
function startRetrieve(){
  const ltype=LURETYPE[S.lure];
  if(ltype==='craw') return startCrawGame();    // Krebs: Jump & Run (immer)
  // Gummifisch/Hardbait/Blech: 50% das köderspezifische Spiel, 50% das klassische Dart-Spiel (wie beim Naturköder)
  if(ltype==='soft'||ltype==='hard'||ltype==='blade'){
    if(Math.random()<0.5) return startDartGame();
    if(ltype==='soft') return startWeedGame();    // Gummifisch: durch Steine & Kraut navigieren
    if(ltype==='hard') return startRhythmGame();  // Hardbait: Lauftiefe auf Höhe des Fisches halten
    return startBladeGame();                       // Blech: HUGO-Style – Hindernissen ausweichen
  }
  startDartGame();                               // Naturköder: bestehende Dartscheibe
}
/* ---- Köderführung (Dartscheibe): driftenden Köder mit Maus/Finger in der Mitte halten ---- */
function startDartGame(){
  game.lureWork=0;
  const lc=$('#lurecircle'); if(lc){ lc.style.display='block'; const f=$('#lcfish'); if(f) f.textContent=LURES[S.lure].ic; }
  showHead('🎣 Köderführung', IS_TOUCH?'Steuerpunkt (✛) schwebt über deinem Finger – halt ihn in der Mitte':'Halte den Köder in der Mitte des Kreises');
  { const ring=$('#lurecircle .lc-ring'), pz=DIFFICULTY[S.difficulty].lureZone||0.30; if(ring){ ring.style.width=(pz*200)+'%'; ring.style.height=(pz*200)+'%'; } }
  game.lc={ px:0, py:0, vx:0, vy:0, dax:0, day:0, nextDrift:0 };
  game.cursor=null; game.lureMoved=false;   // bis zur ersten Bewegung: Mitte
  { const cc=$('#lccursor'); if(cc){ cc.style.left='50%'; cc.style.top='50%'; } }
  $('#actBtn').classList.add('hidden');   // Steuerung per Cursor, kein Button nötig
  setMsg('🎣 Köderführung: ziehe den driftenden Köder mit Maus/Finger in die Mitte des Kreises – innen = perfekt!');
  game.lureMove=(e)=>{ const el=$('#lurecircle'); if(!el) return; const r=el.getBoundingClientRect(); const R=r.width/2; if(R<=0) return;
    const touch=(e.pointerType==='touch')||!!(e.touches&&e.touches.length);
    const cx=(e.touches&&e.touches[0]?e.touches[0].clientX:e.clientX); let cy=(e.touches&&e.touches[0]?e.touches[0].clientY:e.clientY);
    if(cx==null) return; if(touch) cy-=R*0.95;   // Touch: Steuerpunkt über dem Finger – Finger verdeckt die Zielscheibe nicht
    game.cursor={ x:(cx-(r.left+R))/R, y:(cy-(r.top+R))/R }; game.lureMoved=true; };
  const sc=$('#scene'); sc.addEventListener('pointermove',game.lureMove); sc.addEventListener('pointerdown',game.lureMove); sc.addEventListener('touchmove',game.lureMove,{passive:true}); sc.addEventListener('touchstart',game.lureMove,{passive:true});
  game.retrLast=performance.now();
  game.retrRAF=requestAnimationFrame(retrieveLoop);
}
function retrieveLoop(now){
  if(!game||game.state!=='waiting'){ return; }
  const lc=game.lc; if(!lc){ return; }
  const dt=Math.min(0.05,(now-(game.retrLast||now))/1000); game.retrLast=now;
  const spd=DIFFICULTY[S.difficulty].aimSpeed;
  // Drift-Impulse, leicht nach außen gerichtet, wechselnde Richtung & Tempo
  if(now>lc.nextDrift){
    const outAng=(lc.px||lc.py)?Math.atan2(lc.py,lc.px):Math.random()*6.283;
    const ang=(Math.random()<0.6)? outAng+(Math.random()-0.5)*1.7 : Math.random()*6.283;
    const mag=(15+Math.random()*15)*spd;   // schnellerer Drift → anspruchsvoller
    lc.dax=Math.cos(ang)*mag; lc.day=Math.sin(ang)*mag;
    lc.nextDrift=now+(280+Math.random()*440)/spd;   // häufiger neue Richtung
  }
  const cur=game.cursor||{x:0,y:0}, PULL=24;
  lc.vx+=((cur.x-lc.px)*PULL+lc.dax)*dt; lc.vy+=((cur.y-lc.py)*PULL+lc.day)*dt;
  const damp=Math.min(1,7*dt); lc.vx-=lc.vx*damp; lc.vy-=lc.vy*damp;
  lc.px+=lc.vx*dt; lc.py+=lc.vy*dt;
  const dist=Math.hypot(lc.px,lc.py);
  if(dist>1.7){ const k=1.7/dist; lc.px*=k; lc.py*=k; lc.vx*=0.4; lc.vy*=0.4; }
  const f=$('#lcfish'); if(f){ f.style.left=(50+lc.px*50)+'%'; f.style.top=(50+lc.py*50)+'%'; }
  // Cursor-Reticle + Verbindungslinie (zeigt: du steuerst den Köder)
  const cc=$('#lccursor'); if(cc){ cc.style.left=(50+cur.x*50)+'%'; cc.style.top=(50+cur.y*50)+'%'; }
  const ln=$('#lcline'); if(ln){ ln.setAttribute('x1',50+cur.x*50); ln.setAttribute('y1',50+cur.y*50); ln.setAttribute('x2',50+lc.px*50); ln.setAttribute('y2',50+lc.py*50); }
  let rate,label,color;
  const pz=DIFFICULTY[S.difficulty].lureZone||0.30;
  if(dist<=pz){ rate=0.5; label='🎯 PERFEKT'; color='var(--accent2)'; }
  else if(dist<=pz+0.32){ rate=0.30; label='👍 Gut'; color='#9fe06a'; }
  else if(dist<=1.0){ rate=0.10; label='🆗 Ok'; color='var(--gold)'; }
  else { rate=-0.4; label='✖ Daneben – zur Mitte!'; color='var(--danger)'; }
  game.lureWork=Math.max(0,Math.min(1,(game.lureWork||0)+rate*dt));
  setMsg('🎣 Köderführung – '+label+' · '+Math.round(game.lureWork*100)+'%');
  if(rate>=0.5 && Math.random()<dt*4) sfx.netfill(game.lureWork);
  if((game.lureWork||0)>=1){ clearTimeout(game.biteTimer); cancelAnimationFrame(game.retrRAF); triggerBite(game.bw.out,game.bw.sum); return; }
  game.retrRAF=requestAnimationFrame(retrieveLoop);
}
/* ===== Aufräumen & kleiner Punkte-Flash für die Köder-Minispiele ===== */
function endRetMini(){
  cancelAnimationFrame(game.retrRAF);
  const rm=$('#retmini'); if(rm){ rm.style.display='none'; rm.innerHTML=''; }
  const sc=$('#scene');
  ['lureMove','miniTap','miniMove','miniUp'].forEach(h=>{ const fn=game[h]; if(fn&&sc){ ['click','pointermove','pointerdown','pointerup','pointercancel','touchmove','touchstart','touchend'].forEach(ev=>sc.removeEventListener(ev,fn)); } game[h]=null; });
  if(game.miniKey){ window.removeEventListener('keydown',game.miniKey); game.miniKey=null; }
  if(game.miniKeyUp){ window.removeEventListener('keyup',game.miniKeyUp); game.miniKeyUp=null; }
  game.mini=null;
}
function rmFlash(rm,x,y,txt,col){ if(!rm) return; const d=document.createElement('div'); d.className='rm-flash'; d.textContent=txt; d.style.left=x+'%'; d.style.top=y+'%'; d.style.color=col||'#fff'; rm.appendChild(d); setTimeout(()=>{ if(d.parentNode) d.remove(); },520); }

/* ===== 🦀 Krebs: Jump & Run – im richtigen Moment über Hindernisse springen ===== */
function startCrawGame(){
  game.lureWork=0; $('#actBtn').classList.add('hidden');
  showHead('🦀 Krebs führen', IS_TOUCH?'Tippen = Sprung · gedrückt halten = höher · kurz tippen = flacher & schneller':'Tippen/Leertaste = Sprung · gedrückt halten = höher · kurz = flacher & schneller');
  setMsg('🦀 Lass den Krebs über die Hindernisse springen – halten = höher, kurz = schneller!');
  const rm=$('#retmini'); rm.style.display='block';
  rm.innerHTML='<div class="rm-ground" style="top:66%"></div><div class="rm-actor" id="rmCraw" style="left:18%;top:64%">🦀</div>';
  game.mini={type:'craw', jy:0, vy:0, onGround:true, holding:false, obs:[], spawnT:performance.now()+650, cleared:0, spawned:0, goal:30};
  game.miniTap=(e)=>{ if(e.target&&(e.target.closest('.hud')||e.target.closest('.hudtop'))) return; crawJump(); };
  game.miniUp=()=>crawRelease();
  game.miniKey=(e)=>{ if(e.code==='Space'){ if(!e.repeat) crawJump(); e.preventDefault(); } };
  game.miniKeyUp=(e)=>{ if(e.code==='Space'){ crawRelease(); e.preventDefault(); } };
  const sc=$('#scene'); sc.addEventListener('pointerdown',game.miniTap); sc.addEventListener('pointerup',game.miniUp); sc.addEventListener('pointercancel',game.miniUp); sc.addEventListener('touchend',game.miniUp,{passive:true});
  window.addEventListener('keydown',game.miniKey); window.addEventListener('keyup',game.miniKeyUp);
  if(game.bw){ clearTimeout(game.biteTimer); game.biteTimer=setTimeout(crawFinish, 30000); }   // längeres Spiel (genug Zeit für 30 Hindernisse), danach Ergebnis & Biss
  game.retrLast=performance.now(); game.retrRAF=requestAnimationFrame(crawLoop);
}
function crawJump(){ const m=game.mini; if(m&&m.type==='craw'&&!m.done&&m.onGround){ m.vy=70; m.onGround=false; m.holding=true; if(sfx.whoosh)sfx.whoosh(); vib(15); } }
function crawRelease(){ const m=game.mini; if(m&&m.type==='craw') m.holding=false; }   // loslassen → Sprung wird gekappt (flacher)
/* Gemeinsamer Abschluss aller Köder-Minispiele: kurz das Ergebnis einblenden, dann den Biss auslösen.
   Bewertung anteilig (cleared/goal): 100% / ≥80% / ≥60% / ≥35% / darunter. opts.trophy → bei 100% Trophy-Chance. */
function retrMiniFinish(cleared, goal, headline, opts){
  opts=opts||{};
  const m=game.mini; if(!m||m.done) return; m.done=true;
  cancelAnimationFrame(game.retrRAF); clearTimeout(game.biteTimer);
  const pct=goal>0?cleared/goal:0;
  let verdict,col;
  if(pct>=1){ verdict=opts.trophy?'Perfekte Köderführung – die Chance auf einen Trophy-Fisch steigt deutlich! 🏆':'Perfektes Laufverhalten – Top-Chance auf einen kapitalen Fisch!'; col='var(--accent2)'; if(opts.trophy) S.nextBigFish=true; }
  else if(pct>=0.8){ verdict='Sehr gute Köderführung – starke Chance auf einen kapitalen Fisch!'; col='var(--accent2)'; }
  else if(pct>=0.6){ verdict='Gute Köderführung – gute Chancen auf einen guten Fisch.'; col='#9fe06a'; }
  else if(pct>=0.35){ verdict='Solide geführt – ein ordentlicher Fisch ist drin.'; col='var(--gold)'; }
  else { verdict='Da war zu viel Hektik – eher ein kleiner Fisch.'; col='var(--danger)'; }
  flashBig(headline,col,'29%',2000);
  setTimeout(()=>{ if(game&&game.state==='waiting') flashBig(verdict,col,'44%',1800); },780);
  setMsg(headline+' – '+verdict);
  if(game.bw){ game.biteTimer=setTimeout(()=>triggerBite(game.bw.out,game.bw.sum), 2100); }
}
/* Ende des Krebs-Spiels (Krebs = Trophy-Spezialist) */
function crawFinish(){
  const m=game.mini; if(!m||m.type!=='craw'||m.done) return;
  retrMiniFinish(m.cleared||0, m.goal||20, '🦀 '+(m.cleared||0)+'/'+(m.goal||20)+' Hindernisse gemeistert', {trophy:true});
}
function crawLoop(now){
  if(!game||game.state!=='waiting'||!game.mini||game.mini.type!=='craw'||game.mini.done) return;
  const dt=Math.min(0.05,(now-(game.retrLast||now))/1000); game.retrLast=now;
  const m=game.mini, rm=$('#retmini'); if(!rm) return;
  const spd=DIFFICULTY[S.difficulty].aimSpeed;
  if(!m.onGround){
    const g=(m.holding&&m.vy>0)?80:(m.vy>0?300:200);   // halten & steigend → floatig/höher · losgelassen → flacher · fallend → zügig
    m.vy-=g*dt; m.jy+=m.vy*dt;
    if(m.jy<=0){ m.jy=0; m.vy=0; m.onGround=true; m.holding=false; }
  }
  const fast=m.spawned>=5, faster=m.spawned>=15;   // ab dem 5. schneller, ab dem 15. nochmals schneller & dichter → bleibt fordernd
  if(now>=m.spawnT){ const o={x:106,passed:false}; const el=document.createElement('div'); el.className='rm-obs'; el.textContent=(Math.random()<0.5?'🪨':'🌿'); el.style.top='64%'; el.style.left='106%'; rm.appendChild(el); o.el=el; m.obs.push(o); m.spawned++;
    m.spawnT=now+((faster?560:fast?720:1080)+Math.random()*(faster?300:fast?380:560))/spd; }
  const obsSpeed=(faster?70:fast?58:42)*spd;
  for(const o of m.obs){ o.x-=obsSpeed*dt; if(o.el) o.el.style.left=o.x+'%';
    if(!o.passed && o.x<=19.5){ o.passed=true;
      if(m.jy>5){ m.cleared++; game.lureWork=Math.min(1,m.cleared/m.goal); if(sfx.netfill)sfx.netfill(game.lureWork); rmFlash(rm,o.x,53,'＋ '+m.cleared,'var(--accent2)');
        if(m.cleared>=m.goal){ crawFinish(); return; } }
      else { if(sfx.lose)sfx.lose(); rmFlash(rm,18,53,'✖','var(--danger)'); } } }
  m.obs=m.obs.filter(o=>{ if(o.x<-8){ if(o.el) o.el.remove(); return false; } return true; });
  const cr=$('#rmCraw'); if(cr) cr.style.top=(64-m.jy)+'%';
  setMsg('🦀 Übersprungen: '+m.cleared+'/'+m.goal+' · '+Math.round((game.lureWork||0)*100)+'%');
  game.retrRAF=requestAnimationFrame(crawLoop);
}

/* ===== 🐟 Gummifisch: durch Steine & Kraut navigieren (ausweichen) ===== */
function startWeedGame(){
  game.lureWork=0; $('#actBtn').classList.add('hidden');
  showHead('🐟 Gummifisch führen', IS_TOUCH?'Köder mit dem Finger hoch/runter bewegen – Steinen & Kraut ausweichen':'Köder mit der Maus hoch/runter führen – Steinen & Kraut ausweichen');
  setMsg('🐟 Navigiere den Köder durch die Hindernisse!');
  const rm=$('#retmini'); rm.style.display='block';
  rm.innerHTML='<div class="rm-hitbox" id="rmLureBox" style="position:absolute;left:22%;top:56%;width:42px;height:26px;transform:translate(-50%,-50%);border:2px dashed rgba(120,235,120,.75);border-radius:9px;z-index:3;pointer-events:none;box-sizing:border-box"></div><div class="rm-actor" id="rmLure" style="left:22%;top:56%">'+lureGlyph('soft')+'</div>';
  game.mini={type:'weed', ly:56, ty:56, obs:[], spawnT:performance.now()+550, dodged:0, spawned:0, goal:30};
  game.miniMove=(e)=>{ const r=$('#scene').getBoundingClientRect(); const t=e.touches&&e.touches[0]; const cy=(t?t.clientY:e.clientY); if(cy==null) return; let y=((cy-r.top)/r.height)*100; game.mini.ty=Math.max(46,Math.min(67,y)); };
  const sc=$('#scene'); sc.addEventListener('pointermove',game.miniMove); sc.addEventListener('pointerdown',game.miniMove); sc.addEventListener('touchmove',game.miniMove,{passive:true}); sc.addEventListener('touchstart',game.miniMove,{passive:true});
  if(game.bw){ clearTimeout(game.biteTimer); game.biteTimer=setTimeout(weedFinish, 30000); }   // längeres Spiel (genug Zeit für 30 Objekte), danach Ergebnis & Biss
  game.retrLast=performance.now(); game.retrRAF=requestAnimationFrame(weedLoop);
}
function weedFinish(){ const m=game.mini; if(!m||m.type!=='weed'||m.done) return; retrMiniFinish(m.dodged||0, m.goal||20, '🐟 '+(m.dodged||0)+'/'+(m.goal||20)+' Hindernissen ausgewichen'); }
function weedLoop(now){
  if(!game||game.state!=='waiting'||!game.mini||game.mini.type!=='weed'||game.mini.done) return;
  const dt=Math.min(0.05,(now-(game.retrLast||now))/1000); game.retrLast=now;
  const m=game.mini, rm=$('#retmini'); if(!rm) return;
  const spd=DIFFICULTY[S.difficulty].aimSpeed;
  m.ly+=(m.ty-m.ly)*Math.min(1,12*dt);
  if(now>=m.spawnT){ const o={x:106,y:46+Math.random()*21,hitFlag:false,scored:false}; const el=document.createElement('div'); el.className='rm-obs'; el.textContent=(Math.random()<0.5?'🪨':'🌿'); el.style.left='106%'; el.style.top=o.y+'%'; rm.appendChild(el); o.el=el; m.obs.push(o); m.spawned++;
    m.spawnT=now+Math.max(340,(620-(m.spawned*14))+Math.random()*320)/spd; }   // deutlich dichtere Objektfolge, wird mit der Zeit noch enger
  const obsSpeed=(48+Math.min(m.spawned,30)*1.7)*spd;   // Geschwindigkeit steigt mit jedem Objekt
  const lb=$('#rmLureBox'); if(lb) lb.style.top=m.ly+'%'; const lbr=lb?lb.getBoundingClientRect():null;
  let hit=false;
  for(const o of m.obs){ o.x-=obsSpeed*dt; if(o.el) o.el.style.left=o.x+'%';
    if(rectHit(o.el, lbr, 5)){ hit=true; o.hitFlag=true; }   // echte Pixel-Überlappung mit der sichtbaren Hitbox
    if(!o.scored && o.x<=15.5){ o.scored=true;
      if(!o.hitFlag){ m.dodged++; game.lureWork=Math.min(1,m.dodged/m.goal); if(sfx.netfill)sfx.netfill(game.lureWork); rmFlash(rm,18,48,'＋ '+m.dodged,'var(--accent2)');
        if(m.dodged>=m.goal){ weedFinish(); return; } }
      else { if(sfx.lose)sfx.lose(); } } }
  m.obs=m.obs.filter(o=>{ if(o.x<-8){ if(o.el) o.el.remove(); return false; } return true; });
  if(lb) lb.style.borderColor=hit?'rgba(224,83,61,.95)':'rgba(120,235,120,.75)';
  const lu=$('#rmLure'); if(lu){ lu.style.top=m.ly+'%'; lu.style.filter=hit?'drop-shadow(0 0 7px #e0533d)':'drop-shadow(0 2px 4px #000)'; }
  setMsg('🐟 Ausgewichen: '+m.dodged+'/'+m.goal+(hit?' · ✖ Achtung!':'')+' · '+Math.round((game.lureWork||0)*100)+'%');
  game.retrRAF=requestAnimationFrame(weedLoop);
}

/* ===== 🎣 Hardbait „Lauftiefe": Wobbler per Halten/Loslassen auf Tiefe des jagenden Fisches halten ===== */
function startRhythmGame(){
  game.lureWork=0; $('#actBtn').classList.add('hidden');
  showHead('🎣 Hardbait führen', IS_TOUCH?'Halten = Wobbler steigt · loslassen = sinkt – bleib auf Höhe des Fisches':'Halten (Maus/Leertaste) = Wobbler steigt · loslassen = sinkt – bleib auf Höhe des Fisches');
  setMsg('🎣 Halte den Wobbler in der grünen Reiz-Zone auf Tiefe des Fisches – so reizt du ihn zum Biss!');
  const rm=$('#retmini'); rm.style.display='block';
  rm.innerHTML='<div id="rmZone" style="position:absolute;left:0;width:100%;height:18%;top:46%;transform:translateY(-50%);background:rgba(120,235,120,.16);border-top:2px dashed rgba(120,235,120,.55);border-bottom:2px dashed rgba(120,235,120,.55);z-index:1;pointer-events:none"></div>'
    +'<div class="rm-actor" id="rmFish" style="left:72%;top:46%;font-size:36px;z-index:2">🐟</div>'
    +'<div class="rm-actor" id="rmHard" style="left:28%;top:55%;z-index:4">'+lureGlyph('hard')+'</div>';
  game.mini={type:'hard', ly:55, vy:0, reeling:false, fishY:46, fishTarget:46, fishT:performance.now()+1500, reiz:0, goal:24, zoneT:0};
  game.miniTap=(e)=>{ if(e.target&&(e.target.closest('.hud')||e.target.closest('.hudtop'))) return; rhythmPress(); };
  game.miniUp=()=>rhythmRelease();
  game.miniKey=(e)=>{ if(e.code==='Space'){ if(!e.repeat) rhythmPress(); e.preventDefault(); } };
  game.miniKeyUp=(e)=>{ if(e.code==='Space'){ rhythmRelease(); e.preventDefault(); } };
  const sc=$('#scene'); sc.addEventListener('pointerdown',game.miniTap); sc.addEventListener('pointerup',game.miniUp); sc.addEventListener('pointercancel',game.miniUp); sc.addEventListener('touchend',game.miniUp,{passive:true});
  window.addEventListener('keydown',game.miniKey); window.addEventListener('keyup',game.miniKeyUp);
  if(game.bw){ clearTimeout(game.biteTimer); game.biteTimer=setTimeout(rhythmFinish, 30000); }   // festes, längeres Spiel; danach Ergebnis & Biss
  game.retrLast=performance.now(); game.retrRAF=requestAnimationFrame(rhythmLoop);
}
function rhythmPress(){ const m=game.mini; if(m&&m.type==='hard'&&!m.done) m.reeling=true; }
function rhythmRelease(){ const m=game.mini; if(m&&m.type==='hard') m.reeling=false; }
function rhythmFinish(){ const m=game.mini; if(!m||m.type!=='hard'||m.done) return; retrMiniFinish(m.reiz||0, m.goal||24, '🎣 '+(m.reiz||0)+'/'+(m.goal||24)+' Reiz-Treffer'); }
function rhythmLoop(now){
  if(!game||game.state!=='waiting'||!game.mini||game.mini.type!=='hard'||game.mini.done) return;
  const dt=Math.min(0.05,(now-(game.retrLast||now))/1000); game.retrLast=now;
  const m=game.mini, rm=$('#retmini'); if(!rm) return;
  const spd=DIFFICULTY[S.difficulty].aimSpeed;
  // Köder-Physik: Halten = Auftrieb (steigt), sonst sinken; mit Dämpfung & Begrenzung → gut steuerbar
  const acc=(m.reeling? -130 : 60);
  m.vy+=acc*dt; m.vy*=Math.max(0,1-2.4*dt); m.vy=Math.max(-30,Math.min(30,m.vy));
  m.ly+=m.vy*dt; if(m.ly<30){m.ly=30;m.vy=0;} if(m.ly>70){m.ly=70;m.vy=0;}
  // Der Fisch wechselt die Tiefe – ihm folgen!
  if(now>=m.fishT){ m.fishTarget=34+Math.random()*30; m.fishT=now+(1000+Math.random()*1300)/spd; }
  m.fishY+=(m.fishTarget-m.fishY)*Math.min(1,1.7*dt*spd);
  const tol=Math.max(5, 9-(m.reiz||0)*0.12);   // Reiz-Zone wird mit der Zeit etwas enger → schwerer
  const zone=$('#rmZone'); if(zone){ zone.style.top=m.fishY+'%'; zone.style.height=(tol*2)+'%'; }
  const fe=$('#rmFish'); if(fe) fe.style.top=m.fishY+'%';
  const inZone=Math.abs(m.ly-m.fishY)<tol;
  if(inZone){ m.zoneT=(m.zoneT||0)+dt;
    if(m.zoneT>=0.34){ m.zoneT-=0.34; m.reiz=(m.reiz||0)+1; game.lureWork=Math.min(1,m.reiz/m.goal); if(sfx.netfill)sfx.netfill(game.lureWork); rmFlash(rm,30,m.ly,'✨ '+m.reiz,'var(--accent2)'); vib(8);
      if(m.reiz>=m.goal){ rhythmFinish(); return; } } }
  else { m.zoneT=0; }
  if(zone) zone.style.background=inZone?'rgba(120,235,120,.28)':'rgba(120,235,120,.10)';
  const hd=$('#rmHard'); if(hd){ hd.style.top=m.ly+'%'; hd.style.filter=inZone?'drop-shadow(0 0 9px #43d57e)':'drop-shadow(0 2px 4px #000)'; }
  if(fe) fe.style.filter=inZone?'drop-shadow(0 0 9px #43d57e)':'none';
  setMsg(inZone?('🎣 In der Reiz-Zone! '+(m.reiz||0)+'/'+m.goal):('🎣 Auf Tiefe des Fisches gehen … '+(m.reiz||0)+'/'+m.goal));
  game.retrRAF=requestAnimationFrame(rhythmLoop);
}

/* ===== 🌀 Blech (Blinker/Spinner): „HUGO"-Style – Hindernissen ausweichen (Perspektive hinter dem Köder) ===== */
function startBladeGame(){
  game.lureWork=0; $('#actBtn').classList.add('hidden');
  showHead('🌀 Blech führen', IS_TOUCH?'Köder mit dem Finger nach links/rechts steuern – weiche aus':'Köder mit Maus oder ← → steuern – weiche den Hindernissen aus');
  setMsg('🌀 Steuere den Köder und weiche den Hindernissen aus – für perfektes Laufverhalten!');
  const rm=$('#retmini'); rm.style.display='block';
  rm.innerHTML='<div class="rm-vp"></div><div class="rm-hitbox" id="rmBladeBox" style="position:absolute;left:50%;top:82%;width:30px;height:40px;transform:translate(-50%,-50%);border:2px dashed rgba(120,235,120,.75);border-radius:9px;z-index:3;pointer-events:none;box-sizing:border-box"></div><div class="rm-actor" id="rmBlade" style="left:50%;top:82%">'+lureGlyph('blade')+'</div>';
  game.mini={type:'blade', lx:50, tx:50, obs:[], spawnT:performance.now()+450, avoided:0, goal:30};
  game.miniMove=(e)=>{ const r=$('#scene').getBoundingClientRect(); const t=e.touches&&e.touches[0]; const cx=(t?t.clientX:e.clientX); if(cx==null) return; game.mini.tx=Math.max(12,Math.min(88,((cx-r.left)/r.width)*100)); };
  game.miniKey=(e)=>{ const m=game.mini; if(!m) return; if(e.code==='ArrowLeft'){ m.tx=Math.max(12,m.tx-13); e.preventDefault(); } else if(e.code==='ArrowRight'){ m.tx=Math.min(88,m.tx+13); e.preventDefault(); } };
  const sc=$('#scene'); sc.addEventListener('pointermove',game.miniMove); sc.addEventListener('pointerdown',game.miniMove); sc.addEventListener('touchmove',game.miniMove,{passive:true}); sc.addEventListener('touchstart',game.miniMove,{passive:true});
  window.addEventListener('keydown',game.miniKey);
  if(game.bw){ clearTimeout(game.biteTimer); game.biteTimer=setTimeout(bladeFinish, 30000); }   // festes, längeres Spiel; danach Ergebnis & Biss
  game.retrLast=performance.now(); game.retrRAF=requestAnimationFrame(bladeLoop);
}
function bladeFinish(){ const m=game.mini; if(!m||m.type!=='blade'||m.done) return; retrMiniFinish(m.avoided||0, m.goal||18, '🌀 '+(m.avoided||0)+'/'+(m.goal||18)+' Hindernissen ausgewichen'); }
function bladeLoop(now){
  if(!game||game.state!=='waiting'||!game.mini||game.mini.type!=='blade'||game.mini.done) return;
  const dt=Math.min(0.05,(now-(game.retrLast||now))/1000); game.retrLast=now;
  const m=game.mini, rm=$('#retmini'); if(!rm) return;
  const spd=DIFFICULTY[S.difficulty].aimSpeed;
  m.lx+=(m.tx-m.lx)*Math.min(1,14*dt);
  const VPX=50, VPY=44, PY=82;   // Fluchtpunkt (oben mittig) → Spielerebene (unten)
  if(now>=m.spawnT){ const o={lane:14+Math.random()*72, z:0, done:false}; const el=document.createElement('div'); el.className='rm-obs'; el.textContent=(Math.random()<0.5?'🪨':'🌿'); rm.appendChild(el); o.el=el; m.obs.push(o); m.spawnT=now+(Math.max(300,640-(m.avoided||0)*16)+Math.random()*320)/spd; }   // noch dichtere Objektfolge, wird mit der Zeit enger
  const zspeed=(0.54+Math.min(m.avoided||0,30)*0.015)*spd; let hitNow=false;   // schneller herankommend, steigert sich je mehr man schafft
  const bb=$('#rmBladeBox'); if(bb) bb.style.left=m.lx+'%'; const bbr=bb?bb.getBoundingClientRect():null;
  for(const o of m.obs){ o.z+=zspeed*dt;
    const x=VPX+(o.lane-VPX)*o.z, y=VPY+(PY-VPY)*o.z, sc2=0.3+o.z*1.3;
    if(o.el){ o.el.style.left=x+'%'; o.el.style.top=y+'%'; o.el.style.fontSize=Math.round(18*sc2)+'px'; o.el.style.opacity=Math.min(1,0.4+o.z).toFixed(2); }
    if(!o.done){
      if(o.z>=0.8 && rectHit(o.el, bbr, 4)){ o.done=true; hitNow=true; game.lureWork=Math.max(0,(game.lureWork||0)-0.14); if(sfx.lose)sfx.lose(); rmFlash(rm,x,76,'✖','var(--danger)'); }   // echte Pixel-Überlappung mit der sichtbaren Hitbox
      else if(o.z>1.12){ o.done=true; m.avoided=(m.avoided||0)+1; game.lureWork=Math.min(1,(game.lureWork||0)+0.13); if(sfx.netfill)sfx.netfill(game.lureWork); rmFlash(rm,m.lx,76,'＋ '+m.avoided,'var(--accent2)');
        if(m.avoided>=m.goal){ bladeFinish(); return; } } } }
  m.obs=m.obs.filter(o=>{ if(o.z>1.22){ if(o.el) o.el.remove(); return false; } return true; });
  if(bb) bb.style.borderColor=hitNow?'rgba(224,83,61,.95)':'rgba(120,235,120,.75)';
  const bl=$('#rmBlade'); if(bl){ bl.style.left=m.lx+'%'; bl.style.filter=hitNow?'drop-shadow(0 0 8px #e0533d)':'drop-shadow(0 2px 4px #000)'; }
  setMsg('🌀 Ausgewichen: '+(m.avoided||0)+'/'+m.goal+' · '+Math.round((game.lureWork||0)*100)+'%');
  game.retrRAF=requestAnimationFrame(bladeLoop);
}
function pickFish(out,sum){
  let r=Math.random()*sum;
  for(const [sp,v] of Object.entries(out)){ if(v<=0)continue; r-=v; if(r<=0) return sp; }
  return Object.keys(out).find(k=>out[k]>0);
}
function triggerBite(out,sum){
  if(!game||game.state!=='waiting') return;
  cancelAnimationFrame(game.retrRAF); const lb=$('#lurecircle'); if(lb) lb.style.display='none';
  { const hd=$('#lchead'); if(hd) hd.style.display='none'; }
  endRetMini();   // Ködertyp-Minispiele aufräumen (Krebs/Gummifisch/Hardbait)
  // Köderführungs-Ergebnis kurz aufblitzen lassen
  { const lw=game.lureWork||0; let t,c;
    if(lw>=0.8){ t='🎯 Perfekte Köderführung!'; c='var(--accent2)'; }
    else if(lw>=0.5){ t='👍 Gute Köderführung'; c='#9fe06a'; }
    else if(lw>=0.2){ t='🆗 Okay geführt'; c='var(--gold)'; }
    else { t='💩 Köderführung verkackt'; c='var(--danger)'; }
    flashBig(t,c); }
  game.species=pickFish(out,sum);
  game.state='presink';
  $('#actBtn').classList.add('hidden');
  // Nachläufer? Erst nach Bestätigung starten – nie mitten im Köder-Minispiel
  if(!game.followDone && Math.random()<followChance(game.species)){
    game.pendingFollow=true;
    setMsg('👀 Ein Fisch ist deinem Köder gefolgt! Tippe „Nachläufer reizen", um ihn zu führen.');
    showCenter('👀 Nachläufer reizen','');
    return;
  }
  // Köderführung beendet – es geht erst nach einem Klick weiter (keine Hektik vor dem Anhieb)
  setMsg('🎣 Köderführung beendet. Tippe „Köder präsentieren" in der Mitte.');
  showCenter('🎣 Köder präsentieren','');
  // Nach dem Ergebnis-Flash: Hinweis, wie die Köderführung die Fang-Chance beeinflusst (Stil „Drill, Baby, drill")
  { const lw=game.lureWork||0; let ct,cc;
    if(lw>=0.8){ ct='📈 Stark gereizt – die Chance auf einen kapitalen Fisch ist deutlich gestiegen!'; cc='var(--accent2)'; }
    else if(lw>=0.5){ ct='📈 Die Chancen auf einen guten Fisch sind gestiegen.'; cc='#9fe06a'; }
    else if(lw>=0.2){ ct='➖ Mäßig gereizt – normale Chancen auf einen guten Fisch.'; cc='var(--gold)'; }
    else { ct='📉 So wird’s schwer, einen guten Fisch zu überlisten.'; cc='var(--danger)'; }
    game.chanceHintT=setTimeout(()=>{ if(game&&game.state==='presink') flashBig(ct,cc,null,1900); }, 1250); }
}
/* Klick auf „Köder präsentieren" → kurze Aufbau-Phasen, dann das Reaktions-Anschlag-Spiel (rot → grün) */
function armReadyBite(){
  if(!game||game.state!=='presink') return;
  clearTimeout(game.chanceHintT);
  if(game.pendingFollow){ game.pendingFollow=false; hideCenter(); startFollow(); return; }   // bestätigter Nachläufer
  game.state='present';
  hideCenter();
  // Phase 1: Köder wird präsentiert – Pose ruht, kleiner Ringel ums Wasser
  const b=$('#bobber'); if(b){ b.style.display='block'; b.classList.remove('bite','twitch'); b.classList.add('rest'); }
  spawnSplashAtBobber();
  setMsg('🎣 Du präsentierst den Köder verführerisch …');
  flashBig('🎣 Köder wird präsentiert','var(--accent2)',null,1300);
  if(sfx.cast) sfx.cast();
  game.presentT1=setTimeout(()=>{ if(!game||game.state!=='present') return;
    // Phase 2: ein Fischschatten schwimmt sichtbar auf die Pose zu – bereithalten!
    setMsg('🐟 Ein Fisch nähert sich – bereithalten!');
    flashBig('🐟 Fisch nähert sich – bereithalten!','var(--gold)',null,1500);
    if(sfx.tip) sfx.tip(); vib(30);
    const af=$('#approachfish');
    if(af){ const fromRight=Math.random()<0.5; af.style.transition='none'; af.style.display='block';
      af.style.left=(fromRight?86:14)+'%'; af.style.bottom='27%'; af.style.width='20px'; af.style.height='8px'; af.style.opacity='0';
      af.style.transform='translate(-50%,0) scaleX('+(fromRight?-1:1)+')';
      void af.offsetWidth;   // Reflow erzwingen, damit die Transition greift
      af.style.transition='left 1.5s cubic-bezier(.35,0,.7,1),bottom 1.5s ease-in,width 1.5s ease-in,height 1.5s ease-in,opacity .5s';
      af.style.left='50%'; af.style.bottom='33%'; af.style.width='52px'; af.style.height='18px'; af.style.opacity='.92'; }
    if(b){ b.classList.remove('rest'); b.classList.add('twitch'); }   // Pose wird nervös
    game.presentT2=setTimeout(()=>{ if(game&&game.state==='present'){ hideApproachFish(); realBite(); } }, 1650);
  }, 1300);
}
function spawnSplashAtBobber(){ const sc=$('#scene'), b=$('#bobber'); if(!sc||!b||b.style.display==='none') return;
  const sp=document.createElement('div'); sp.className='splash'; sp.style.left='50%'; sp.style.bottom='34%'; sc.appendChild(sp);
  setTimeout(()=>{ if(sp.parentNode) sp.remove(); }, 950); }
function hideApproachFish(){ const af=$('#approachfish'); if(af){ af.style.display='none'; af.style.opacity='0'; } }
/* ---- Nachläufer: der Fisch folgt dem Köder, im richtigen Moment „Achter drehen" → Biss ---- */
function followChance(sp){
  const base=(sp==='hecht'||sp==='rapfen'||sp==='blackbass')?0.42:(sp==='barsch')?0.30:0.22;
  return base*(TIMES[S.time].night?0.6:1);
}
/* Nachläufer-Pfade (Punkte in % der Szene, sichtbarer Bereich y 30–66) – zufällig gewählt, zufällig gespiegelt, 5–7 Punkte */
const FOLLOW_PATHS=[
  [{x:34,y:31},{x:60,y:40},{x:45,y:49},{x:61,y:58},{x:37,y:66}],                               // S-Kurve (5)
  [{x:30,y:32},{x:64,y:34},{x:32,y:44},{x:64,y:50},{x:34,y:58},{x:62,y:65}],                    // Zickzack (6)
  [{x:62,y:31},{x:40,y:39},{x:60,y:48},{x:38,y:57},{x:58,y:65}],                                // Spiegel-S (5)
  [{x:30,y:46},{x:42,y:32},{x:54,y:46},{x:64,y:33},{x:52,y:58},{x:38,y:64}],                    // Doppel-Welle (6)
  [{x:30,y:31},{x:44,y:36},{x:44,y:46},{x:58,y:46},{x:58,y:56},{x:44,y:60},{x:34,y:65}],        // Treppe (7)
  [{x:48,y:30},{x:64,y:42},{x:52,y:56},{x:34,y:52},{x:40,y:38},{x:56,y:34}],                    // Schlaufe (6)
  [{x:30,y:32},{x:42,y:42},{x:52,y:50},{x:62,y:58},{x:48,y:66}],                                // Diagonale (5)
  [{x:30,y:64},{x:34,y:34},{x:46,y:52},{x:58,y:34},{x:64,y:52},{x:52,y:64},{x:40,y:56}],        // M-Form (7)
];
/* Erzeugt einen Nachläufer-Pfad mit 8–10 gut verteilten Punkten (Mindestabstand → nie zu nah beieinander) */
function genFollowPts(){
  const C=8+Math.floor(Math.random()*3);                 // 8..10 Punkte (3 mehr als bisher)
  const X0=20,X1=78,Y0=29,Y1=67;                          // nutzbarer Bereich der Szene
  let minD=15, pts=[];                                    // Mindestabstand zwischen allen Punkten
  for(let attempt=0; attempt<8 && pts.length<C; attempt++){
    pts=[]; let tries=0;
    while(pts.length<C && tries<1500){ tries++;
      const p={x:X0+Math.random()*(X1-X0), y:Y0+Math.random()*(Y1-Y0)};
      if(pts.every(q=>Math.hypot(p.x-q.x,p.y-q.y)>=minD)) pts.push(p);
    }
    if(pts.length<C) minD-=1;                             // falls Platz knapp: minimal enger erlauben
  }
  // Als zusammenhängenden Pfad ordnen: oben starten, dann jeweils zum nächstgelegenen Punkt
  pts.sort((a,b)=>a.y-b.y);
  const order=[pts.shift()];
  while(pts.length){ const last=order[order.length-1]; let bi=0,bd=1e9; pts.forEach((q,i)=>{ const d=Math.hypot(q.x-last.x,q.y-last.y); if(d<bd){bd=d;bi=i;} }); order.push(pts.splice(bi,1)[0]); }
  return order.map(p=>({x:Math.round(p.x),y:Math.round(p.y)}));
}
function startFollow(){
  game.state='follow';
  $('#scene').classList.remove('waiting'); $('#bobber').classList.remove('rest');
  cancelAnimationFrame(game.retrRAF); { const lc=$('#lurecircle'); if(lc) lc.style.display='none'; }
  sfx.bite(); vib(40);
  const dcfg=DIFFICULTY[S.difficulty];
  let pts=genFollowPts();   // 8–10 gut verteilte Punkte
  const dur=(3200+pts.length*340)*dcfg.hookWindow;            // mehr Punkte → etwas mehr Zeit, aber knapp
  setMsg('👀 Ein '+SPECIES[game.species].name+' folgt deinem Köder! Führ ihn lebhaft durch die Punkte – bleib in Bewegung, sonst verliert er die Lust!');
  showHead('👀 Nachläufer', IS_TOUCH?('Köder schwebt über dem Finger · zügig durch 1→'+pts.length):('Führ den Köder lebhaft & zügig durch die Punkte 1→'+pts.length));
  $('#actBtn').classList.add('hidden');
  const st=pts[0];
  game.fp={ pts, idx:0, lure:{x:st.x,y:st.y}, prev:{x:st.x,y:st.y}, fish:{x:st.x,y:Math.min(72,st.y+22)}, interest:0.62, t0:performance.now(), last:performance.now(), dur, speed:0, armed:false };
  buildFollowPath();
  suspenseStart();   // bedrohliche Spannungsmusik
  const fpEl=$('#followpath'); if(fpEl) fpEl.style.display='block';
  const fb=$('#followbars'); if(fb){ fb.style.display='flex'; fb.style.top=(CH||TOURNEY)?'70px':'18%'; }   // im Turnier unter den Banner schieben
  game.followMove=(e)=>{ if(!game||game.state!=='follow'||!game.fp||!game.fp.armed) return; const r=$('#scene').getBoundingClientRect();
    const touch=(e.pointerType==='touch')||!!(e.touches&&e.touches.length);
    const cx=(e.touches&&e.touches[0]?e.touches[0].clientX:e.clientX); let cy=(e.touches&&e.touches[0]?e.touches[0].clientY:e.clientY);
    if(cx==null) return; if(touch) cy-=r.height*0.17;   // Touch: Köder deutlich über dem Finger – Finger verdeckt Spiel & Punkte nicht
    game.fp.lure.x=((cx-r.left)/r.width)*100; game.fp.lure.y=((cy-r.top)/r.height)*100; };
  const sc=$('#scene'); sc.addEventListener('pointermove',game.followMove); sc.addEventListener('pointerdown',game.followMove); sc.addEventListener('touchmove',game.followMove,{passive:true}); sc.addEventListener('touchstart',game.followMove,{passive:true});
  // 2-Sekunden-Countdown mit großem „NACHLÄUFER"-Schriftzug, dann startet das Spiel (Timer & Eingabe)
  startFollowCountdown(()=>{
    if(!game||game.state!=='follow'||!game.fp) return;
    game.fp.armed=true; const tnow=performance.now(); game.fp.t0=tnow; game.fp.last=tnow;
    setMsg('👀 LOS! Führ den Köder lebhaft & zügig durch die Punkte 1→'+game.fp.pts.length);
    game.followRAF=requestAnimationFrame(followLoop);
  });
}
function startFollowCountdown(done){
  const sc=$('#scene'); if(!sc){ if(done)done(); return; }
  { const old=$('#followcount'); if(old) old.remove(); }
  const ov=document.createElement('div'); ov.id='followcount';
  ov.innerHTML='<div class="fc-title">👀 NACHLÄUFER!</div><div class="fc-sub">Mach dich bereit …</div><div class="fc-num">2</div>';
  sc.appendChild(ov);
  const num=ov.querySelector('.fc-num'); let n=2; sfx.bite(); vib(40);
  clearInterval(game.fcIv);
  game.fcIv=setInterval(()=>{ n--;
    if(n>=1){ num.textContent=n; if(sfx.tip) sfx.tip(); vib(20); }
    else { clearInterval(game.fcIv); game.fcIv=null; const e=$('#followcount'); if(e) e.remove(); if(sfx.bite) sfx.bite(); vib([0,40,40,40]); if(done) done(); }
  }, 1000);
}
function fbSet(sel,frac){ const el=$(sel+' > i'); if(!el) return; const f=Math.max(0,Math.min(1,frac));
  el.style.width=(f*100)+'%'; el.style.backgroundColor = f>0.5?'#2fbf71':(f>0.25?'#ffd24a':'#e0533d'); }
function followLoop(now){
  const fp=game&&game.fp; if(!fp||game.state!=='follow'){ return; }
  const dt=Math.min(0.05,(now-(fp.last||now))/1000); fp.last=now;
  const dcfg=DIFFICULTY[S.difficulty];
  // Köder-Tempo (geglättet, %/s)
  const moved=Math.hypot(fp.lure.x-fp.prev.x, fp.lure.y-fp.prev.y);
  fp.speed = fp.speed*0.6 + (moved/Math.max(dt,0.001))*0.4;
  fp.prev.x=fp.lure.x; fp.prev.y=fp.lure.y;
  // Fisch verfolgt den Köder mit Verzögerung
  const chase=Math.min(1,3.0*dt);
  fp.fish.x += (fp.lure.x-fp.fish.x)*chase; fp.fish.y += (fp.lure.y-fp.fish.y)*chase;
  const distFL=Math.hypot(fp.fish.x-fp.lure.x, fp.fish.y-fp.lure.y);
  // Interesse: lebhafte Bewegung in der Nähe → steigt; Stillstand / zu schnell / zu weit → fällt
  const good = fp.speed>14 && fp.speed<150 && distFL<26;
  let d=-0.16*(dcfg.drainMul||1);
  if(good) d+=0.62;
  if(fp.speed<6) d-=0.34;          // Stillstand langweilt
  if(distFL>34) d-=0.42;           // Fisch abgehängt
  fp.interest=Math.max(0,Math.min(1,fp.interest+d*dt));
  const remain=1-(now-fp.t0)/fp.dur;
  // Rendern
  const lureEl=$('#fplure'); if(lureEl){ lureEl.style.left=fp.lure.x+'%'; lureEl.style.top=fp.lure.y+'%'; }
  const fishEl=$('#fpfish'); if(fishEl){ fishEl.style.left=fp.fish.x+'%'; fishEl.style.top=fp.fish.y+'%';
    fishEl.classList.toggle('hot', good && fp.interest>0.5);
    fishEl.classList.toggle('cold', distFL>34 || fp.interest<0.25);
    fishEl.style.transform='translate(-50%,-50%) scaleX('+(fp.lure.x<fp.fish.x?-1:1)+')'; }
  fbSet('#fbTime', Math.max(0,remain)); fbSet('#fbInt', fp.interest);
  // nächsten Punkt prüfen
  const t=fp.pts[fp.idx];
  if(t && Math.hypot(fp.lure.x-t.x, fp.lure.y-t.y) < (dcfg.followR||9)){
    markFollowDot(fp.idx); fp.idx++; fp.interest=Math.min(1,fp.interest+0.10); sfx.netfill(fp.idx/fp.pts.length); vib(18);
    if(fp.idx>=fp.pts.length){ followResolve('win'); return; }
  }
  if(fp.interest<=0){ followResolve('interest'); return; }
  if(remain<=0){ followResolve('time'); return; }
  setMsg(good ? ('🔥 Er ist heiß! Weiter zu Punkt '+(fp.idx+1)+'/'+fp.pts.length)
       : (fp.speed<6 ? '😴 Beweg den Köder – sonst dreht er ab!'
       : (distFL>34 ? '🏃 Nicht zu schnell – der Fisch hängt hinterher!'
       : '👀 Führ ihn durch Punkt '+(fp.idx+1)+'/'+fp.pts.length)));
  game.followRAF=requestAnimationFrame(followLoop);
}
function buildFollowPath(){
  const fp=$('#followpath'); if(!fp||!game.fp) return; const pts=game.fp.pts;
  const d='M'+pts.map(p=>p.x+' '+p.y).join(' L');
  fp.innerHTML='<svg viewBox="0 0 100 100" preserveAspectRatio="none"><path d="'+d+'" fill="none" stroke="rgba(255,255,255,.45)" stroke-width="2" stroke-dasharray="3 2" vector-effect="non-scaling-stroke"/></svg>'
    + pts.map((p,i)=>'<div class="fp-dot'+(i===0?' next':'')+'" data-i="'+i+'" style="left:'+p.x+'%;top:'+p.y+'%">'+(i+1)+'</div>').join('')
    + '<div class="fp-fish" id="fpfish">'+(SPECIES[game.species].em||'🐟')+'</div>'
    + '<div class="fp-lure" id="fplure">'+(LURES[S.lure].ic||'🎣')+'</div>';
  const lel=$('#fplure'); if(lel){ lel.style.left=game.fp.lure.x+'%'; lel.style.top=game.fp.lure.y+'%'; }
  const fel=$('#fpfish'); if(fel){ fel.style.left=game.fp.fish.x+'%'; fel.style.top=game.fp.fish.y+'%'; }
}
function markFollowDot(i){ const fp=$('#followpath'); if(!fp) return;
  const d=fp.querySelector('[data-i="'+i+'"]'); if(d){ d.classList.add('done'); d.classList.remove('next'); }
  const n=fp.querySelector('[data-i="'+(i+1)+'"]'); if(n) n.classList.add('next'); }
function endFollowInput(){ const fp=$('#followpath'); if(fp) fp.style.display='none'; { const hd=$('#lchead'); if(hd) hd.style.display='none'; } { const fb=$('#followbars'); if(fb) fb.style.display='none'; }
  { clearInterval(game.fcIv); game.fcIv=null; const fc=$('#followcount'); if(fc) fc.remove(); }
  suspenseStop();
  cancelAnimationFrame(game.followRAF);
  const sc=$('#scene'); if(sc&&game.followMove){ sc.removeEventListener('pointermove',game.followMove); sc.removeEventListener('pointerdown',game.followMove); sc.removeEventListener('touchmove',game.followMove); sc.removeEventListener('touchstart',game.followMove); }
  game.followMove=null; }
function followResolve(reason){
  game.followDone=true; cancelAnimationFrame(game.followRAF); clearTimeout(game.followTimer); endFollowInput();
  if(reason===true||reason==='win'){ game.lureWork=Math.min(1,(game.lureWork||0)+0.3); anglerSay('Sitzt – er hat zugepackt!',1100); flashBig('🔥 Biss provoziert!','var(--accent2)'); realBite(); return; }
  game.state='done'; sfx.lose();
  if(reason==='interest') showLoss('🥱','Der Fisch verlor die Lust!','Dein Köder war zu langweilig – zu langsam geführt oder der Fisch zu weit abgehängt. Der Nachläufer hat das Interesse verloren und abgedreht.','Halt den Köder ständig in lebhafter Bewegung und nah am Fisch – gleichmäßig zügig, nicht abreißen lassen. Die <b>Interesse-Leiste</b> muss oben bleiben!');
  else if(reason==='time') showLoss('⏱️','Zu langsam – abgedreht!','Du hast es nicht rechtzeitig durch alle Punkte geschafft. Nachläufer beißen nur, wenn der Reiz schnell genug kommt.','Zieh den Köder zügig nacheinander durch die Punkte 1→Ende, bevor die <b>Zeit-Leiste</b> leer ist.');
  else showLoss('🌀','Nachläufer abgedreht!','Du hast den Köder nicht sauber durch die Punkte geführt – der Fisch hat abgedreht.','Führ den Köder lebhaft & zügig durch alle Punkte – bleib dran am Fisch.');
}
/* Reaktions-Anschlag: Button erst ROT (warten), dann GRÜN – dann blitzschnell anhauen */
function realBite(){
  game.state='bite';
  $('#scene').classList.remove('waiting');
  hideApproachFish();
  { const b=$('#bobber'); if(b){ b.style.display='block'; b.classList.remove('rest','bite','predive'); b.classList.add('twitch'); } }   // Pose zuckt nervös, während es ROT ist
  $('#hookmeter').style.display='none'; $('#actBtn').classList.add('hidden');
  game.hookPhase='red'; game.greenAt=0;
  showCenter('🔴 Warten … (nicht zu früh!)','redwait');
  { const cb=$('#centerbtn'); if(cb) cb.style.top='40%'; }   // Button ein Stück höher → Pose bleibt sichtbar
  setMsg('❗ Es klopft! Achte auf die Pose – wenn sie abtaucht und der Button GRÜN wird: blitzschnell anhauen!');
  const delay=650+Math.random()*1700;   // Zufallszeit bis Grün
  // Früh-Indikator: kurz vor Grün zuckt die Pose deutlich heftiger
  game.preDiveTimer=setTimeout(()=>{ if(game&&game.state==='bite'&&game.hookPhase==='red'){ const b=$('#bobber'); if(b){ b.classList.remove('twitch'); b.classList.add('predive'); } } }, Math.max(0,delay-300));
  game.greenTimer=setTimeout(()=>{ if(!game||game.state!=='bite'||game.hookPhase!=='red') return;
    game.hookPhase='green'; game.greenAt=performance.now();
    { const b=$('#bobber'); if(b){ b.classList.remove('twitch','predive'); b.classList.add('bite'); } }   // GRÜN: Pose taucht ab
    showCenter('⚡ JETZT ANHAUEN!','greenflash');
    { const cb=$('#centerbtn'); if(cb) cb.style.top='40%'; }
    setMsg('⚡ JETZT! Hau an, so schnell du kannst!'); sfx.bite(); vib(50);
    game.strikeTimer=setTimeout(()=>{ if(game.state==='bite'&&game.hookPhase==='green') missBite(); }, 1500*(DIFFICULTY[S.difficulty].reactMul||1)*(hasGear('haken')?1.4:1));
  }, delay);
}
function missBite(){
  clearTimeout(game.greenTimer); clearTimeout(game.strikeTimer); clearTimeout(game.preDiveTimer);
  $('#bobber').classList.remove('bite','twitch','predive'); hideCenter();
  sfx.lose(); game.state='done';
  showLoss('😴','Zu spät angeschlagen!','Nach „JETZT" zu lange gewartet – der Fisch hat den Köder wieder ausgespuckt.','Sobald der Button GRÜN wird: blitzschnell anhauen! Je schneller deine Reaktion, desto besser sitzt der Haken.');
}
function falseStrike(){
  clearTimeout(game.greenTimer); clearTimeout(game.strikeTimer); clearTimeout(game.preDiveTimer);
  $('#bobber').classList.remove('bite','twitch','predive'); hideCenter();
  sfx.lose(); game.state='done';
  showLoss('🔴','Zu früh angeschlagen!','Du hast angehauen, bevor der Fisch den Köder richtig im Maul hatte (Button war noch rot).','Warte, bis der Button GRÜN wird – erst dann anhauen. Ruhig bleiben und auf den Wechsel reagieren!');
}
function strike(){
  if(!game||game.state!=='bite') return;
  if(game.hookPhase!=='green'){ return falseStrike(); }   // Fehlstart auf Rot
  clearTimeout(game.strikeTimer); clearTimeout(game.preDiveTimer);
  const rt=performance.now()-game.greenAt;   // Reaktionszeit in ms
  hideCenter();
  $('#bobber').classList.remove('bite','twitch','predive');
  const rm=(DIFFICULTY[S.difficulty].reactMul||1)*(hasGear('haken')?1.4:1);   // leicht & scharfe Haken: mehr Zeit
  let q;
  if(rt<=260*rm) q={l:'🎯 Blitz-Reaktion – Fisch hängt perfekt!', s:1.0, f:'🎯 Perfekt angehauen!', c:'var(--accent2)'};
  else if(rt<=460*rm) q={l:'👍 Schnell angehauen – Fisch hängt gut', s:0.7, f:'👍 Gut angehauen!', c:'#9fe06a'};
  else if(rt<=760*rm) q={l:'🆗 Fisch hängt', s:0.45, f:'🆗 Okay angehauen', c:'var(--gold)'};
  else q={l:'⚠️ Spät reagiert – Fisch hängt schlecht', s:0.20, f:'⚠️ Schlecht angehauen', c:'var(--danger)'};
  game.hookScore=q.s; game.hookLabel=q.l+' ('+Math.round(rt)+' ms)';
  flashBig(q.f+' · '+Math.round(rt)+' ms', q.c);   // kurzer Hinweis wie bei der Köderführung
  if(q.s>=1) sfx.perfect();
  recordHook(rt);
  // Sanfter Übergang: nicht sofort in den Drill springen – Button leicht verzögert & eingefadet
  game.state='tofight';
  $('#bobber').classList.add('bite');
  setMsg(q.l+' · gleich geht der Drill los …');
  game.btnArm=performance.now()+940;   // erst nach Verzögerung+Fade klickbar
  game.tofightT=setTimeout(()=>{ if(game&&game.state==='tofight'){ showCenter('💪 Drill starten',''); fadeInCenter(460); setMsg(q.l+' · Tippe „Drill starten", wenn du bereit bist!'); } }, 480);
}
function beginDrill(){ if(!game||game.state!=='tofight') return; if(performance.now()<(game.btnArm||0)) return; clearTimeout(game.tofightT); hideCenter(); $('#bobber').classList.remove('bite'); startFight(); }
function beginNetting(){ if(!game||game.state!=='landing') return; if(performance.now()<(game.btnArm||0)) return; clearTimeout(game.landT); hideCenter(); startNetting(); }
/* ---- Anhau-Reaktionszeit: Statistik + Awards ---- */
function recordHook(rt){
  if(!S.hook) S.hook={n:0,sum:0,best:9999,fast:0,streak:0,bestStreak:0,awardedStreak:0};
  const h=S.hook; rt=Math.round(rt);
  h.n++; h.sum+=rt; if(rt<h.best) h.best=rt; if(rt<=300){ h.fast++; h.streak++; if(h.streak>h.bestStreak) h.bestStreak=h.streak; } else h.streak=0;
  save(); checkBadges(); maybeHookAward(h);
}
const HOOK_AWARDS=[
  {n:3,  rew:60,  t:'🔥 Reflex-Serie!',            m:'3 perfekte Anhiebe in Folge (je unter 300 ms)! Deine Hand ist schneller als ein flüchtender Hecht.'},
  {n:5,  rew:120, t:'⚡ Schnellster Daumen am See', m:'5 Blitz-Anhiebe in Folge! Da werden selbst Esport-Profis neidisch.'},
  {n:8,  rew:250, t:'🎯 Anschlag-Maschine',        m:'8-mal in Folge unter 300 ms. Das ist keine Reaktion mehr, das ist Vorahnung.'},
  {n:12, rew:500, t:'🐉 Übermenschliche Reflexe',  m:'12 in Folge?! Du haust an, bevor der Fisch überhaupt zugebissen hat.'},
];
function maybeHookAward(h){
  const aw=h.awardedStreak||0;
  for(const tier of HOOK_AWARDS){ if(h.streak>=tier.n && aw<tier.n){ h.awardedStreak=tier.n; S.money+=tier.rew; addKarma(2); save(); syncTop();
    setTimeout(()=>{ toast('🏅 '+tier.t+'  +'+tier.rew+' 💶'); sfx.coupon(); vib([0,50,70,50]); }, 350); break; } }
}
function reactionVerdict(ms){
  if(ms<200) return {ic:'🏎️',txt:'<b>F1-Reflexe!</b> Formel-1-Fahrer reagieren auf die Startampel in ~200 ms, Esport-Profis in ~150–200 ms – du spielst in der Liga.'};
  if(ms<260) return {ic:'🎮',txt:'<b>Pro-Gamer-Niveau!</b> Du bist schneller als die durchschnittliche menschliche Reaktionszeit (~250 ms) – Reflexe wie ein 20-jähriger Esportler.'};
  if(ms<330) return {ic:'👍',txt:'<b>Stark!</b> Du liegst rund um die normale menschliche Reaktionszeit (~250 ms). Damit haust du jeden Hecht an.'};
  if(ms<430) return {ic:'🙂',txt:'<b>Solide.</b> Ein Wimpernschlag dauert ~100–150 ms – du brauchst nur ein paar mehr davon. Mit Übung (oder Kaffee) geht da noch was.'};
  return {ic:'🐢',txt:'<b>Gemütlich</b> wie ein Karpfenangler im Liegestuhl. Reaktionszeit steigt übrigens mit dem Alter – Hauptsache, der Haken sitzt am Ende!'};
}
function hookStatCard(){
  const h=S.hook; if(!h||!h.n) return '';
  const avg=Math.round(h.sum/h.n), fastPct=Math.round(h.fast/h.n*100); const v=reactionVerdict(avg);
  return `<div class="card" style="margin-top:10px">
    <b>🎯 Deine Anschlag-Reflexe</b>
    <div class="statline" style="margin:8px 0 4px">
      <div><div class="v">${avg} ms</div><div class="l">Ø Reaktion</div></div>
      <div><div class="v">${h.best} ms</div><div class="l">Bestzeit</div></div>
      <div><div class="v">${h.bestStreak||0}×</div><div class="l">Beste Serie</div></div>
    </div>
    <div class="sub" style="margin:4px 0 0">${v.ic} ${v.txt}</div>
    <div class="sub2" style="margin:6px 0 0;color:var(--muted)">${h.n} Anhiebe · ${fastPct}% davon blitzschnell (&lt;300 ms) · Serie = perfekte Anhiebe (&lt;300 ms) nacheinander</div>
  </div>`;
}

function rollWeight(sp){
  const s=SPECIES[sp], w=WATERS[S.water];
  const boatSize=(S.fromBoat&&S.boat&&BOATS[S.boat])?BOATS[S.boat].sizeMul:0;   // Boot → größere Fische erreichbar
  const gA=activeGuide(); const guideSize=gA?(gA.all?gA.sizeBoost:(gA.sp===sp?gA.sizeBoost:0)):0;   // Guide → kapitale Zielfische (Daniel: kleiner)
  const nbf=(S.nextBigFish)?0.9:0;   // Karma-Bonus: nächster Fisch richtig gut
  const lb=lureLevel(S.lure)*0.12;   // eingefischter Köder → minimal größere Fische
  const lw=(game&&game.lureWork?game.lureWork*0.25:0);   // gute Köderführung → etwas größere Fische
  const crawB=(LURETYPE[S.lure]==='craw') ? (sp==='barsch'?0.8 : sp==='zander'?0.45 : 0) : 0;   // Krebse → besonders kapitale Barsche, auch große Zander
  const eb=(game&&game.echoBonus?game.echoBonus*0.3:0);  // Echolot-Hotspot → größere Fische
  const km=karmaP()*0.3;                                  // gutes Karma → tendenziell bessere Fänge
  const spook=(S.spookedUntil&&Date.now()<S.spookedUntil)?0.9:0;   // „Nasser Labrador"/Ben verscheucht große Fische
  const nbad=(S.nextBadFish)?0.8:0;   // „Fischadler"-Event: nächster Wurf → eher kleinere Fische
  const gsp=(S.goodSpotUntil&&Date.now()<S.goodSpotUntil)?0.7:0;   // Ronnys Geheim-Spots → sehr gute Fische (3 Min)
  const farB=(game&&game.castBottom!=null)?Math.max(0,Math.min(1,(game.castBottom-30)/26))*0.5:0;   // weiter Wurf (Freiwasser) → größere Fische (Belohnung fürs schwerere Treffen)
  const expo=Math.max(1.0, 2.4-(game&&game.castScore?game.castScore*0.9:0)-boatSize-guideSize-nbf-lb-lw-crawB-eb-km-gsp-farB+spook+nbad);   // guter & weiter Wurf → größere Fische
  const r=Math.pow(Math.random(),expo);
  let wt=s.wMin+(s.wMax-s.wMin)*r; wt*=(0.7+w.sizeBias*0.6);
  return Math.max(s.wMin,Math.min(s.wMax,wt));
}

function sizeFeel(sp,weight){
  const r=weight/Math.max(SPECIES[sp].trophy,0.1);
  if(r>=0.85) return '🐋 Wahnsinn – das fühlt sich KAPITAL an!';
  if(r>=0.55) return '💪 Das fühlt sich nach einem sehr guten Fisch an!';
  if(r>=0.30) return '🙂 Ein schöner Fisch hängt.';
  return '🐟 Das ist nur ein Kleiner.';
}
function updateHookHold(lineHp){
  const el=$('#hookhold'), fill=$('#hhfill'); if(!el||!fill) return;
  const icn=el.querySelector('.hh-ic'), txt=el.querySelector('.hh-txt');
  const v=Math.max(0,Math.min(1,lineHp));
  fill.style.width=(v*100)+'%';
  let c,t,ic,cls;
  if(v>0.66){ c='#2fbf71'; t='Haken sitzt fest'; ic='🪝'; cls='good'; }
  else if(v>0.33){ c='#ffd24a'; t='Haken wackelt!'; ic='⚠️'; cls='mid'; }
  else { c='#e0533d'; t='Reißt gleich aus!'; ic='🚨'; cls='low'; }
  fill.style.backgroundColor=c; if(icn) icn.textContent=ic; if(txt) txt.textContent=t;
  el.classList.remove('good','mid','low'); el.classList.add(cls);
}
function startFight(){
  const sp=game.species, s=SPECIES[sp];
  let weight=rollWeight(sp);
  game.boss=null;
  if(Math.random()<bossChance()){ const bd=pickBoss(sp); if(bd){ game.boss=bd; weight=bd.kg; } }   // Legende!
  const rod=RODS[S.rod], reel=REELS[S.reel], net=NETS[S.net];
  const ratio=weight/Math.max(s.trophy,0.1);
  const sizeFactor=0.6+Math.min(ratio,2.6)*0.9, difficulty=s.fight*sizeFactor;
  const dcfg=DIFFICULTY[S.difficulty], hs=game.hookScore??0.5;
  game.state='fight';
  const hk=hasGear('haken');        // scharfe Haken → Fisch sitzt deutlich besser
  const bl=!!S.bluntHooks;          // stumpfe Haken (Zufalls-Event) → Drill extrem schwer
  game.f={ sp,s,weight,difficulty,ratio, fishPos:0.5,fishTarget:0.5,fishVel:0, blunt:bl,
    zonePos:0.5,zoneVel:0,zoneH:rod.zone,
    progress:0.24+hs*0.28+(hk?0.08:0)-(bl?0.12:0),            // besserer Anschlag/Haken → besserer Start; stumpf → schlechter
    fill:reel.speed*(hk?1.1:1)*(bl?0.78:1),
    drain:0.46*difficulty*(1.5-hs*0.7)*(1.25-(rod.zone-0.30)*1.2-(reel.speed-1)*0.18)*(dcfg.drainMul||1)*(hk?0.72:1)*(bl?1.6:1), // Anschlag, Gerät, Schwierigkeit, scharfe/stumpfe Haken → Verlust-Tempo
    buffer:net.buffer, holding:false,
    overpower:(difficulty-rod.power)*(hk?0.8:1)*(bl?1.4:1),
    lineHp:0.7+hs*0.3+(hk?0.12:0)-(bl?0.3:0),                // schlechter Anschlag → schwächerer Sitz; scharfe Haken → fester, stumpfe → wackeliger
    reactAt:(ratio>=0.25?performance.now()+2600+Math.random()*2200:Infinity), react:null,
    landMul:1/(0.8+Math.min(ratio,2.6)*0.6),   // größerer Fisch → langsamerer Fortschritt → längerer Drill
    minMs:3500+Math.min(ratio,2.6)*1100,        // Mindest-Drilldauer (größere Fische etwas länger)
    graceMs:(S.difficulty==='leicht'?2600:S.difficulty==='schwer'?1600:2000),  // Schonfrist: am Drill-Anfang kein sofortiges Ausschlitzen/Schnurbruch
    calm:dcfg.fishCalm, last:performance.now(), t0:performance.now() };
  $('#actBtn').classList.add('hidden'); $('#idlebtns').classList.add('hidden'); { const eb=$('#echoBtn'); if(eb) eb.classList.add('hidden'); }
  $('#bobber').classList.remove('rest','bite');
  $('#scene').classList.remove('waiting');
  $('#fight').style.display='flex';
  { const hh=$('#hookhold'); if(hh){ hh.style.display='flex'; hh.style.top=(CH||TOURNEY)?'70px':'11%'; } } updateHookHold(game.f.lineHp);
  { const old=$('#bluntHint'); if(old) old.remove();
    if(bl){ const bh=document.createElement('div'); bh.id='bluntHint'; bh.textContent='🪝 Dein Haken ist echt stumpf geworden!';
      bh.style.cssText='position:absolute;left:50%;top:4%;transform:translateX(-50%);background:rgba(224,83,61,.94);color:#fff;font-weight:900;font-size:13px;padding:4px 12px;border-radius:12px;z-index:8;white-space:nowrap;box-shadow:0 2px 8px #000;pointer-events:none';
      const sc=$('#scene'); if(sc) sc.appendChild(bh);
      flashBig('🪝 Dein Haken ist echt stumpf geworden!','var(--danger)',null,2200); } }
  $('#fmark').innerHTML=fishIcon(sp,30);
  if(game.boss){ setMsg('🐉 Etwas RIESIGES ist eingestiegen … das ist eine LEGENDE! Halt durch!'); sfx.big(); anglerSay('Das ist DER Fisch!!',2400); }
  else setMsg(sizeFeel(sp,weight)+' Im grünen Fenster halten!');
  setTimeout(()=>{ if(game&&game.f&&game.state==='fight') flashBig('💪 Drill, Baby, drill!','var(--gold)',null,2200); },1600);   // Drill-Start-Spruch – deutlich verzögert (Anschlag-Hinweis erst weg) und länger sichtbar
  const rb=$('#reelbtn');
  const down=e=>{ if(game.f){ game.f.holding=true; if(!game.brakeIv){ sfx.brake(); game.brakeIv=setInterval(()=>{ if(game&&game.f&&game.f.holding) sfx.brake(); else { clearInterval(game.brakeIv); game.brakeIv=null; } },75); } } if(e&&e.preventDefault)e.preventDefault(); };
  const up=()=>{ if(game.f) game.f.holding=false; if(game.brakeIv){ clearInterval(game.brakeIv); game.brakeIv=null; } };
  const key=e=>{ if(e.code==='Space'){ if(e.type==='keydown')down(); else up(); e.preventDefault(); } };
  game.ctrl={rb,down,up,key};
  rb.addEventListener('touchstart',down,{passive:false}); rb.addEventListener('mousedown',down);
  window.addEventListener('touchend',up); window.addEventListener('mouseup',up);
  const sc=$('#scene'); sc.addEventListener('touchstart',down,{passive:false}); sc.addEventListener('mousedown',down);
  window.addEventListener('keydown',key); window.addEventListener('keyup',key);
  game.raf=requestAnimationFrame(fightLoop);
}
/* Drill-Zonenfarbe: t=0 Mitte (kräftig grün) → t=1 Zonenrand (blasser) → t>1 außerhalb (fließend rot) */
function zoneColor(t){
  const lerp=(a,b,k)=>{ k=Math.max(0,Math.min(1,k)); return Math.round(a+(b-a)*k); };
  const green=[47,191,113], pale=[176,206,140], red=[224,83,61];
  if(t<=1) return [lerp(green[0],pale[0],t),lerp(green[1],pale[1],t),lerp(green[2],pale[2],t)];
  const k=(t-1)/0.6; return [lerp(pale[0],red[0],k),lerp(pale[1],red[1],k),lerp(pale[2],red[2],k)];
}
function fightLoop(now){
  const f=game.f; if(!f) return;
  let dt=(now-f.last)/1000; f.last=now; dt=Math.min(dt,0.05);
  const calm=f.calm||1;
  if(Math.random()<dt*(1.2+f.difficulty*0.7)*calm) f.fishTarget=Math.random();
  const fishSpeed=(1.3+f.difficulty*0.5)*calm;
  f.fishVel+=(f.fishTarget-f.fishPos)*fishSpeed*dt*6; f.fishVel*=0.86;
  f.fishPos=Math.min(1,Math.max(0,f.fishPos+f.fishVel*dt));
  f.zoneVel+=(f.holding?-2.0:1.1)*dt; f.zoneVel*=0.9; f.zonePos+=f.zoneVel*dt;
  if(f.zonePos<0){f.zonePos=0;f.zoneVel=0;} if(f.zonePos>1){f.zonePos=1;f.zoneVel=0;}
  const half=f.zoneH/2;
  const zCenter=f.zonePos*(1-f.zoneH)+f.zoneH/2;   // sichtbare Zonenmitte – deckt sich mit dem grünen Balken
  const zdist=Math.abs(f.fishPos-zCenter), inZone=zdist<=half;
  if(inZone){ f.progress+=f.fill*0.22*dt*(f.landMul||1); }
  else{ f.progress-=(f.drain/f.buffer)*0.17*dt; if(f.overpower>0&&f.holding) f.lineHp-=f.overpower*0.085*dt; }
  if(f.blunt) f.lineHp-=0.045*dt;   // stumpfe Haken: der Haken arbeitet sich stetig locker
  f.progress=Math.min(1,Math.max(0,f.progress));
  // Mindest-Drilldauer: vor Ablauf kann der Balken nicht ganz volllaufen (kriecht sanft Richtung 100 %)
  { const el=now-(f.t0||now); if(el<(f.minMs||3500)){ const cap=0.9+0.099*(el/(f.minMs||3500)); if(f.progress>cap) f.progress=cap; } }
  // Schonfrist am Drill-Anfang: kein sofortiges Ausschlitzen/Schnurbruch – der Spieler bekommt Zeit zu reagieren
  { const el=now-(f.t0||now); if(el<(f.graceMs||2000)){ if(f.progress<0.12) f.progress=0.12; if(f.lineHp<0.16) f.lineHp=0.16; } }
  // Drill-Reaktionen: Kopfschlag / Sprung (loslassen!) oder Flucht (halten!)
  const rbtn=$('#reelbtn');
  if(!f.react && now>f.reactAt){
    const types=[{t:'Kopfschlag',msg:'⚠️ KOPFSCHLAG! Loslassen – NICHT kurbeln!',hold:false},
                 {t:'Sprung',msg:'🐟 SPRUNG! Schnur locker – loslassen!',hold:false},
                 {t:'Flucht',msg:'💨 FLUCHT! Gegenhalten – HALTEN!',hold:true}];
    f.react=Object.assign({until:now+1200,ok:true}, types[Math.floor(Math.random()*types.length)]);
    setMsg(f.react.msg); sfx.bite(); vib([0,60,40,60]); if(rbtn) rbtn.classList.add('alert');
  }
  if(f.react){
    if((f.react.hold? !f.holding : f.holding)){ f.lineHp-=0.32*dt; f.react.ok=false; }
    if(now>f.react.until){ if(rbtn) rbtn.classList.remove('alert');
      if(f.react.ok){ f.progress=Math.min(1,f.progress+0.06); anglerSay('Sauber pariert!',1000); sfx.perfect(); }
      else anglerSay('Mist – fast weg!',1000);
      f.react=null; f.reactAt=now+3000+Math.random()*3000; }
  }
  const trackH=$('#track').clientHeight, zh=f.zoneH*trackH, zone=$('#zone');
  zone.style.height=zh+'px'; zone.style.top=(f.zonePos*(trackH-zh))+'px';
  // Farbe: zentral kräftig grün → zum Rand blasser → außerhalb fließend nach rot
  { const col=zoneColor(half>0?zdist/half:2); zone.style.backgroundColor='rgba('+col[0]+','+col[1]+','+col[2]+',.52)'; zone.style.borderColor='rgb('+col[0]+','+col[1]+','+col[2]+')'; }
  $('#fmark').style.top=(f.fishPos*trackH)+'px';
  $('#pfill').style.height=(f.progress*100)+'%';
  updateHookHold(f.lineHp);
  // Angler drillt: Rute biegt sich – je größer der Fisch, desto stärker
  const load=Math.min(1.6,(f.ratio||0.5)*1.0+(f.holding?0.2:0)), wob=Math.sin(now/100);
  const tx=139+load*22, ty=30+load*42, cx=129+load*4, cy=110-load*6;
  game.tipVB={x:tx,y:ty};
  const rodEl=$('#rod'); if(rodEl) rodEl.setAttribute('d','M118 192 Q'+Math.round(cx)+' '+Math.round(cy)+' '+Math.round(tx)+' '+Math.round(ty));
  const angEl=$('#angler'); if(angEl) angEl.style.transform='translateX(calc(-50% + '+(wob*load*2.6).toFixed(1)+'px))';
  if(game.land) setLine(game.land.left,game.land.bottom);
  if(f.ratio>=0.6 && (!f.shoutAt || now-f.shoutAt>2300)){ f.shoutAt=now; anglerSay(pick(DRILL_SHOUTS),2000); }
  if(f.lineHp<=0){ endFight(false,'break'); return; }
  if(f.progress>=1){ endFight(true); return; }
  if(f.progress<=0){ endFight(false,'slip'); return; }
  game.raf=requestAnimationFrame(fightLoop);
}
function stopFight(){
  if(!game) return;
  cancelAnimationFrame(game.raf);
  { const bh=$('#bluntHint'); if(bh) bh.remove(); }
  const rb2=$('#reelbtn'); if(rb2) rb2.classList.remove('alert');
  if(game.brakeIv){ clearInterval(game.brakeIv); game.brakeIv=null; }
  if(game.ctrl){ const {rb,down,up,key}=game.ctrl;
    try{ rb.removeEventListener('touchstart',down); rb.removeEventListener('mousedown',down);
      window.removeEventListener('touchend',up); window.removeEventListener('mouseup',up);
      const sc=$('#scene'); if(sc){sc.removeEventListener('touchstart',down);sc.removeEventListener('mousedown',down);}
      window.removeEventListener('keydown',key); window.removeEventListener('keyup',key);
    }catch(e){} game.ctrl=null; }
  game.f=null;
}
function stopAll(){
  ambientStop(); suspenseStop(); mosquitoStop();
  if(!game) return;
  clearTimeout(game.biteTimer); clearTimeout(game.strikeTimer); clearTimeout(game.followTimer); clearTimeout(game.presentT1); clearTimeout(game.presentT2); clearTimeout(game.chanceHintT); clearTimeout(game.preDiveTimer); clearTimeout(game.tofightT); clearTimeout(game.landT);
  cancelAnimationFrame(game.tRAF); cancelAnimationFrame(game.hookRAF); cancelAnimationFrame(game.retrRAF); cancelAnimationFrame(game.followRAF); clearTimeout(game.greenTimer); netCleanup();
  { const lb=$('#lurecircle'); if(lb) lb.style.display='none'; }
  { const hd=$('#lchead'); if(hd) hd.style.display='none'; }
  { const fb=$('#followbars'); if(fb) fb.style.display='none'; }
  { const fpx=$('#followpath'); if(fpx) fpx.style.display='none'; }
  { const hh=$('#hookhold'); if(hh) hh.style.display='none'; }
  { clearInterval(game.fcIv); game.fcIv=null; const fc=$('#followcount'); if(fc) fc.remove(); }
  hideApproachFish(); { const b=$('#bobber'); if(b) b.classList.remove('twitch'); }
  endRetMini();
  if(game.guideIv) clearInterval(game.guideIv);
  if(game.tipIv) clearInterval(game.tipIv);
  if(game.chIv) clearInterval(game.chIv);
  if(game.toIv) clearInterval(game.toIv);
  if(game.echoIv) clearInterval(game.echoIv);
  stopFight();
}
function endFight(won,lossKey){
  const sp=game.species, weight=game.f?game.f.weight:rollWeight(sp);
  stopFight(); $('#fight').style.display='none'; { const hh=$('#hookhold'); if(hh) hh.style.display='none'; }
  if(won){ game.pendingSp=sp; game.pendingWeight=weight; game.state='landing';
    setMsg('💪 Gut gedrillt!'); sfx.reel();
    flashBig('💪 Fisch ausgedrillt!','var(--accent2)',null,1300);
    // Keschern erst per Klick auf den Button – leicht verzögert & eingefadet (kein versehentliches Wegklicken)
    game.btnArm=performance.now()+940;
    game.landT=setTimeout(()=>{ if(game&&game.state==='landing'){ showCenter('🥅 Keschern',''); fadeInCenter(460); setMsg('💪 Gut gedrillt! Tippe genau auf „Keschern", wenn du bereit bist.'); } }, 480);
    return; }
  sfx.lose(); game.state='done';
  const wasBig=(game.f&&game.f.ratio>=0.6);
  if(wasBig) anglerSay('Das war ein großer, wirklich!', 2200);
  const bigNote=wasBig?' Das war ein richtig guter Fisch – ärgerlich!':'';
  slipStreak++;   // verlorener Drill (Ausschlitzen/Schnurbruch) in Folge
  const hookTip = slipStreak>=3 && !hasGear('haken');
  if(hookTip) slipStreak=0;
  const tip = hookTip
    ? '🪝 Schon 3 Fische in Folge verloren! Hol dir im Angelladen die scharfen <b>Jighaken</b> (nur 40 💶) – sie erhöhen die Chance auf einen erfolgreichen Drill deutlich, der Fisch schlitzt viel seltener aus.'
    : (lossKey==='break' ? 'Bessere Rute (mehr „Power") & Rolle kaufen – schwaches Gerät lässt Fische schneller ausschlitzen. Für Welse die Wallerrute.'
                         : 'Gutes Equipment hilft enorm: bessere Rute (Kontrolle) & Rolle (Speed) verhindern Ausschlitzen. Und halt ihn im grünen Fenster!');
  if(lossKey==='break') showLoss('💥','Schnurbruch!','Die Belastung war zu groß – Rute & Schnur waren diesem Fisch nicht gewachsen.'+bigNote, tip);
  else showLoss('🌊','Ausgeschlitzt!','Im Drill ist die Spannung verloren gegangen – der Haken hat sich gelöst.'+bigNote, tip);
}

/* ---- Echolot vom Boot: Fische orten → Bonus auf den nächsten Wurf ---- */
const ECHO_COOLDOWN=300000;   // Echolot nur alle 5 Minuten nutzbar (außer mit Live-Scope)
function echoReady(){ return hasGear('livescope') || Date.now()>=(S.echoUntil||0); }
const ECHO_FAILS=[
  'Auch das beste Echolot macht aus dir noch keinen Hellseher – aber witzig war’s! 😄',
  'Nichts geortet. Die Fische haben heute wohl ihr Tarnkappen-Update bekommen. 🛸',
  'Sogar das Echolot zuckt ratlos mit den Schultern. Macht nix – nächstes Mal!',
  'Fische 1, du 0. Technik ist eben kein Ersatz für ein bisschen Glück. 🍀',
  'Leer geortet – die schwimmen bestimmt gerade woanders Kaffee trinken. ☕',
  'Selbst mit Echolot bleibt Angeln Kopfsache. Atmen, lächeln, weitermachen!',
];
function showSonar(){
  if(!game||(game.state!=='idle'&&game.state!=='done')) return;
  if(!echoReady()){ toast('📡 Echolot lädt noch '+fmtMMSS((S.echoUntil||0)-Date.now())+' …'); return; }
  const liveScope=hasGear('livescope');
  if(!liveScope){ S.echoUntil=Date.now()+ECHO_COOLDOWN; save(); }   // Cooldown nur ohne Live-Scope
  // Echolot-Upgrades aus dem Angelladen
  const upGeber=hasGear('sonarGeber'), upMotor=hasGear('sonarMotor'), upDisplay=hasGear('sonarDisplay');
  const goal=3, fishCount=upGeber?5:3, lineSpeed=70*(upMotor?0.55:1), fishSize=upDisplay?36:26, tol=7.5*(upDisplay?1.4:1);   // langsamerer Strahl & größeres Trefferfenster → leichter zu treffen
  let tries=5;
  const upgList=[
    (upGeber?'✅':'🛰️')+' Geber: mehr Fische + Trophäen-Chance',
    (upMotor?'✅':'🛥️')+' Bugmotor: langsamerer Strahl',
    (upDisplay?'✅':'🖥️')+' Display: größere Fische',
  ].join(' · ');
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:460px;text-align:center">
    <div class="fname">📡 Echolot</div>
    <div class="sub" style="margin:6px 0">Tippe „Loten", wenn der grüne Scan-Strahl einen Fisch 🐟 trifft. <b>5 Versuche</b> für 3 Fische – mehr Treffer = schnellerer Biss & größere Fische beim nächsten Wurf! (Der Strahl ist schnell – ziele genau!)</div>
    <div id="sonar" style="position:relative;height:360px;border:1px solid var(--line);border-radius:12px;overflow:hidden;background:linear-gradient(180deg,#06283b,#031722)">
      <div id="scanline" style="position:absolute;left:0;right:0;height:3px;background:rgba(47,191,113,.9);box-shadow:0 0 10px #2fbf71;top:0"></div></div>
    <div class="sub2" id="sonarStat" style="margin:6px 0">Treffer: 0 / 3 · Versuche: 5</div>
    <button class="btn full gold" id="sonarTap">🎯 Loten</button>
    <div class="lurebox" style="display:block;text-align:left;border-color:var(--accent);margin:10px 0 6px">
      <div class="nm" style="margin-bottom:3px">🛠️ Echolot-Upgrades im Angelladen</div>
      <div class="sub2" style="line-height:1.5">${upgList}</div></div>
    <button class="btn full" id="sonarShop" style="margin-top:2px">🛒 Upgrades im Angelladen ansehen</button>
    <button class="btn ghost full" id="sonarDone" style="margin-top:8px">Fertig</button></div>`;
  document.body.appendChild(ov);
  const sonar=ov.querySelector('#sonar'), scan=ov.querySelector('#scanline'), blips=[];
  for(let i=0;i<fishCount;i++){ const b=document.createElement('div'); b.textContent='🐟';
    b.style.cssText='position:absolute;font-size:'+fishSize+'px;transform:translate(-50%,-50%)';
    b.style.left=(12+Math.random()*76)+'%'; b._y=9+Math.random()*82; b.style.top=b._y+'%'; sonar.appendChild(b); blips.push(b); }
  let hits=0, y=0, dir=1, last=performance.now(), raf;
  const loop=now=>{ const dt=Math.min(0.05,(now-last)/1000); last=now; y+=dir*lineSpeed*dt; if(y>=100){y=100;dir=-1;} if(y<=0){y=0;dir=1;} scan.style.top=y+'%'; raf=requestAnimationFrame(loop); };
  raf=requestAnimationFrame(loop);
  const upd=()=>{ const st=ov.querySelector('#sonarStat'); if(st) st.textContent='Treffer: '+hits+' / '+goal+' · Versuche: '+tries; };
  const tap=()=>{ if(tries<=0||done) return; tries--; let hit=false;
    for(const b of blips){ if(!b._done && Math.abs(b._y-y)<tol){ b._done=true; b.textContent='✨'; b.style.filter='drop-shadow(0 0 6px #ffd965)'; hits++; hit=true; sfx.perfect(); vib(30); break; } }
    if(!hit) sfx.lose();
    upd();
    if(hits>=goal || tries<=0) setTimeout(finish, hits>=goal?150:550); };
  let done=false;
  const finish=()=>{ if(done) return; done=true; cancelAnimationFrame(raf); game.echoBonus=Math.min(1,hits/goal); game.echoGeber=(upGeber&&hits>0)?1:0; ov.remove();
    const pause=liveScope?'':' (Echolot 5 Min Pause)';
    toast(hits>0?('📡 Hotspot geortet ('+hits+'/'+goal+') – der nächste Wurf läuft besser!'+(upGeber?' 🏆 Trophäen-Chance erhöht!':'')+pause):'📡 '+pick(ECHO_FAILS)+pause); };
  ov.querySelector('#sonarTap').onclick=tap;
  ov.querySelector('#sonarShop').onclick=()=>{ cancelAnimationFrame(raf); done=true; ov.remove(); shopTab='gear'; go('shop'); };
  ov.querySelector('#sonarDone').onclick=finish;
}
/* ---- Keschern (Präzision): Kescher mit Maus/Touch auf den schwimmenden Fisch bewegen ---- */
function startNetting(){
  game.state='netting'; game.netPerfect=false;
  flashBig(pick(['🥅 Ab ins Netz!','🥅 Gleich ist er drin!','🥅 Jetzt keschern!']),'var(--accent2)',null,1300);   // kurzer Hinweis im „Drill, Baby, drill"-Stil
  $('#bobber').style.display='none'; hideLine();
  $('#actBtn').classList.add('hidden'); $('#idlebtns').classList.add('hidden'); { const eb=$('#echoBtn'); if(eb) eb.classList.add('hidden'); }
  const sr=$('#scene').getBoundingClientRect(), W=sr.width, H=sr.height;
  const spd=DIFFICULTY[S.difficulty].aimSpeed, buf=NETS[S.net].buffer;
  const brk=S.netBroken?0.5:1;   // zertrampelter Kescher → nur halb so groß
  const netSizeMul=(S.net==='klein')?1:0.8;   // gute Kescher ~20% kleiner (Standard-Kescher unverändert)
  const brasse=((S.netHardUntil||0)>Date.now());   // „Brasse gefangen"-Event: Fisch 3 Min lang schneller
  const expMul=1+Math.min(0.6,(S.totalCatch||0)*0.006);   // erfahrene Spieler (viele Fänge) → Fisch bis +60% schneller, damit Keschern fordernd bleibt
  const hardMul=(brasse?1.3:1)*expMul;   // Gesamt-Tempofaktor des Fisches beim Keschern
  game.net={ W,H, spd, hardMul, agility:(NETS[S.net].agility||6),
    fx:(0.3+Math.random()*0.4)*W, fy:(0.45+Math.random()*0.16)*H,
    vx:(Math.random()<.5?-1:1)*(50+30*spd), vy:(Math.random()-0.5)*70,
    nx:W*0.5, ny:H*0.62, tx:W*0.5, ty:H*0.62, cap:0, captureTime:0.95,
    catchR: Math.max(12, H*0.053*buf*(1.5-0.4*spd)*brk*netSizeMul),
    dartT:0, nextDart: performance.now()+1400,
    last:performance.now(),
    deadline: performance.now() + (S.difficulty==='leicht'?16000:S.difficulty==='schwer'?9000:12000) };
  const f=$('#netfish'); f.style.display='block'; f.innerHTML=fishIcon(game.pendingSp,46);
  const c=$('#netcatcher'); c.style.display='block';
  const sz=2*game.net.catchR+'px';
  c.querySelector('.netring').style.width=sz; c.querySelector('.netring').style.height=sz;
  const cf=$('#capfill'); cf.style.width=sz; cf.style.height=sz;
  const hd=c.querySelector('.nethandle'); if(hd) hd.style.height=(game.net.catchR+64)+'px';
  const touchDev=('ontouchstart' in window)||navigator.maxTouchPoints>0;
  setMsg(sizeFeel(game.pendingSp,game.pendingWeight)+(S.netBroken?' 🥅⚠️ Beschädigter Kescher (halb so groß!) – ':' 🥅 ')+(brasse?'🐠 Brasse-Chaos: Der Fisch ist gerade besonders flink! ':'')+'Kescher auf den Fisch halten – Vorsicht, er flüchtet in Sprüngen!'+(touchDev?' (Der Kescher schwebt über deinem Finger.)':''));
  // Dauerhafter Hinweis, solange der Kescher reduziert/erschwert ist
  { const old=$('#netHint'); if(old) old.remove();
    const mk=(t,bg)=>'<div style="background:'+bg+';color:#fff;font-weight:900;font-size:13px;padding:4px 12px;border-radius:12px;white-space:nowrap;box-shadow:0 2px 8px #000">'+t+'</div>';
    let html=''; if(S.netBroken) html+=mk('🥅 Kaputter Kescher!','rgba(224,83,61,.94)'); if(brasse) html+=mk('🐠 Brassen-Schleim am Kescher!','rgba(150,138,40,.94)');
    if(html){ const nh=document.createElement('div'); nh.id='netHint'; nh.style.cssText='position:absolute;left:50%;top:5%;transform:translateX(-50%);display:flex;flex-direction:column;gap:4px;align-items:center;z-index:8;pointer-events:none'; nh.innerHTML=html; const sc=$('#scene'); if(sc) sc.appendChild(nh); } }
  // Auf Touch-Geräten den Kescher oberhalb des Fingers führen, damit der Finger Fisch & Fangzone nicht verdeckt
  game.netMove=(e)=>{ const r=$('#scene').getBoundingClientRect();
    const t=e.touches&&e.touches[0];
    const isTouch=!!t || e.pointerType==='touch';
    const px=(t?t.clientX:e.clientX), py=(t?t.clientY:e.clientY);
    if(px==null) return;
    const yoff=isTouch ? (game.net.catchR+48) : 0;
    game.net.tx=Math.max(0,Math.min(r.width,px-r.left));
    game.net.ty=Math.max(0,Math.min(r.height,(py-r.top)-yoff)); };
  const sc=$('#scene');
  sc.addEventListener('pointermove',game.netMove); sc.addEventListener('pointerdown',game.netMove);
  sc.addEventListener('touchmove',game.netMove,{passive:true}); sc.addEventListener('touchstart',game.netMove,{passive:true});
  game.netRAF=requestAnimationFrame(netLoop);
}
function netLoop(now){
  const n=game.net; if(!n||game.state!=='netting') return;
  let dt=Math.min(0.05,(now-n.last)/1000); n.last=now;
  // Fluchtsprint des Fisches
  if(now>n.nextDart){ const a=Math.random()*6.283, burst=175+90*n.spd; n.vx=Math.cos(a)*burst; n.vy=Math.sin(a)*burst*0.8;
    n.dartT=0.42; n.nextDart=now+(1700+Math.random()*2000)/(0.6+n.spd*0.6); if(now>n.last+0) sfx.splash(); }
  if(n.dartT>0){ n.dartT-=dt; }
  else if(Math.random()<dt*0.7){ n.vx=(Math.random()<.5?-1:1)*(50+30*n.spd); n.vy=(Math.random()-0.5)*70; }
  const hm=n.hardMul||1;   // „Brasse"-Event → Fisch bewegt sich 30% schneller
  n.fx+=n.vx*dt*hm; n.fy+=n.vy*dt*hm;
  const W=n.W,H=n.H, minX=0.12*W,maxX=0.88*W,minY=0.40*H,maxY=0.66*H;   // Fisch bleibt über der Info-Box sichtbar
  if(n.fx<minX){n.fx=minX;n.vx=Math.abs(n.vx);n.dartT=0;} if(n.fx>maxX){n.fx=maxX;n.vx=-Math.abs(n.vx);n.dartT=0;}
  if(n.fy<minY){n.fy=minY;n.vy=Math.abs(n.vy);} if(n.fy>maxY){n.fy=maxY;n.vy=-Math.abs(n.vy);}
  // Kescher folgt dem Zeiger – Tempo abhängig vom Kescher (agility)
  const fol=Math.min(1, n.agility*dt); n.nx+=(n.tx-n.nx)*fol; n.ny+=(n.ty-n.ny)*fol;
  const d=Math.hypot(n.nx-n.fx, n.ny-n.fy);
  if(d<n.catchR){ n.cap+=dt/n.captureTime; if(Math.random()<dt*6) sfx.netfill(n.cap); } else n.cap-=dt*0.5;
  n.cap=Math.max(0,Math.min(1,n.cap));
  const f=$('#netfish'); f.style.left=n.fx+'px'; f.style.top=n.fy+'px';
  f.style.transform='translate(-50%,-50%) scaleX('+(n.vx>0?-1:1)+')'+(n.dartT>0?' scale(1.15)':'');
  const c=$('#netcatcher'); c.style.left=n.nx+'px'; c.style.top=n.ny+'px';
  $('#capfill').style.transform='translate(-50%,-50%) scale('+n.cap+')';
  if(n.cap>=1){ game.netPerfect=d<n.catchR*0.45; netCleanup(); sfx.land(); recordCatch(game.pendingSp,game.pendingWeight); game.state='done'; return; }
  if(now>n.deadline){ netCleanup(); sfx.lose(); game.state='done'; showLoss('💦','Beim Keschern verloren!','Der Fisch ist im letzten Moment aus dem Kescher gesprungen.','Halt den Kescher ruhig auf dem Fisch – er flüchtet in Sprüngen. Ein größerer & wendigerer Kescher fängt ihn deutlich leichter.'); return; }
  game.netRAF=requestAnimationFrame(netLoop);
}
function netCleanup(){
  cancelAnimationFrame(game.netRAF);
  const sc=$('#scene');
  if(game.netMove&&sc){ sc.removeEventListener('pointermove',game.netMove); sc.removeEventListener('pointerdown',game.netMove);
    sc.removeEventListener('touchmove',game.netMove); sc.removeEventListener('touchstart',game.netMove); }
  game.netMove=null;
  const f=$('#netfish'),c=$('#netcatcher'); if(f)f.style.display='none'; if(c)c.style.display='none';
  { const nh=$('#netHint'); if(nh) nh.remove(); }
}
/* ========================= ABZEICHEN / ERFOLGE ========================= */
const ACHIEVEMENTS=[
  {id:'first', ic:'🎣', name:'Erster Fang', desc:'Fange deinen ersten Fisch.', check:()=>S.totalCatch>=1},
  {id:'c25',   ic:'🐟', name:'Routinier', desc:'Fange 25 Fische.', check:()=>S.totalCatch>=25},
  {id:'c100',  ic:'🏅', name:'Vollprofi', desc:'Fange 100 Fische.', check:()=>S.totalCatch>=100},
  {id:'allsp', ic:'📖', name:'Sammler', desc:'Fange jede Fischart mindestens einmal.', check:()=>Object.keys(S.book).length>=Object.keys(SPECIES).length},
  {id:'trophy',ic:'🏆', name:'Kapitaler Fang', desc:'Lande einen Trophäenfisch.', check:()=>Object.entries(S.book).some(([k,r])=>SPECIES[k]&&r.bestW>=SPECIES[k].trophy)},
  {id:'pike',  ic:'🐊', name:'Großhecht', desc:'Fange einen Hecht über 9 kg.', check:()=>((S.book.hecht||{}).bestW||0)>=9},
  {id:'cat',   ic:'🐋', name:'Waller-Bändiger', desc:'Fange einen Wels über 20 kg.', check:()=>((S.book.wels||{}).bestW||0)>=20},
  {id:'night', ic:'🌙', name:'Nachtschwärmer', desc:'Fange 5 Fische bei Nacht.', check:()=>(S.nightCatch||0)>=5},
  {id:'rel',   ic:'🤲', name:'Catch & Release', desc:'Setze 5 Fische schonend zurück.', check:()=>(S.releases||0)>=5},
  {id:'boss',  ic:'🐉', name:'Legendenjäger', desc:'Lande eine Gewässer-Legende.', check:()=>!!S.bosses&&Object.keys(S.bosses).length>=1},
  {id:'alllegends', ic:'🏵️', name:'Legenden-Sammler', desc:'Lande alle Legenden aller Gewässer.', check:()=>{const g=S.bosses||{}; return allBosses().every(b=>g[b.name]);}},
  {id:'tour',  ic:'🥇', name:'Turniersieger', desc:'Gewinne ein Turnier.', check:()=>(S.tourWins||0)>=1},
  {id:'rich',  ic:'💰', name:'Gut betucht', desc:'Besitze 5.000 Münzen.', check:()=>S.money>=5000},
  {id:'chal',  ic:'🥇', name:'Challenger', desc:'Schließe eine Challenge ab.', check:()=>(S.chDone||[]).length>=1},
  {id:'allchal',ic:'👑',name:'Challenge-König', desc:'Schließe alle Challenges ab.', check:()=>(S.chDone||[]).length>=CHALLENGES.length},
  {id:'coupon',ic:'🎟️', name:'Durchgespielt', desc:'Erspiele dir den 10.000-Punkte-Gutschein.', check:()=>!!S.couponEarned},
  {id:'reflex', ic:'⚡', name:'Schneller Anschlag', desc:'3 perfekte Anhiebe (<300 ms) in Folge.', check:()=>!!S.hook&&(S.hook.bestStreak||0)>=3},
  {id:'reflexpro', ic:'🎮', name:'Pro-Gamer-Reflexe', desc:'Ø-Reaktion unter 260 ms (ab 10 Anhieben).', check:()=>!!S.hook&&S.hook.n>=10&&(S.hook.sum/S.hook.n)<260},
];
function checkBadges(){
  if(!S.badges) S.badges=[]; let any=false;
  for(const a of ACHIEVEMENTS){ if(!S.badges.includes(a.id) && a.check()){ S.badges.push(a.id); any=true;
    (a=>setTimeout(()=>{ toast('🏅 Abzeichen: '+a.name); sfx.coupon(); vib([0,40,60,40]); },1200))(a); } }
  if(any) save();
}
function renderBadges(){
  checkBadges(); const got=new Set(S.badges||[]);
  let h=topBack()+`<h2>🏅 Erfolge <span class="donebadge" style="vertical-align:middle">${got.size}/${ACHIEVEMENTS.length}</span></h2><p class="sub">Sammle Abzeichen für besondere Angel-Leistungen.</p><div class="grid cols2">`;
  for(const a of ACHIEVEMENTS){ const has=got.has(a.id);
    h+=`<div class="pick${has?' chdone':''}" style="cursor:default">
      <div class="ttl"><span class="ic">${has?a.ic:'🔒'}</span> ${a.name} ${has?'<span class="donebadge">✅</span>':''}</div>
      <div class="meta">${a.desc}</div></div>`; }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h; wireBack('start');
}
/* ========================= TAGESAUFGABE ========================= */
function todayStr(){ const d=new Date(); return d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate(); }
function hashStr(s){ let h=0; for(let i=0;i<s.length;i++) h=(h*31+s.charCodeAt(i))|0; return Math.abs(h); }
const DAILY_POOL=[
  {kind:'total',  n:3, rew:120, txt:'Fange 3 Fische'},
  {kind:'total',  n:6, rew:220, txt:'Fange 6 Fische'},
  {kind:'sp', sp:'barsch', n:2, rew:160, txt:'Fange 2 Barsche'},
  {kind:'sp', sp:'hecht',  n:1, rew:180, txt:'Fange einen Hecht'},
  {kind:'sp', sp:'zander', n:2, rew:200, txt:'Fange 2 Zander'},
  {kind:'trophy', n:1, rew:320, txt:'Lande einen Trophäenfisch'},
  {kind:'weight', n:5, rew:240, txt:'Fange zusammen 5 kg Fisch'},
];
function ensureDaily(){ const t=todayStr();
  if(!S.daily || S.daily.date!==t){ S.daily={date:t, idx:hashStr(t)%DAILY_POOL.length, prog:0, claimed:false}; save(); } }
function dailyDef(){ ensureDaily(); return DAILY_POOL[S.daily.idx]; }
function dailyDone(){ return S.daily && S.daily.prog>=dailyDef().n; }
function updateDaily(sp,weight){ ensureDaily(); if(S.daily.claimed) return; const d=DAILY_POOL[S.daily.idx];
  if(d.kind==='total') S.daily.prog++;
  else if(d.kind==='sp'){ if(sp===d.sp) S.daily.prog++; }
  else if(d.kind==='trophy'){ if(weight>=SPECIES[sp].trophy) S.daily.prog++; }
  else if(d.kind==='weight') S.daily.prog=Math.min(d.n,+(S.daily.prog+weight).toFixed(2));
  if(S.daily.prog>=d.n && !S.daily.announced){ S.daily.announced=true; setTimeout(()=>toast('✅ Tagesaufgabe geschafft – hol die Belohnung auf der Startseite ab!'),1600); } }
function claimDaily(){ const d=dailyDef(); if(!dailyDone()||S.daily.claimed) return; S.daily.claimed=true;
  S.money+=d.rew; addXp(Math.round(d.rew*0.5)); save(); syncTop(); sfx.coupon();
  toast('🎁 +'+d.rew+' 💶 & +'+Math.round(d.rew*0.5)+' Punkte!'); renderStart(); }
function dailyCardHTML(){ const d=dailyDef(); const done=dailyDone(); const prog=Math.min(S.daily.prog,d.n);
  const pct=Math.round(prog/d.n*100);
  return `<div class="card" style="margin-top:10px;border-color:${done?'var(--accent2)':'var(--line)'}">
    <b>📅 Tagesaufgabe</b>
    <div class="sub" style="margin:6px 0 4px">${d.txt} · Belohnung: <b>${d.rew} 💶</b></div>
    <div class="meter" style="margin:4px 0"><i style="width:${pct}%;background:${done?'var(--accent2)':'var(--accent)'}"></i></div>
    <div class="sub2" style="margin:2px 0 8px">${d.kind==='weight'?prog.toFixed(1):prog} / ${d.n}${d.kind==='weight'?' kg':''}</div>
    ${S.daily.claimed?'<div class="sub2" style="color:var(--accent2)">✅ Heute schon abgeholt – morgen gibt’s eine neue Aufgabe.</div>'
      :done?'<button class="btn full gold" id="claimDaily">🎁 Belohnung abholen</button>'
      :'<div class="sub2">Noch nicht geschafft – ab ans Wasser!</div>'}</div>`; }
/* ========================= TROPHÄEN-BILD ========================= */
function shareTrophyImage(sp,weight,boss){
  const s=SPECIES[sp], W=900, H=900;
  const c=document.createElement('canvas'); c.width=W; c.height=H; const x=c.getContext('2d');
  const g=x.createLinearGradient(0,0,0,H);
  if(boss){ g.addColorStop(0,'#5a2a86'); g.addColorStop(1,'#0a1f31'); } else { g.addColorStop(0,'#1a4e7c'); g.addColorStop(1,'#0a1f31'); }
  x.fillStyle=g; x.fillRect(0,0,W,H);
  x.strokeStyle=boss?'#c98bff':'#ffb71b'; x.lineWidth=14; x.strokeRect(26,26,W-52,H-52);
  x.textAlign='center';
  const banner = boss?'🐉 LEGENDE GELANDET' : (weight>=s.trophy?'🏆 KAPITALER FANG':'🎣 MEIN FANG');
  x.fillStyle='#eaf3fb'; x.font='bold 46px sans-serif'; x.fillText(banner, W/2, 124);
  x.font='220px sans-serif'; x.fillText(s.em||'🐟', W/2, 400);
  if(boss){ x.fillStyle='#e7c6ff'; x.font='bold 60px sans-serif'; x.fillText(boss.name, W/2, 500);
            x.fillStyle='#c9d6e6'; x.font='34px sans-serif'; x.fillText('('+s.name+')', W/2, 546); }
  else { x.fillStyle='#ffb71b'; x.font='bold 66px sans-serif'; x.fillText(s.name+(s.special?' ⭐':''), W/2, 522); }
  x.fillStyle='#fff'; x.font='bold 54px sans-serif'; x.fillText(fmtW(weight)+'  ·  ~'+lengthEst(sp,weight)+' cm', W/2, boss?612:600);
  x.fillStyle='#a3c0db'; x.font='34px sans-serif'; x.fillText(WATERS[S.water].name+'  ·  '+todayStr(), W/2, boss?664:658);
  x.fillStyle='#eaf3fb'; x.font='bold 38px sans-serif'; x.fillText('🎣 Petri – Das Angelspiel', W/2, 802);
  x.fillStyle='#a3c0db'; x.font='30px sans-serif'; x.fillText('Spiel mit auf HechtundBarsch.de', W/2, 848);
  // Teilen-Text (kein Bildpfad, aber Einladung zum Mitspielen)
  const txt = (boss?('🐉 '+boss.name+' ('+s.name+')'):('🎣 '+s.name))+' mit '+fmtW(weight)+' gefangen bei „Petri – Das Angelspiel" von HechtundBarsch.de!\n\nSpiel mit unter '+GAME_URL;
  c.toBlob(blob=>{ if(!blob){ toast('Bild konnte nicht erstellt werden'); return; }
    const file=new File([blob],'mein-fang.png',{type:'image/png'});
    if(navigator.canShare && navigator.canShare({files:[file]})){
      navigator.share({files:[file], title:'Mein Fang', text:txt}).catch(()=>{});
    } else {
      const a=document.createElement('a'); a.href=URL.createObjectURL(blob); a.download='mein-fang.png'; a.click();
      setTimeout(()=>URL.revokeObjectURL(a.href),3000); toast('📸 Trophäenbild gespeichert!');
    }
  },'image/png');
}
/* ========================= PROFI-SETUPS (LOADOUTS) ========================= */
const LOADOUTS=[
  {name:'Hecht-Setup (Ufer)',ic:'🐊',lure:'busterjerk',rig:'direkt',color:'grell',
    url:'https://www.hechtundbarsch.de/collections/hecht',
    tip:'Große Jerk-/Hardbaits am Stahlvorfach, auffällige Reizfarben bei trübem Wasser. Kräftige Rute mit Power, Spot: Ufer/Schilf.'},
  {name:'Zander-Setup (Grund)',ic:'🐠',lure:'easyshiner',rig:'jigkopf',color:'naturell',
    url:'https://www.hechtundbarsch.de/collections/zander',
    tip:'Gummifisch am Jigkopf, naturnahe Farben, Dämmerung & Nacht. Sensible, straffe Rute. Spot: Kante/Tiefe.'},
  {name:'Barsch-Finesse',ic:'🐟',lure:'dropshot',rig:'dropshot',color:'naturell',
    url:'https://www.hechtundbarsch.de/collections/barsch',
    tip:'Drop-Shot mit kleinen Ködern, feines Gerät, klares Wasser = Naturfarben. Spot: Kante/Freiwasser.'},
  {name:'Krebs-Setup (Barsch & Zander)',ic:'🦀',lure:'finessecraw',rig:'jigkopf',color:'naturell',
    url:'https://www.hechtundbarsch.de/collections/barsch',
    tip:'Krebs-Köder am Jigkopf/Texas am Grund – DER Köder für kapitale Barsche, auch Zander lieben Krebse. Naturfarben, langsam am Grund führen. Spot: Kante/Tiefe.'},
  {name:'Wels-Setup (schwer)',ic:'🐋',lure:'bigshiner',rig:'grund',color:'grell',
    url:'https://www.hechtundbarsch.de/collections/wels',
    tip:'Großer Köder am Grund, Wallerrute & Big-Pit-Rolle, XL-Kescher. Nachts am stärksten. Spot: Kante/Tiefe.'},
  {name:'Rapfen-Setup (Freiwasser)',ic:'🐬',lure:'uvspoon',rig:'direkt',color:'uv',
    url:'https://www.hechtundbarsch.de/collections/spinnfischen',
    tip:'Weit werfende Blinker/Spinner, schnelle Führung im freien Wasser bei Sonne. Spot: Freiwasser.'},
];
function renderLoadouts(){
  let h=topBack()+`<h2>🎯 Profi-Setups</h2><p class="sub">Bewährte Kombis je Zielfisch – im Spiel ausrüsten und die passenden echten Produkte im Shop entdecken.</p><div class="grid">`;
  for(const L of LOADOUTS){ const lu=LURES[L.lure];
    h+=`<div class="pick" style="cursor:default">
      <div class="ttl"><span class="ic">${L.ic}</span> ${L.name}</div>
      <div class="meta">${L.tip}<br><b>Köder:</b> ${lu.ic} ${lu.name} · <b>Montage:</b> ${RIGS[L.rig].ic} ${RIGS[L.rig].name} · <b>Farbe:</b> ${COLORS[L.color].ic} ${COLORS[L.color].name}</div>
      <div class="btnrow" style="margin-top:10px">
        <button class="btn gold" style="flex:1" data-lo="${L.name}">🎒 Ausrüsten</button>
        <a class="btn ghost" style="flex:1;text-decoration:none" href="${L.url}" target="_blank" rel="noopener">🛒 Shop ↗</a>
      </div></div>`; }
  h+=`</div><div class="btnrow">${backBtn()}</div>`;
  screen.innerHTML=h;
  screen.querySelectorAll('[data-lo]').forEach(b=>b.onclick=()=>equipLoadout(LOADOUTS.find(x=>x.name===b.dataset.lo)));
  wireBack('start');
}
function equipLoadout(L){
  S.color=L.color; let note='';
  if(S.ownLures.includes(L.lure)){ S.lure=L.lure; S.rig=L.rig; }
  else note=' – Köder „'+LURES[L.lure].name+'" noch im Angelladen kaufen';
  save(); sfx.buy(); toast('🎒 Setup „'+L.name+'" ausgerüstet'+note);
}
/* Schonmaß (kg) – darunter MUSS schonend zurückgesetzt werden (kein Verkauf, aber Karma) */
const SCHONMASS={barsch:0.12,hecht:0.9,zander:0.7,blackbass:0.3,rapfen:0.5,wels:0,dorsch:1.0,seelachs:1.0,heilbutt:0};
function schonmass(sp){ return SCHONMASS[sp]||0; }
/* Legenden / Boss-Fische je Gewässer – seltene, riesige benannte Fische */
const BOSSES={
  mueritz:[
    {name:'„Old Esox"',sp:'hecht',kg:14.5},
    {name:'Barsch-Opa „Klops"',sp:'barsch',kg:1.7},
    {name:'Müritz-Geist (Zander)',sp:'zander',kg:9.5},
  ],
  bodensee:[
    {name:'Kretzer „Brocken"',sp:'barsch',kg:1.9},
    {name:'Bodensee-Esox „Lang-Heini"',sp:'hecht',kg:15.5},
    {name:'„Silberpfeil" (Rapfen)',sp:'rapfen',kg:6.5},
  ],
  mittellandkanal:[
    {name:'Kanal-Schatten (Zander)',sp:'zander',kg:11.5},
    {name:'Streifenboss „Buckliger"',sp:'barsch',kg:1.75},
    {name:'Schleusen-Hecht',sp:'hecht',kg:13},
  ],
  rhein:[
    {name:'Rhein-Waller „Hannibal"',sp:'wels',kg:64},
    {name:'Buhnen-König (Zander)',sp:'zander',kg:10.5},
    {name:'Strom-Rapfen „Stromer"',sp:'rapfen',kg:7},
  ],
  edersee:[
    {name:'Der Graf vom Edersee',sp:'hecht',kg:16.5},
    {name:'Tiefen-Zander „Schatten"',sp:'zander',kg:11},
    {name:'Barsch „Dickkopf"',sp:'barsch',kg:1.8},
  ],
  ebro:[
    {name:'„El Gigante" (Wels)',sp:'wels',kg:88},
    {name:'Bass „El Toro"',sp:'blackbass',kg:4.3},
    {name:'Rapfen „Bandido"',sp:'rapfen',kg:7.5},
  ],
  norwegen:[
    {name:'Heilbutt „Trollet"',sp:'heilbutt',kg:165},
    {name:'Dorsch „Brummer"',sp:'dorsch',kg:22},
    {name:'Köhler „Express"',sp:'seelachs',kg:17},
  ],
};
/* alle Legenden eines Gewässers, passend zur Art – bevorzugt noch nicht gefangene */
function pickBoss(sp){
  const list=BOSSES[S.water]||[]; const matching=list.filter(b=>b.sp===sp);
  if(!matching.length) return null;
  const fresh=matching.filter(b=>!(S.bosses&&S.bosses[b.name]));
  const pool=fresh.length?fresh:matching;
  return pool[Math.floor(Math.random()*pool.length)];
}
function allBosses(){ const a=[]; for(const w in BOSSES) for(const b of BOSSES[w]) a.push(Object.assign({water:w},b)); return a; }
function bossChance(){ return Math.min(0.24, 0.05+(game&&game.castScore?game.castScore*0.04:0)+(game&&game.echoBonus?game.echoBonus*0.05:0)+(game&&game.echoGeber?0.06:0)+(S.fromBoat?0.02:0)+(activeGuide()?0.03:0)); }
/* ========================= EINSTIEG: ANGELKUMPEL (Wizard) ========================= */
const BUDDY={ name:'Kalle', rod:'dentist', reel:'vanquish', net:'folding', lure:'easyshiner', color:'naturell', rig:'jigkopf', ms:300000 };
function buddyActive(){ return !!(S.buddyUntil && Date.now()<S.buddyUntil); }
function startBuddy(){
  if(S.buddySeen) return;              // Kalle erscheint garantiert nur 1× pro Spieler
  S.buddySeen=true; S.tipsSeen=true; save();   // sofort merken (Onboarding ersetzt das Tipps-Popup)
  const g=BUDDY, added=[];
  const lend=(arr,k)=>{ if(!S[arr].includes(k)){ S[arr].push(k); added.push([arr,k]); } };
  lend('ownRods',g.rod); lend('ownReels',g.reel); lend('ownNets',g.net); lend('ownLures',g.lure);
  S.rod=g.rod; S.reel=g.reel; S.net=g.net; S.lure=g.lure; S.color=g.color; S.rig=g.rig;
  S.buddyGear={added}; S.buddyUntil=Date.now()+g.ms; save(); syncTop();
  showBuddyIntro();
}
function showBuddyIntro(){
  const g=BUDDY;
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 ZUFALLS-BEGEGNUNG</div>
    <div style="font-size:54px">🎣🧑‍🤝‍🧑</div>
    <div class="fname">Dein Kumpel ${g.name} ist da!</div>
    <div class="sub" style="margin:8px 6px">Was für ein Zufall – dein bester Angelkumpel ${g.name} fischt auch hier! Er drückt dir für die <b>nächsten 5 Minuten</b> sein Top-Tackle in die Hand (alles schon angelegt):</div>
    <div class="lurebox" style="display:block;text-align:left">
      <div class="sub2">🎣 Rute: <b>${RODS[g.rod].name}</b></div>
      <div class="sub2">⚙️ Rolle: <b>${REELS[g.reel].name}</b></div>
      <div class="sub2">🥅 Kescher: <b>${NETS[g.net].name}</b></div>
      <div class="sub2">🐟 Köder: <b>${LURES[g.lure].name}</b></div>
    </div>
    <div class="sub" style="margin:8px 6px">Danach nimmt ${g.name} sein Tackle wieder mit – dann fischst du mit dem Basis-Gerät. <b>Nutz die Zeit & fang was Großes!</b></div>
    <button class="btn full gold" id="buddyGo">🎣 Auf geht's!</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#buddyGo').onclick=()=>ov.remove();
}
function endBuddy(){
  const bg=S.buddyGear;
  if(bg&&bg.added){ for(const [arr,k] of bg.added){ const i=S[arr]?S[arr].indexOf(k):-1; if(i>=0) S[arr].splice(i,1); } }
  S.rod='teleskop'; S.reel='basic'; S.net='klein'; S.lure='tauwurm'; S.color='naturell'; S.rig='jigkopf';
  S.buddyGear=null; S.buddyUntil=0; save(); syncTop();
  showBuddyEnd();
  if(route==='fish') renderFishing();
}
function showBuddyEnd(){
  const g=BUDDY;
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:380px;text-align:center">
    <div style="font-size:52px">👋🎣</div>
    <div class="fname">${g.name} muss los</div>
    <div class="sub" style="margin:8px 6px">Deine 5 Minuten mit ${g.name}s Top-Tackle sind vorbei – er nimmt seine Sachen wieder mit. Ab jetzt fischst du mit deinem <b>Basis-Gerät</b>.</div>
    <div class="sub" style="margin:8px 6px">Im <b>Angelladen</b> rüstest du dich Stück für Stück selbst mit richtig gutem Gerät aus!</div>
    <button class="btn full gold" id="buddyEndGo">Alles klar!</button>
    <button class="btn ghost full" id="buddyShop" style="margin-top:8px">🛒 Zum Angelladen</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#buddyEndGo').onclick=()=>ov.remove();
  ov.querySelector('#buddyShop').onclick=()=>{ ov.remove(); go('shop'); };
}
function recordCatch(sp,weight){
  slipStreak=0;   // erfolgreich gelandet → Verlust-Serie zurücksetzen
  const s=SPECIES[sp];
  const boss=(game&&game.boss)||null;
  const released = !boss && schonmass(sp)>0 && weight<schonmass(sp);   // untermaßig → C&R
  const sizeMul=0.6+(weight/Math.max(s.trophy,0.1))*1.1;
  let money=released?0:Math.round(s.value*sizeMul);
  if(boss) money=Math.round(money*1.5)+400;   // Legenden-Bonus
  const xp=Math.round(s.xp*sizeMul*(boss?1.6:1)), prevLvl=S.level;
  let netNote='';
  if(!released && game.netPerfect){ const b=Math.round(money*0.3); money+=b; netNote='🥅 Sauber gekeschert! +'+b+' 💶 Bonus'; }
  if(released){ S.releases=(S.releases||0)+1; addKarma(2); if(Math.random()<0.4) S.nextBigFish=true; netNote='🤲 Untermaßig – schonend zurückgesetzt. Petri Dank für den Naturschutz! (+2 ☯️ Karma)'; }
  else if(boss){ addKarma(-4); netNote=(netNote?netNote+' · ':'')+'🐉 Legende entnommen – schlecht fürs Karma (−4 ☯️). Setz Legenden besser zurück!'; }
  S.money+=money; addXp(xp); S.totalCatch++;
  if(!released) S.nextBigFish=false;   // Karma-Bonus verbraucht (außer Release vergibt neuen)
  S.nextBadFish=false;                 // „Fischadler"-Malus gilt nur für diesen einen Fang
  if(boss){ if(!S.bosses) S.bosses={}; S.bosses[boss.name]=true; }   // Legende nach Namen sammeln
  const rec=S.book[sp]||{count:0,bestW:0}; const isRecord=weight>rec.bestW; rec.count++; if(isRecord)rec.bestW=weight; S.book[sp]=rec;
  // Köder einfischen
  if(!S.lureXp) S.lureXp={}; const preLureLv=lureLevel(S.lure); S.lureXp[S.lure]=lureUses(S.lure)+1;
  if(lureLevel(S.lure)>preLureLv) setTimeout(()=>toast('🎣 '+LURES[S.lure].name+' ist jetzt eingefischt '+lureStars(S.lure)+' – fängt etwas größere Fische!'),900);
  if(TIMES[S.time].night) S.nightCatch=(S.nightCatch||0)+1;
  updateDaily(sp,weight);
  let couponNew=false;
  if(!S.couponEarned && S.xp>=COUPON_POINTS && S.difficulty!=='leicht'){ S.couponEarned=true; couponNew=true; setTimeout(()=>sfx.coupon(),700); }
  if(challengeActive()) challengeOnCatch(sp,weight);
  if(TOURNEY) TOURNEY.score+=weight;
  if(activeGuide()){ if(!S.guideCatch) startGuideSession(); const gc=S.guideCatch;
    gc.n++; gc.kg+=weight; gc.bySp[sp]=(gc.bySp[sp]||0)+1; if(weight>gc.bigW){ gc.bigW=weight; gc.bigSp=sp; } }
  const found = Math.random()<0.18 ? findTackle() : null;
  save(); syncTop(); checkBadges();
  showResult({sp,s,weight,money,xp,isRecord,isTrophy:weight>=s.trophy,lvlUp:S.level>prevLvl,lure:LURES[S.lure],hookLabel:game.hookLabel,diff:DIFFICULTY[S.difficulty].name,netNote,found,couponNew,released,boss});
}

/* ---- Gefundenes / fremdes Tackle ---- */
function findTackle(){
  const pools=[['lure',LURES,S.ownLures],['rod',RODS,S.ownRods],['reel',REELS,S.ownReels],['net',NETS,S.ownNets]];
  const c=[];
  for(const [cat,items,own] of pools) for(const k in items) if(items[k].price>0 && !own.includes(k)) c.push([cat,k,items[k]]);
  return c.length ? c[Math.floor(Math.random()*c.length)] : null;
}
function equipItem(cat,k,equip){
  const map={lure:['ownLures','lure'],rod:['ownRods','rod'],reel:['ownReels','reel'],net:['ownNets','net']};
  const [ownKey,field]=map[cat]; if(!S[ownKey].includes(k)) S[ownKey].push(k);
  if(equip){ S[field]=k; if(cat==='net') S.netBroken=false; if(cat==='lure'&&!rigOK(S.rig,S.lure)) S.rig=defaultRigFor(S.lure); updateGearChips(); }
  save(); syncTop();
}
function updateGearChips(){
  const lc=document.getElementById('lurechip'); if(lc) lc.innerHTML=LURES[S.lure].ic+' '+LURES[S.lure].name;
  const tc=document.getElementById('techchip'); if(tc) tc.innerHTML=COLORS[S.color].ic+' · '+RIGS[S.rig].ic+' '+RIGS[S.rig].name;
}
function maybeFind(chance){
  if(Math.random()>=chance) return false;
  const f=findTackle(); if(f){ findModal(f); return true; } return false;
}
function findModal(f){
  const [cat,k,it]=f;
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal">
    <div class="ribbon">🎁 FUND AM UFER!</div>
    <div style="font-weight:900;font-size:18px;margin:6px 0">${it.name}</div>
    ${it.brand?`<div class="brandline" style="text-align:center;margin:0 0 4px">${it.brand}${it.hb?' · H&B Edition':''}</div>`:''}
    ${it.img?`<img class="findimg" src="${esc(it.img)}" onerror="this.style.display='none'">`:`<div style="font-size:60px">${it.ic}</div>`}
    <div class="sub">Ein anderer Angler hat dieses Tackle am Wasser vergessen – du darfst es behalten und direkt einsetzen!</div>
    <button class="btn full gold" id="fEquip" style="margin-top:10px">🎒 Aufheben & direkt benutzen</button>
    <button class="btn ghost full" id="fPack" style="margin-top:8px">In die Box (später nutzen)</button>
  </div>`;
  document.body.appendChild(ov);
  ov.querySelector('#fEquip').onclick=()=>{ equipItem(cat,k,true); sfx.buy(); toast('🎒 '+it.name+' angelegt'); ov.remove(); if(route==='fish') renderFishing(); };
  ov.querySelector('#fPack').onclick=()=>{ equipItem(cat,k,false); sfx.buy(); toast('🎒 '+it.name+' eingepackt'); ov.remove(); };
}
/* Zufallsevent: Müll am Wasser */
function maybeTrash(chance){ if(Math.random()>=chance) return false; showTrash(); return true; }
/* Weitere humorvolle Zufalls-Events */
const EVENTS=[
  {ic:'💶',t:'Glücksfund',x:'Im Schilf glitzert etwas – ein verlorener 20er! Den nimmst du natürlich mit. (+20 💶)',fn:()=>{S.money+=20;}},
  {ic:'🦢',t:'Schwan-Attacke',x:'Ein bulliger Höckerschwan zischt dich an und klaut frech deinen Köder. Notgedrungen montierst du wieder den guten alten Tauwurm.',fn:()=>{S.lure='tauwurm';if(!S.ownLures.includes('tauwurm'))S.ownLures.push('tauwurm');if(!rigOK(S.rig,'tauwurm'))S.rig=defaultRigFor('tauwurm');}},
  {ic:'🪺',t:'„Perücke"!',x:'Beim letzten Wurf gab es einen fiesen Schnursalat („Perücke"). Nach fünf Minuten Gefummel ist die Rolle wieder frei. Angeln ist Geduld.',fn:null},
  {ic:'📸',t:'Influencer am Start',x:'Ein Angel-Influencer filmt dich beim Wurf. Für die Kamera gibst du alles – der nächste Fisch wird bestimmt ein Brett!',fn:()=>{S.nextBigFish=true;}},
  {ic:'⛈️',t:'Wetterumschwung',x:'Dunkle Wolken ziehen auf – es fängt an zu regnen. Gut für dich: Raubfische werden bei Regen oft aktiver!',fn:()=>{S.weather='regen';}},
  {ic:'🐸',t:'Quak-Applaus',x:'Ein Frosch hockt sich auf deinen Schwimmer und quakt anerkennend. Glücksbringer? Wir werden sehen.',fn:null},
  {ic:'🦦',t:'Frecher Otter',x:'Ein Otter taucht auf, mampft genüsslich einen Fisch direkt vor dir und grinst. Na, vielen Dank auch.',fn:null},
  {ic:'🪱',t:'Wurmkönig',x:'Beim Buddeln triffst du auf den Wurmkönig – die dicksten Tauwürmer aller Zeiten. Der nächste Fisch wird ein guter!',fn:()=>{S.nextBigFish=true;}},
  {ic:'☕',t:'Vereinskollege',x:'Ein Vereinskollege drückt dir einen Kaffee in die Hand und verrät dir einen Hotspot. Danke! (+15 💶)',fn:()=>{S.money+=15;}},
  {ic:'🥾',t:'Watstiefel voll',x:'Du steigst einen Schritt zu weit rein – Wasser im Watstiefel. Kalt, aber selbst schuld. Wenigstens hat’s keiner gesehen.',fn:null},
  {ic:'🦅',t:'Fischadler',x:'Ein Fischadler stößt herab und schnappt sich direkt vor deiner Nase einen Fisch! Die Räuber sind jetzt aufgescheucht und ducken sich weg – beim <b>nächsten Wurf</b> beißen eher die kleineren Kaliber.',fn:()=>{S.nextBadFish=true;}},
  {ic:'🪙',t:'Schatz im Schlamm',x:'Im Uferschlamm blinkt eine alte Münze – richtiger Sammlerwert! (+25 💶)',fn:()=>{S.money+=25;}},
  {ic:'🐟',t:'Köderfisch-Panik',x:'Ein Schwarm Köderfische flüchtet panisch an die Oberfläche – Räuber sind unterwegs! Der nächste Fisch wird ein guter.',fn:()=>{S.nextBigFish=true;}},
  {ic:'🍟',t:'Currywurst-Pause',x:'Der Imbisswagen ruft. Currywurst-Pommes gönnst du dir – schmeckt, kostet aber. (−8 💶)',fn:()=>{S.money=Math.max(0,S.money-8);}},
  {ic:'🦆',t:'Entenfamilie',x:'Eine Entenmama führt ihre Küken quer durch deine Wurfschneise. Du wartest geduldig. Aww.',fn:null},
  {ic:'🅿️',t:'Knöllchen',x:'Falsch geparkt am See. Unterm Scheibenwischer klemmt ein Strafzettel. Petri Heil, liebe Politesse. (−15 💶)',fn:()=>{S.money=Math.max(0,S.money-15);}},
  {ic:'🎁',t:'Köder-Probe',x:'Ein LMAB-Promoter drückt dir eine brandneue Köder-Probe in die Hand. Der nächste Wurf sitzt bestimmt!',fn:()=>{S.nextBigFish=true;}},
  {ic:'🌈',t:'Regenbogen',x:'Nach einem kurzen Schauer spannt sich ein Regenbogen über das Wasser. Kitsch pur – aber schön (ein paar Minuten lang).',fn:()=>{S.rainbowUntil=Date.now()+180000;}},
  {ic:'☀️',t:'Sonnenfenster',x:'Die Wolken reißen auf, plötzlich Sonne satt. Das Wasser glitzert – und du schwitzt.',fn:()=>{S.weather='sonnig';}},
  {ic:'🐕',t:'Nasser Labrador',x:'Ein klatschnasser Labrador springt jubelnd in deine Angelstelle und vergrault die Fische! Die nächste Minute beißen nur noch kleine Kaliber.',fn:()=>{S.spookedUntil=Date.now()+60000;}},
  {ic:'🦟',t:'Mückenalarm',custom:()=>showMosquito()},
  {ic:'🧓',t:'Alter Hase',x:'Ein alter Angler verrät dir augenzwinkernd seinen Lieblingsspot und steckt dir was zu. (+12 💶)',fn:()=>{S.money+=12;}},
  {ic:'💨',t:'Fehlbiss',x:'Es klopfte, du schlugst an – ins Leere. Irgendwo unter Wasser lacht sich gerade ein Fisch schlapp.',fn:null},
  {ic:'🚤',t:'Bootswelle',custom:()=>showBoatWave()},
  {ic:'🐍',t:'Ringelnatter',x:'Eine harmlose Ringelnatter schlängelt elegant vorbei. Du erschrickst – sie sich vermutlich auch.',fn:null},
  {ic:'📵',t:'Akku leer',x:'Das Handy gibt den Geist auf. Keine Nachrichten, keine Ablenkung – nur du, die Rute und das Wasser. Herrlich.',fn:null},
  {ic:'🌙',t:'Wolke vorm Mond',x:'Eine Wolke schiebt sich vor den Mond – schlagartig perfekte Räuber-Stimmung am Wasser.',fn:null},
  {ic:'🍺',t:'Feierabendbier',x:'Der Angler vom Nachbarplatz teilt sein kühles Bier. Für einen Moment ist die Welt vollkommen in Ordnung.',fn:null},
  {ic:'🧊',t:'Kühlbox-Fund',x:'Ganz unten in der Kühlbox liegt doch noch ein vergessenes Brötchen. Unverhofftes Festmahl!',fn:null},
  {ic:'🪰',t:'Eintagsfliegen-Schlupf',x:'Tausende Eintagsfliegen schlüpfen – das ganze Wasser kocht vor fressenden Fischen! Nutz die Chance.',fn:()=>{S.nextBigFish=true;}},
  {ic:'🥅',t:'Kescher zertrampelt',x:'Autsch – du bist eben auf deinen Kescher getreten! Der Reifen ist verbogen, der Kescher ist nur noch <b>halb so groß</b>. Kauf dir im Angelladen einen neuen Kescher, dann ist er ersetzt.',fn:()=>{S.netBroken=true;}},
  {ic:'🐠',t:'Brasse gefangen',x:'Statt eines Räubers hängt eine fette, schleimige Brasse am Haken – die zappelt wie verrückt und bringt mächtig Unruhe ins Wasser. Die nächsten <b>3 Minuten</b> ist der zu keschernde Fisch <b>30 % schneller</b> und damit deutlich schwerer zu landen!',fn:()=>{S.netHardUntil=Date.now()+180000;}},
  {ic:'🪝',t:'Stumpfe Haken',x:'Beim Blick auf deine Montage merkst du: Deine Haken sind <b>richtig stumpf</b> geworden! So sitzt der Haken im Drill schlecht und jeder Fisch schlitzt leicht aus. Du solltest dir <b>scharfe Haken</b> im Angelladen (Zubehör) kaufen!',fn:()=>{ S.bluntHooks=true; const i=(S.ownGear||[]).indexOf('haken'); if(i>=0) S.ownGear.splice(i,1); }},
  {ic:'📡',t:'Angler am Live-Scope',custom:()=>showLivescopeAngler()},
  {ic:'🪨',t:'Hängerreicher Spot',custom:()=>showSnagAvoid()},
  {ic:'🎣',t:'Kapitaler Hänger',custom:()=>showSnagFree()},
  {ic:'🧭',t:'Neuen Spot suchen',custom:()=>showSpotSearch()},
  {ic:'🐟',t:'Barsch-Schwarm entdeckt',custom:()=>showPerchSwarm()},
];
/* Team-Begegnung als EIGENER Roll (sonst nur 1/32 im Pool → praktisch nie). Max. 2×/Stunde. */
function maybeTeam(chance){ if(!eventReady('Team von HechtundBarsch.de')) return false; if(Math.random()>=chance) return false;
  markEvent('Team von HechtundBarsch.de'); showTeam(); return true; }
/* ===== Team von HechtundBarsch.de – Zufallsbegegnung mit einem Teammitglied ===== */
function teamOv(){ const ov=document.createElement('div'); ov.className='overlay'; document.body.appendChild(ov); return ov; }
function teamClose(ov){ ov.remove(); if(route==='fish') renderFishing(); }
function showTeam(){ pick([showRonny,showMax,showBen,showKevin,showMicha])(); }
function showMicha(){
  const ov=teamOv();
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 TEAM HECHTUNDBARSCH</div>
    <div style="font-size:52px">🧑‍🏭📦</div>
    <div class="fname">Du triffst Micha</div>
    <div class="sub" style="margin:8px 6px">Micha ist im Dauerstress – „Boah, so viel zu tun hier…" stöhnt er und schleppt schon das nächste Paket. Lässt du ihn <b>in Ruhe weiterarbeiten</b>? Aus Dankbarkeit gibt er dir <b>20% Rabatt</b> im Angelladen für die nächsten <b>120 Sekunden</b>! Oder quatschst du ihn weiter zu und hältst ihn von der Arbeit ab – das bringt <b>+30 ☯️ Karma</b>, aber keinen Rabatt.</div>
    <button class="btn full gold" id="mi1">🙏 In Ruhe arbeiten lassen (−20% Rabatt · 120 s)</button>
    <button class="btn ghost full" id="mi2" style="margin-top:8px">💬 Weiter zuquatschen (+30 ☯️ Karma)</button></div>`;
  ov.querySelector('#mi1').onclick=()=>{ S.shopDiscUntil=Date.now()+120000; save(); syncTop(); sfx.coupon();
    toast('🏷️ Micha: „Danke, Mann!" – 20% Rabatt im Angelladen für 120 s!'); teamClose(ov); };
  ov.querySelector('#mi2').onclick=()=>{ addKarma(30); save(); syncTop(); sfx.tip();
    toast('💬 Micha seufzt, plaudert aber nett mit dir. (+30 ☯️ Karma)'); teamClose(ov); };
}
function showRonny(){
  const ov=teamOv(); const M=()=>ov.querySelector('.modal');
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 TEAM HECHTUNDBARSCH</div>
    <div style="font-size:52px">🧑‍🌾🍔</div>
    <div class="fname">Du triffst Ronny</div>
    <div class="sub" style="margin:8px 6px">Ronny arbeitet im HechtundBarsch-Lager und angelt ~200 Tage im Jahr – er kennt wirklich <b>jeden Spot</b>. Und er liebt Cheeseburger. Spendierst du ihm <b>2 Cheeseburger (50 💶)</b>? Mit <b>50 % Chance</b> verrät er die besten Stellen → die nächsten <b>3 Min</b> fängst du mit hoher Wahrscheinlichkeit einen sehr guten Fisch!</div>
    <button class="btn full gold" id="r1">🍔 2 Cheeseburger ausgeben (50 💶)</button>
    <button class="btn ghost full" id="r2" style="margin-top:8px">Lieber nicht</button></div>`;
  ov.querySelector('#r1').onclick=()=>{
    if(S.money<50){ toast('💶 Du hast keine 50 €'); return; }
    S.money-=50; const ok=Math.random()<0.5; if(ok){ S.goodSpotUntil=Date.now()+180000; sfx.coupon(); } else sfx.lose();
    save(); syncTop();
    M().innerHTML=`<div style="text-align:center"><div style="font-size:50px">${ok?'🤙🐟':'🍔😶'}</div>
      <div class="fname">${ok?'Ronny plaudert!':'Ronny mampft zufrieden'}</div>
      <div class="sub" style="margin:8px 6px">${ok?'„Komm, ich zeig dir die Hammer-Stellen!" – die nächsten <b>3 Minuten</b> beißen die richtig Großen! 🎣':'Die Burger waren top – aber zu den Spots schweigt er heute. Naja, nächstes Mal!'}</div>
      <button class="btn full gold" id="rGo">${ok?'🎣 Nichts wie hin!':'Schade.'}</button></div>`;
    M().querySelector('#rGo').onclick=()=>teamClose(ov); };
  ov.querySelector('#r2').onclick=()=>teamClose(ov);
}
function showMax(){
  const ov=teamOv(); const M=()=>ov.querySelector('.modal'); const owns=S.ownLures.includes('maxbait');
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 TEAM HECHTUNDBARSCH</div>
    <div style="font-size:52px">🧑‍💼🎣</div>
    <div class="fname">Du triffst Max</div>
    <div class="sub" style="margin:8px 6px">Max macht den Einkauf bei HechtundBarsch.de – er kennt <b>alle Neuheiten</b> am Markt. Aber er ist Geschäftsmann: Für <b>500 💶</b> schaut er in seiner Tacklebox nach einem <b>exklusiven Köder</b>, den es sonst nirgends zu kaufen gibt.</div>
    <button class="btn full gold" id="m1">💶 500 € zahlen</button>
    <button class="btn ghost full" id="m2" style="margin-top:8px">Zu teuer!</button></div>`;
  ov.querySelector('#m1').onclick=()=>{
    if(S.money<500){ toast('💶 Du hast keine 500 €'); return; }
    if(owns){ M().innerHTML=`<div style="text-align:center"><div style="font-size:50px">🤷‍♂️</div><div class="fname">Heute nichts Neues</div>
        <div class="sub" style="margin:8px 6px">Max kramt in der Box … „Den ${LURES.maxbait.name} hast du ja schon, Digga." Er steckt dein Geld wieder ein. (kostenlos)</div>
        <button class="btn full" id="mGo">Na dann.</button></div>`;
      M().querySelector('#mGo').onclick=()=>teamClose(ov); return; }
    S.money-=500; S.ownLures.push('maxbait'); S.lure='maxbait'; if(!rigOK(S.rig,'maxbait')) S.rig=defaultRigFor('maxbait'); save(); syncTop(); sfx.coupon();
    M().innerHTML=`<div style="text-align:center"><div class="ribbon" style="background:var(--gold);color:#3a2a00">✨ EXKLUSIV-KÖDER</div>
      <div style="font-size:54px">${LURES.maxbait.ic}</div><div class="fname">${LURES.maxbait.name}</div>
      <div class="sub" style="margin:8px 6px">„Hier – handgemachter Prototyp, gibt's nirgends zu kaufen. Fängt wie verrückt." Direkt angelegt! 🎣</div>
      <button class="btn full gold" id="mGo">🎣 Stark!</button></div>`;
    M().querySelector('#mGo').onclick=()=>teamClose(ov); };
  ov.querySelector('#m2').onclick=()=>teamClose(ov);
}
function showBen(){
  const ov=teamOv();
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 TEAM HECHTUNDBARSCH</div>
    <div style="font-size:52px">🧑‍🦰🎣</div>
    <div class="fname">Du triffst Ben</div>
    <div class="sub" style="margin:8px 6px">Ben ist – zugegeben – ein echter Angel-Flopp 😅, aber ein super netter Typ. Leider will keiner mehr mit ihm los. Verbringst du <b>3 Minuten</b> mit ihm? Du fängst in der Zeit <b>deutlich schlechter</b> – dafür gibt's <b>+100 ☯️ Karma</b>!</div>
    <button class="btn full gold" id="b1">🤝 3 Min mit Ben angeln (+100 Karma)</button>
    <button class="btn ghost full" id="b2" style="margin-top:8px">Keine Zeit</button></div>`;
  ov.querySelector('#b1').onclick=()=>{ addKarma(100); S.spookedUntil=Date.now()+180000; save(); syncTop(); sfx.coupon();
    toast('🤝 Ben strahlt – danke, dass du mit ihm losziehst! (+100 ☯️ Karma)'); teamClose(ov); };
  ov.querySelector('#b2').onclick=()=>teamClose(ov);
}
function showKevin(){
  const ov=teamOv(); const M=()=>ov.querySelector('.modal');
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div class="ribbon">🤝 TEAM HECHTUNDBARSCH</div>
    <div style="font-size:52px">🧑‍💻🎰</div>
    <div class="fname">Du triffst Kevin</div>
    <div class="sub" style="margin:8px 6px;text-align:left">Kevin kennt dieses Spiel wie kein anderer – er kann es sogar manipulieren 😏 Er bietet dir das <b>Glücksrad</b> an:<br>🟰 33 % – nichts passiert<br>⬆️ 33 % – Geld & Karma <b>verdoppelt</b><br>⬇️ 33 % – du verlierst <b>80 %</b> von Geld & Karma</div>
    <button class="btn full gold" id="k1">🎡 Am Glücksrad drehen</button>
    <button class="btn ghost full" id="k2" style="margin-top:8px">Risiko? Nein danke</button></div>`;
  ov.querySelector('#k1').onclick=()=>{
    const r=Math.random(); let seg, ic,t,msg, apply;
    if(r<0.3333){ seg=0; ic='😐'; t='Nichts passiert'; msg='Das Rad dreht … und bleibt auf „nix" stehen. Kevin grinst: „Glück gehabt – oder Pech, je nachdem."'; apply=()=>sfx.tip(); }
    else if(r<0.6666){ seg=1; ic='🤑✨'; t='VERDOPPELT!'; msg='Kevin tippt kurz ins Spiel … dein <b>Geld und Karma sind verdoppelt!</b> 🎉'; apply=()=>{ S.money=Math.floor(S.money*2); S.karma=Math.floor((S.karma||0)*2); sfx.coupon(); }; }
    else { seg=2; ic='💸😱'; t='Autsch – 80 % weg'; msg='Kevin lacht diabolisch … <b>80 % deines Geldes und Karmas sind futsch.</b> Tja, selbst gewählt.'; apply=()=>{ S.money=Math.floor(S.money*0.2); S.karma=Math.floor((S.karma||0)*0.2); sfx.lose(); }; }
    M().innerHTML=`<div style="text-align:center">
      <div class="fname" style="margin-bottom:2px">🎡 Das Glücksrad dreht …</div>
      <div class="wheel-wrap"><div class="wheel-ptr">🔻</div>
        <div class="wheel" id="kwheel">
          <div class="wheel-lbl" style="left:76%;top:35%">🟰</div>
          <div class="wheel-lbl" style="left:50%;top:80%">⬆️</div>
          <div class="wheel-lbl" style="left:24%;top:35%">⬇️</div>
          <div class="wheel-hub">🎣</div>
        </div></div>
      <div class="sub2" style="color:var(--muted)">🟰 nix · ⬆️ verdoppeln · ⬇️ −80 %</div></div>`;
    const centers=[60,180,300];
    const D=1800 - centers[seg] + (Math.random()*70-35);   // 5 Umdrehungen, landet im Zielsegment
    const w=M().querySelector('#kwheel');
    setTimeout(()=>{ if(w) w.style.transform='rotate('+D+'deg)'; }, 40);   // CSS-Transition zuverlässig auslösen
    // Ratter-Ticks, die immer langsamer werden (synchron zur Verzögerung des Rads)
    let delay=55; const tick=()=>{ if(!w.isConnected) return; sfx.brake(); delay*=(delay<240?1.07:1.16); if(delay<600) setTimeout(tick,delay); };
    tick();
    setTimeout(()=>{
      apply(); save(); syncTop();
      M().innerHTML=`<div style="text-align:center"><div style="font-size:54px">${ic}</div><div class="fname">${t}</div>
        <div class="sub" style="margin:8px 6px">${msg}</div>
        <button class="btn full gold" id="kGo">Weiter</button></div>`;
      M().querySelector('#kGo').onclick=()=>teamClose(ov);
    }, 4000);
  };
  ov.querySelector('#k2').onclick=()=>teamClose(ov);
}
/* Erstmaliger Nacht-Hinweis */
function maybeNightIntro(){
  if(S.nightSeen || S.time!=='nacht' || route!=='fish') return;
  if(document.querySelector('.overlay')) return;   // nicht über andere Popups legen
  S.nightSeen=true; save(); showNightIntro();
}
function showNightIntro(){
  const owns=hasGear('stirnlampe');
  const lampLine = owns
    ? 'Gut, dass du schon eine <b>LMAB Stirnlampe</b> dabei hast – damit ist dein Lichtkegel schön groß.'
    : 'Mit einer <b>LMAB Stirnlampe</b> aus dem Shop geht das deutlich einfacher – sie vergrößert deinen Lichtkegel enorm.';
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="text-align:center;max-width:390px">
    <div style="font-size:54px">🌙🔦</div>
    <div class="fname">Du angelst jetzt im Dunkeln</div>
    <div class="sub" style="margin:8px 6px">Das Nachtangeln ist eine besondere Herausforderung: Du siehst nur, was im Lichtkegel deiner Kopflampe liegt – führe ihn mit Maus bzw. Finger übers Wasser. Dafür beißen jetzt vermehrt Zander & Wels!</div>
    <div class="sub" style="margin:8px 6px">${lampLine}</div>
    ${owns?'':`<a class="btn full gold" href="${SHOP}${SHOPGEAR.stirnlampe.handle}" target="_blank" rel="noopener" style="margin-top:4px;text-decoration:none">🔦 LMAB Stirnlampe ansehen ↗</a>`}
    <button class="btn ${owns?'full gold':'ghost full'}" id="niGo" style="margin-top:8px">Alles klar, los geht’s!</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#niGo').onclick=()=>ov.remove();
}
/* Jedes einzelne Zufalls-Event (auch eine bestimmte Guide-Begegnung) kommt max. 2× pro Stunde vor */
const EVENT_WINDOW=3600000, EVENT_MAX=2;
function eventTimes(key){ const a=(S.eventSeen||{})[key]; return Array.isArray(a)?a:[]; }
function eventReady(key){ const now=Date.now(); return eventTimes(key).filter(t=>now-t<EVENT_WINDOW).length < EVENT_MAX; }
function markEvent(key){ if(!S.eventSeen) S.eventSeen={}; const now=Date.now();
  S.eventSeen[key]=eventTimes(key).filter(t=>now-t<EVENT_WINDOW).concat(now); save(); }
function showEvent(){
  let pool=EVENTS.filter(e=>eventReady(e.t));
  if(!pool.length) pool=EVENTS;   // Fallback: alle auf Cooldown → trotzdem eins zeigen
  const e=pool[Math.floor(Math.random()*pool.length)];
  markEvent(e.t);
  if(e.custom){ e.custom(); return; }   // interaktives Event (eigenes Popup)
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="text-align:center;max-width:380px">
    <div style="font-size:54px">${e.ic}</div><div class="fname">${e.t}</div>
    <div class="sub" style="margin:8px 6px">${e.x}</div>
    <button class="btn full gold" id="evGo">Weiter</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#evGo').onclick=()=>{ if(e.fn)e.fn(); save(); syncTop(); ov.remove(); if(route==='fish') renderFishing(); };
}
function maybeEvent(chance){ if(Math.random()>=chance) return false;
  if(Math.random()<0.35 && eventReady('trash')){ markEvent('trash'); showTrash(); }
  else showEvent();
  return true; }
/* Versteckte Test-Funktion: Klick auf Sonne/Mond → garantiert ein Zufalls-Event (oft eine Team-Begegnung) */
function forceRandomEvent(){
  if(route!=='fish'||!game) return;
  if(document.querySelector('.overlay')) return;
  if(game.state!=='idle'&&game.state!=='done'){ toast('🌗 Erst den Wurf/Drill abschließen, dann Sonne/Mond tippen'); return; }
  if(Math.random()<0.45) showTeam();   // ~45 % Team-Begegnung (Ronny/Max/Ben/Kevin) zum gezielten Testen
  else showEvent();
}
function rollArrivalEvents(){
  if(route!=='fish'||!game||game.state!=='idle'||CH||TOURNEY) return false;
  if(document.querySelector('.overlay')) return false;   // nicht über offene Popups (z. B. Kumpel-Intro) legen
  if(!S.tipsSeen){ S.tipsSeen=true; save(); showTips(); return true; }
  const kp=karmaP();   // gutes Karma → mehr Glücks-Events & Funde
  if(maybeBigL(0.05)) return true;
  if(maybeTeam(0.10)) return true;        // Team-Begegnung (Ronny/Max/Ben/Kevin) – eigener Roll
  if(maybeEvent(0.18+kp*0.10)) return true;
  if(maybeGuideEncounter(0.12)) return true;
  return maybeFind(0.12+kp*0.15);
}
function showLivescopeAngler(){
  const ov=document.createElement('div'); ov.className='overlay';
  const M=()=>ov.querySelector('.modal');
  ov.innerHTML=`<div class="modal" style="max-width:420px;text-align:center">
    <div style="font-size:54px">📡🧐</div>
    <div class="fname">Angler am Live-Scope</div>
    <div class="sub" style="margin:8px 6px">Du triffst einen Angler, der die ganze Zeit gebannt auf sein Live-Scope-Echolot starrt – er nimmt dich gar nicht wahr. Was machst du?</div>
    <button class="btn ghost full enopt" id="l1">› Hose runter und blanken Hintern zeigen – er guckt ja sowieso nicht hin.</button>
    <button class="btn ghost full enopt" id="l2">› Ihn fragen, ob er mir sagen kann, wo die Fische stehen.</button>
    <button class="btn ghost full enopt" id="l3">› Einfach weitergehen – soll jeder machen, was er will.</button></div>`;
  document.body.appendChild(ov);
  M().querySelector('#l1').onclick=()=>{ addKarma(10); save(); syncTop(); sfx.tip();
    M().innerHTML=`<div style="text-align:center"><div style="font-size:48px">🍑😎</div><div class="fname">Voller Mond am See</div>
    <div class="sub" style="margin:8px 6px">Du lässt die Hüllen fallen … und tatsächlich: Er merkt nichts, der Bildschirm hat ihn voll im Griff. Ein kindischer, aber befriedigender Triumph. <b>+10 ☯️ Karma</b> (frag nicht, warum).</div>
    <button class="btn full gold" id="lGo">😄 Weiter</button></div>`;
    M().querySelector('#lGo').onclick=()=>ov.remove(); };
  M().querySelector('#l2').onclick=()=>{ S.nextBigFish=true; if(game) game.echoGeber=1; addKarma(-50); save(); syncTop(); sfx.coupon();
    M().innerHTML=`<div style="text-align:center"><div style="font-size:48px">🗺️🏆</div><div class="fname">Heißer Tipp!</div>
    <div class="sub" style="margin:8px 6px">Genervt tippt er auf den Bildschirm: „Da, an der Kante!" Wertvolle Info – deine <b>Chance auf einen Trophäen-Fisch beim nächsten Wurf steigt deutlich</b>. Dafür war's etwas dreist, ihn zu stören: <b>−50 ☯️ Karma</b>.</div>
    <button class="btn full gold" id="lGo">🎣 Stark!</button></div>`;
    M().querySelector('#lGo').onclick=()=>ov.remove(); };
  M().querySelector('#l3').onclick=()=>{ addKarma(50); save(); syncTop(); sfx.coupon();
    M().innerHTML=`<div style="text-align:center"><div style="font-size:48px">🧘🌅</div><div class="fname">Leben und leben lassen</div>
    <div class="sub" style="margin:8px 6px">Du gönnst ihm seinen Spaß und ziehst friedlich weiter. Diese gelassene Haltung tut gut: <b>+50 ☯️ Karma</b>.</div>
    <button class="btn full gold" id="lGo">☯️ Weiter</button></div>`;
    M().querySelector('#lGo').onclick=()=>ov.remove(); };
}
/* ===================== EVENT-MINISPIELE ===================== */
function evOv(){ const ov=document.createElement('div'); ov.className='overlay'; document.body.appendChild(ov); return ov; }
function evClose(ov){ ov.remove(); if(route==='fish') renderFishing(); }

/* 🪨 Hänger-vermeiden: Köder durch ein Feld aus Steinen/Bäumen führen, ohne hängenzubleiben */
function showSnagAvoid(){
  const ov=evOv();
  ov.innerHTML=`<div class="modal" style="max-width:430px;text-align:center">
    <div style="font-size:50px">🪨🌳</div><div class="fname">Hängerreicher Spot</div>
    <div class="sub" style="margin:8px 6px">Dein neuer Spot sieht stark aus, aber er ist voll mit Steinen, Bäumen & Geäst. Gute Nachricht: <b>Hängerreiche Spots liefern oft die besten Fische!</b> Führ deinen Köder sauber an den Hindernissen vorbei und erhöhe deine Chance auf einen richtig guten Fang!</div>
    <button class="btn full gold" id="saStart">🎣 Köder durchführen</button>
    <button class="btn ghost full" id="saSkip" style="margin-top:8px">Lieber woanders angeln</button></div>`;
  ov.querySelector('#saSkip').onclick=()=>evClose(ov);
  ov.querySelector('#saStart').onclick=()=>runSnagAvoid(ov);
}
function runSnagAvoid(ov){
  const M=ov.querySelector('.modal');
  M.innerHTML=`<div style="text-align:center">
    <div class="fname" style="margin-bottom:2px">🪨 Um die Hänger herum</div>
    <div class="sub2" id="saHud" style="margin:2px 0 6px">Sauber vorbei: 0/12</div>
    <div id="saArea" style="position:relative;width:100%;height:300px;border-radius:12px;overflow:hidden;background:linear-gradient(180deg,#2a7a93,#0f3b4a);touch-action:none"></div>
    <div class="sub2" style="color:var(--muted);margin-top:6px">Köder mit Maus/Finger hoch & runter führen – Hindernissen ausweichen!</div></div>`;
  const area=M.querySelector('#saArea'), hud=M.querySelector('#saHud');
  const lure=document.createElement('div'); lure.innerHTML=lureGlyph('hard'); lure.style.cssText='position:absolute;left:20%;top:50%;transform:translate(-50%,-50%);z-index:4'; area.appendChild(lure);
  const box=document.createElement('div'); box.style.cssText='position:absolute;left:20%;top:50%;width:40px;height:26px;transform:translate(-50%,-50%);border:2px dashed rgba(120,235,120,.8);border-radius:9px;z-index:3;pointer-events:none;box-sizing:border-box'; area.appendChild(box);
  let ly=50, ty=50, obs=[], dodged=0, hits=0, goal=12, maxHits=6, alive=true, last=performance.now(), spawnT=last+500, spawned=0, raf;
  const move=(e)=>{ const r=area.getBoundingClientRect(); const t=e.touches&&e.touches[0]; const cy=(t?t.clientY:e.clientY); if(cy==null) return; ty=Math.max(8,Math.min(92,((cy-r.top)/r.height)*100)); };
  area.addEventListener('pointermove',move); area.addEventListener('pointerdown',move); area.addEventListener('touchmove',move,{passive:true});
  function loop(now){ if(!alive) return; if(!ov.isConnected){ alive=false; return; }
    const dt=Math.min(0.05,(now-last)/1000); last=now;
    ly+=(ty-ly)*Math.min(1,12*dt); lure.style.top=ly+'%'; box.style.top=ly+'%';
    if(now>=spawnT){ const o={y:10+Math.random()*80,x:106,scored:false}; const el=document.createElement('div'); el.textContent=(Math.random()<0.5?'🪨':'🌳'); el.style.cssText='position:absolute;font-size:30px;transform:translate(-50%,-50%);filter:drop-shadow(0 2px 3px #000);z-index:2'; el.style.left='106%'; el.style.top=o.y+'%'; area.appendChild(el); o.el=el; obs.push(o); spawned++;
      spawnT=now+Math.max(360,(740-spawned*14)+Math.random()*340); }
    const spd=46+Math.min(spawned,24)*1.6;
    const br=box.getBoundingClientRect();
    let hitNow=false;
    for(const o of obs){ o.x-=spd*dt; if(o.el) o.el.style.left=o.x+'%';
      if(!o.scored && rectHit(o.el, br, 5)){ o.scored=true; o.hit=true; hits++; hitNow=true; if(sfx.lose)sfx.lose();
        if(hits>=maxHits){ alive=false; cancelAnimationFrame(raf); finish(false); return; } }
      else if(!o.scored && o.x<=14){ o.scored=true; dodged++; if(sfx.netfill)sfx.netfill(dodged/goal);
        if(dodged>=goal){ alive=false; cancelAnimationFrame(raf); finish(true); return; } } }
    obs=obs.filter(o=>{ if(o.x<-8){ if(o.el) o.el.remove(); return false; } return true; });
    box.style.borderColor=hitNow?'rgba(224,83,61,.95)':'rgba(120,235,120,.8)';
    hud.textContent='Sauber vorbei: '+dodged+'/'+goal+(hits>0?(' · ✖ Hänger: '+hits+'/'+maxHits):'');
    raf=requestAnimationFrame(loop); }
  function finish(won){ area.removeEventListener('pointermove',move); area.removeEventListener('pointerdown',move); area.removeEventListener('touchmove',move);
    if(won){ S.goodSpotUntil=Date.now()+180000; S.nextBigFish=true; save(); syncTop(); if(sfx.coupon)sfx.coupon();
      M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">🏆🎣</div><div class="fname">Sauber durchgeführt!</div>
        <div class="sub" style="margin:8px 6px">Kein einziger fester Hänger – und genau hier zwischen den Steinen stehen die Großen! Die nächsten <b>3 Minuten</b> ist deine Chance auf einen <b>kapitalen Fisch deutlich erhöht</b>! 🏆</div>
        <button class="btn full gold" id="saGo">Stark!</button></div>`; }
    else { if(sfx.lose)sfx.lose();
      M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">🪨😤</div><div class="fname">Zu viele Hänger!</div>
        <div class="sub" style="margin:8px 6px">Das war zu ruppig – ständig bleibst du hängen und verscheuchst die Fische. Diesmal wird's nichts mit dem Bonus.</div>
        <button class="btn full gold" id="saGo">Schade…</button></div>`; }
    M.querySelector('#saGo').onclick=()=>evClose(ov); }
  raf=requestAnimationFrame(loop);
}

/* 🎣 Hänger-lösen: Spannung aufbauen (nicht zu wenig/viel) und im grünen Bereich loslassen → Schnur schnellt zurück */
function showSnagFree(){
  const ov=evOv();
  ov.innerHTML=`<div class="modal" style="max-width:430px;text-align:center">
    <div style="font-size:50px">🎣🪨</div><div class="fname">Kapitaler Hänger!</div>
    <div class="sub" style="margin:8px 6px">Mist – einer deiner Lieblingsköder hängt kapital fest! Lös ihn mit Gefühl: <b>Spannung aufbauen</b> (Knopf halten) – nicht zu wenig, nicht zu viel – und im <b>grünen Bereich loslassen</b>, damit die Schnur zurückschnellt und der Köder frei kommt.<br><br>Klappt es in <b>3 Versuchen</b> nicht, kaufst du den Köder bei HechtundBarsch.de nach – das kostet <b>200 💶</b>.</div>
    <button class="btn full gold" id="sfStart">🎣 Hänger lösen</button></div>`;
  ov.querySelector('#sfStart').onclick=()=>runSnagFree(ov);
}
function runSnagFree(ov){
  const M=ov.querySelector('.modal');
  M.innerHTML=`<div style="text-align:center">
    <div class="fname" style="margin-bottom:2px">🎣 Hänger lösen</div>
    <div class="sub2" id="sfHud" style="margin:2px 0 8px">Versuch 1/3 · Halten zum Spannen, im GRÜN loslassen!</div>
    <div style="position:relative;width:64px;height:230px;margin:0 auto;background:rgba(0,0,0,.4);border-radius:12px;border:1px solid rgba(255,255,255,.22);overflow:hidden">
      <div id="sfRed" style="position:absolute;left:0;top:0;width:100%;height:14%;background:rgba(224,83,61,.45);border-bottom:2px solid #e0533d"></div>
      <div id="sfGreen" style="position:absolute;left:0;width:100%;background:rgba(67,213,126,.4);border-top:2px solid #43d57e;border-bottom:2px solid #43d57e"></div>
      <div id="sfBar" style="position:absolute;left:0;bottom:0;width:100%;height:0%;background:linear-gradient(180deg,#7fe0ff,#3185da)"></div>
    </div>
    <button class="btn full gold" id="sfHold" style="margin-top:12px">🖐️ Halten zum Spannen</button></div>`;
  const bar=M.querySelector('#sfBar'), green=M.querySelector('#sfGreen'), hud=M.querySelector('#sfHud'), btn=M.querySelector('#sfHold');
  let tries=0, tension=0, holding=false, alive=true, last=performance.now(), raf, gLo=40, gHi=56;
  function newZone(){ const h=13+Math.random()*9; const lo=30+Math.random()*38; gLo=lo; gHi=lo+h; green.style.bottom=lo+'%'; green.style.height=h+'%'; }
  newZone();
  function press(){ if(!alive||holding) return; holding=true; }
  function release(){ if(!alive||!holding) return; holding=false; resolve(); }
  function resolve(){ const ok=tension>=gLo&&tension<=gHi, over=tension>=86;
    if(ok){ alive=false; cancelAnimationFrame(raf); cleanup(); win(); return; }
    tries++;
    if(tries>=3){ alive=false; cancelAnimationFrame(raf); cleanup(); lose(); return; }
    hud.textContent='Versuch '+(tries+1)+'/3 · '+(over?'Zu viel Kraft – fast Schnurbruch!':'Daneben! Genau im GRÜN loslassen!');
    tension=0; bar.style.height='0%'; newZone(); }
  btn.addEventListener('pointerdown',e=>{e.preventDefault();press();});
  btn.addEventListener('pointerup',e=>{e.preventDefault();release();});
  btn.addEventListener('pointercancel',release);
  const key=e=>{ if(e.code==='Space'){ if(e.type==='keydown'&&!e.repeat)press(); else if(e.type==='keyup')release(); e.preventDefault(); } };
  window.addEventListener('keydown',key); window.addEventListener('keyup',key);
  function cleanup(){ window.removeEventListener('keydown',key); window.removeEventListener('keyup',key); }
  function loop(now){ if(!alive) return; if(!ov.isConnected){ alive=false; cleanup(); return; }
    const dt=Math.min(0.05,(now-last)/1000); last=now;
    if(holding){ tension=Math.min(100,tension+52*dt); bar.style.height=tension+'%'; if(tension>=100){ holding=false; resolve(); } }
    raf=requestAnimationFrame(loop); }
  function win(){ if(sfx.coupon)sfx.coupon();
    M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">🎉🎣</div><div class="fname">Köder befreit!</div>
      <div class="sub" style="margin:8px 6px">Die Schnur schnellt zurück – <b>tock!</b> – und dein Lieblingsköder kommt frei! Sauber gemacht, keinen Cent verloren.</div>
      <button class="btn full gold" id="sfGo">Weiter</button></div>`;
    M.querySelector('#sfGo').onclick=()=>evClose(ov); }
  function lose(){ S.money=Math.max(0,S.money-200); save(); syncTop(); if(sfx.lose)sfx.lose();
    M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">✂️😤</div><div class="fname">Abgerissen!</div>
      <div class="sub" style="margin:8px 6px">Der Hänger gibt nicht nach – die Schnur reißt, der Köder bleibt unten. Den kaufst du bei <b>HechtundBarsch.de</b> nach: <b>−200 💶</b>.</div>
      <button class="btn full gold" id="sfGo">Schade…</button></div>`;
    M.querySelector('#sfGo').onclick=()=>evClose(ov); }
  raf=requestAnimationFrame(loop);
}

/* 🧭 Spot-Suche: Labyrinth mit Fog-of-War, finde den neuen Spot, bevor die Zeit abläuft */
function showSpotSearch(){
  const ov=evOv();
  ov.innerHTML=`<div class="modal" style="max-width:430px;text-align:center">
    <div style="font-size:50px">🧭🗺️</div><div class="fname">Neuen Spot suchen</div>
    <div class="sub" style="margin:8px 6px">Du kennst deinen Spot in- und auswendig – und langweilst dich. Zeit für was Neues! Bahn dir den Weg durchs Ufergewirr und finde den <b>frischen Hotspot ⭐</b>, bevor die Zeit abläuft. Du sieht immer nur, was direkt um dich liegt.</div>
    <button class="btn full gold" id="ssStart">🧭 Auf Erkundung</button>
    <button class="btn ghost full" id="ssSkip" style="margin-top:8px">Keine Lust</button></div>`;
  ov.querySelector('#ssSkip').onclick=()=>evClose(ov);
  ov.querySelector('#ssStart').onclick=()=>runSpotSearch(ov);
}
function runSpotSearch(ov){
  const M=ov.querySelector('.modal'), N=7, TIME=30;
  const mk=(r,c)=>({r,c,N:true,E:true,S:true,W:true,vis:false,seen:false});
  const g=[]; for(let r=0;r<N;r++){ const row=[]; for(let c=0;c<N;c++) row.push(mk(r,c)); g.push(row); }
  const opp={N:'S',S:'N',E:'W',W:'E'}, dirs=[['N',-1,0],['S',1,0],['E',0,1],['W',0,-1]];
  const st=[g[0][0]]; g[0][0].vis=true;
  while(st.length){ const cur=st[st.length-1], nb=[];
    for(const [d,dr,dc] of dirs){ const nr=cur.r+dr,nc=cur.c+dc; if(nr>=0&&nr<N&&nc>=0&&nc<N&&!g[nr][nc].vis) nb.push([d,g[nr][nc]]); }
    if(nb.length){ const [d,nx]=nb[Math.floor(Math.random()*nb.length)]; cur[d]=false; nx[opp[d]]=false; nx.vis=true; st.push(nx); } else st.pop(); }
  let pr=0,pc=0; const goal=[N-1,N-1]; let alive=true, raf, t0=performance.now();
  M.innerHTML=`<div style="text-align:center">
    <div class="fname" style="margin-bottom:2px">🧭 Spot-Suche</div>
    <div class="sub2" id="ssHud" style="margin:2px 0 6px">⏱️ ${TIME}.0s · Finde ⭐</div>
    <div id="ssMaze" style="display:grid;grid-template-columns:repeat(${N},34px);gap:0;justify-content:center;margin:0 auto;background:#04161d;padding:6px;border-radius:10px"></div>
    <div style="display:grid;grid-template-columns:repeat(3,52px);gap:6px;justify-content:center;margin-top:12px">
      <span></span><button class="btn" id="ssU" style="padding:10px 0">▲</button><span></span>
      <button class="btn" id="ssL" style="padding:10px 0">◀</button><button class="btn" id="ssD" style="padding:10px 0">▼</button><button class="btn" id="ssR" style="padding:10px 0">▶</button>
    </div></div>`;
  const maze=M.querySelector('#ssMaze'), hud=M.querySelector('#ssHud');
  for(let r=0;r<N;r++) for(let c=0;c<N;c++){ const d=document.createElement('div'); d.id='ss-'+r+'-'+c;
    d.style.cssText='width:34px;height:34px;display:flex;align-items:center;justify-content:center;font-size:18px;box-sizing:border-box;background:#04161d'; maze.appendChild(d); }
  function reveal(){ for(const [d,dr,dc] of [['C',0,0]].concat(dirs)){ const nr=pr+dr,nc=pc+dc; if(nr>=0&&nr<N&&nc>=0&&nc<N) g[nr][nc].seen=true; } }
  function render(){ for(let r=0;r<N;r++) for(let c=0;c<N;c++){ const cell=g[r][c], el=document.getElementById('ss-'+r+'-'+c); if(!el) continue;
      if(!cell.seen){ el.style.background='#04161d'; el.style.border='none'; el.textContent=''; continue; }
      el.style.background='#16526a';
      el.style.borderTop=(cell.N?'3px solid #02232e':'3px solid transparent');
      el.style.borderBottom=(cell.S?'3px solid #02232e':'3px solid transparent');
      el.style.borderLeft=(cell.W?'3px solid #02232e':'3px solid transparent');
      el.style.borderRight=(cell.E?'3px solid #02232e':'3px solid transparent');
      el.textContent = (r===pr&&c===pc)?'🎣' : (r===goal[0]&&c===goal[1])?'⭐' : ''; } }
  function move(d){ if(!alive) return; const cur=g[pr][pc]; if(cur[d]) return; const mv={N:[-1,0],S:[1,0],E:[0,1],W:[0,-1]}[d]; pr+=mv[0]; pc+=mv[1]; if(sfx.tip)sfx.tip(); reveal(); render(); if(pr===goal[0]&&pc===goal[1]) win(); }
  reveal(); render();
  M.querySelector('#ssU').onclick=()=>move('N'); M.querySelector('#ssD').onclick=()=>move('S');
  M.querySelector('#ssL').onclick=()=>move('W'); M.querySelector('#ssR').onclick=()=>move('E');
  const key=e=>{ const m={ArrowUp:'N',ArrowDown:'S',ArrowLeft:'W',ArrowRight:'E'}[e.code]; if(m){ move(m); e.preventDefault(); } };
  window.addEventListener('keydown',key);
  function cleanup(){ window.removeEventListener('keydown',key); }
  function loop(now){ if(!alive) return; if(!ov.isConnected){ alive=false; cleanup(); return; }
    const left=Math.max(0,TIME-(now-t0)/1000); hud.textContent='⏱️ '+left.toFixed(1)+'s · Finde ⭐';
    if(left<=0){ alive=false; cleanup(); lose(); return; } raf=requestAnimationFrame(loop); }
  function win(){ alive=false; cancelAnimationFrame(raf); cleanup(); S.goodSpotUntil=Date.now()+180000; S.nextBigFish=true; save(); syncTop(); if(sfx.coupon)sfx.coupon();
    M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">⭐🎣</div><div class="fname">Neuer Hotspot gefunden!</div>
      <div class="sub" style="margin:8px 6px">Was für eine Stelle – hier war bestimmt lange keiner mehr! Die nächsten <b>3 Minuten</b> ist deine Chance auf einen <b>richtig guten Fisch deutlich erhöht</b>! 🏆</div>
      <button class="btn full gold" id="ssGo">Nichts wie hin!</button></div>`;
    M.querySelector('#ssGo').onclick=()=>evClose(ov); }
  function lose(){ cancelAnimationFrame(raf); if(sfx.lose)sfx.lose();
    M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">🕒🗺️</div><div class="fname">Zeit abgelaufen</div>
      <div class="sub" style="margin:8px 6px">Du hast dich im Ufergewirr verlaufen und den neuen Spot nicht rechtzeitig gefunden. Dann eben zurück zum alten Platz.</div>
      <button class="btn full gold" id="ssGo">Na gut…</button></div>`;
    M.querySelector('#ssGo').onclick=()=>evClose(ov); }
  raf=requestAnimationFrame(loop);
}

/* 🐟 Barsch-Schwarm: Moorhuhn-Style – in 20 s so viele Barsche wie möglich antippen */
function showPerchSwarm(){
  const ov=evOv();
  ov.innerHTML=`<div class="modal" style="max-width:430px;text-align:center">
    <div style="font-size:50px">🐟✨</div><div class="fname">Barsch-Schwarm entdeckt!</div>
    <div class="sub" style="margin:8px 6px">Ein riesiger Barsch-Schwarm jagt direkt vor dir an der Oberfläche! Wirf so schnell du kannst und zieh in <b>20 Sekunden</b> so viele Barsche raus wie möglich – jeder bringt 💶 & Punkte!</div>
    <button class="btn full gold" id="psStart">🎣 Losangeln!</button>
    <button class="btn ghost full" id="psSkip" style="margin-top:8px">Lieber nicht</button></div>`;
  ov.querySelector('#psSkip').onclick=()=>evClose(ov);
  ov.querySelector('#psStart').onclick=()=>runPerchSwarm(ov);
}
function runPerchSwarm(ov){
  const M=ov.querySelector('.modal');
  M.innerHTML=`<div style="text-align:center">
    <div class="fname" style="margin-bottom:2px">🐟 Barsch-Schwarm</div>
    <div class="sub2" id="psHud" style="margin:2px 0 6px">Gefangen: 0 · ⏱️ 20.0s</div>
    <div id="psArea" style="position:relative;width:100%;height:300px;border-radius:12px;overflow:hidden;background:linear-gradient(180deg,#2a7a93,#0f3b4a);touch-action:manipulation;cursor:crosshair"></div>
    <div class="sub2" style="color:var(--muted);margin-top:6px">Tippe die Barsche an, bevor sie wieder abtauchen!</div></div>`;
  const area=M.querySelector('#psArea'), hud=M.querySelector('#psHud');
  let caught=0, alive=true, last=performance.now(), tEnd=last+20000, spawnT=last+250, raf; const fish=new Set();
  function spawn(){ const f=document.createElement('div'); f.textContent='🐟'; const sz=24+Math.random()*16;
    f.style.cssText='position:absolute;font-size:'+sz+'px;transform:translate(-50%,-50%) scaleX(-1);cursor:pointer;filter:drop-shadow(0 2px 3px #000);transition:opacity .18s,transform .12s';
    f.style.left=(10+Math.random()*80)+'%'; f.style.top=(14+Math.random()*72)+'%';
    f._die=performance.now()+(850+Math.random()*650);
    f.addEventListener('pointerdown',e=>{ e.stopPropagation(); if(f._got) return; f._got=true; caught++; if(sfx.perfect)sfx.perfect(); f.textContent='✨'; f.style.pointerEvents='none'; setTimeout(()=>{f.remove();fish.delete(f);},140); });
    area.appendChild(f); fish.add(f); }
  function loop(now){ if(!alive) return; if(!ov.isConnected){ alive=false; return; }
    const left=Math.max(0,(tEnd-now)/1000); hud.textContent='Gefangen: '+caught+' · ⏱️ '+left.toFixed(1)+'s';
    if(now>=spawnT){ spawn(); spawnT=now+Math.max(200,520-caught*9)+Math.random()*240; }
    for(const f of [...fish]){ if(!f._got && now>=f._die){ fish.delete(f); f.style.opacity='0'; setTimeout(()=>f.remove(),200); } }
    if(now>=tEnd){ alive=false; finish(); return; } raf=requestAnimationFrame(loop); }
  function finish(){ cancelAnimationFrame(raf); fish.forEach(f=>f.remove());
    const money=caught*9, xp=caught*5; S.money+=money; addXp(xp); if(caught>=18) S.nextBigFish=true; save(); syncTop(); (caught>0&&sfx.win)?sfx.win():(sfx.lose&&sfx.lose());
    M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">${caught>=18?'🏆':caught>=8?'🎉':'🐟'}</div>
      <div class="fname">${caught} Barsche gefangen!</div>
      <div class="sub" style="margin:8px 6px">${caught>=8?'Was für ein Schwarm!':'Der Schwarm war schnell weg…'} <b>+${money} 💶</b> & <b>+${xp} Punkte</b>.${caught>=18?' So heiß, dass dein <b>nächster Fisch</b> ein Brett wird! 🏆':''}</div>
      <button class="btn full gold" id="psGo">Weiter</button></div>`;
    M.querySelector('#psGo').onclick=()=>evClose(ov); }
  raf=requestAnimationFrame(loop);
}

/* 🦟 Mückenalarm: nerviges Sirren für 30 s – außer man hat Anti-Mücken-Spray gekauft */
function showMosquito(){
  const ov=evOv(); const has=hasGear('mueckenspray');
  ov.innerHTML=`<div class="modal" style="max-width:400px;text-align:center">
    <div style="font-size:54px">🦟</div><div class="fname">Mückenalarm!</div>
    <div class="sub" style="margin:8px 6px">${has
      ? 'Mückenwolken im Anflug – aber du hast dein <b>Anti-Mücken-Spray</b> dabei! Kurz eingesprüht, und die Plagegeister lassen dich komplett in Ruhe. 😎'
      : 'Mückenwolken im Anflug – und das Spray liegt natürlich zu Hause. Jetzt heißt es: tapfer die Stellung halten und das Sirren <b>30 Sekunden</b> ertragen … 🫠<br><br>Tipp: Kauf dir <b>Anti-Mücken-Spray</b> im Angelladen (Zubehör), dann bleibst du verschont!'}</div>
    <button class="btn full gold" id="mqGo">${has?'😎 Weiter':'🫠 Aushalten'}</button></div>`;
  ov.querySelector('#mqGo').onclick=()=>{ ov.remove(); if(route==='fish') renderFishing(); if(!has) mosquitoStart(30000); };
}
/* 🚤 Bootswelle: über 2–3 Wellen springen, um trocken zu bleiben */
function showBoatWave(){
  const ov=evOv();
  ov.innerHTML=`<div class="modal" style="max-width:430px;text-align:center">
    <div style="font-size:50px">🚤🌊</div><div class="fname">Bootswelle!</div>
    <div class="sub" style="margin:8px 6px">Ein Bootsangler rauscht viel zu nah vorbei – und schwappt dir ein paar fette Wellen ans Ufer! Spring im richtigen Moment drüber, damit du trocken bleibst.</div>
    <button class="btn full gold" id="bwStart">🦘 Über die Wellen springen</button></div>`;
  ov.querySelector('#bwStart').onclick=()=>runBoatWave(ov);
}
function runBoatWave(ov){
  const M=ov.querySelector('.modal');
  const total=2+Math.floor(Math.random()*2);   // 2–3 Wellen
  M.innerHTML=`<div style="text-align:center">
    <div class="fname" style="margin-bottom:2px">🌊 Wellen-Sprung</div>
    <div class="sub2" id="bwHud" style="margin:2px 0 6px">Welle 0/${total}</div>
    <div id="bwArea" style="position:relative;width:100%;height:240px;border-radius:12px;overflow:hidden;background:linear-gradient(180deg,#7fc9e6,#2a7a93);touch-action:none;cursor:pointer">
      <div style="position:absolute;left:0;bottom:0;width:100%;height:26%;background:rgba(40,90,70,.5);border-top:3px solid rgba(255,255,255,.3)"></div>
      <div id="bwAng" style="position:absolute;left:22%;bottom:26%;transform:translate(-50%,0);font-size:38px;z-index:3">🧍</div>
    </div>
    <div class="sub2" style="color:var(--muted);margin-top:6px">Tippen / Leertaste = springen!</div></div>`;
  const area=M.querySelector('#bwArea'), hud=M.querySelector('#bwHud'), ang=M.querySelector('#bwAng');
  let jy=0, vy=0, onGround=true, alive=true, last=performance.now(), raf;
  let waves=[], spawned=0, cleared=0, nextSpawn=last+700;
  function jump(){ if(onGround&&alive){ vy=78; onGround=false; if(sfx.whoosh)sfx.whoosh(); vib(12); } }
  const tap=(e)=>{ e.preventDefault(); jump(); };
  area.addEventListener('pointerdown',tap);
  const key=e=>{ if(e.code==='Space'){ if(!e.repeat) jump(); e.preventDefault(); } };
  window.addEventListener('keydown',key);
  function cleanup(){ window.removeEventListener('keydown',key); }
  function loop(now){ if(!alive) return; if(!ov.isConnected){ alive=false; cleanup(); return; }
    const dt=Math.min(0.05,(now-last)/1000); last=now;
    if(!onGround){ vy-=150*dt; jy+=vy*dt; if(jy<=0){ jy=0; vy=0; onGround=true; } }
    ang.style.bottom=(26+jy)+'%'; ang.textContent=onGround?'🧍':'🤸';
    if(spawned<total && now>=nextSpawn){ const w={x:106,passed:false}; const el=document.createElement('div'); el.textContent='🌊'; el.style.cssText='position:absolute;bottom:23%;font-size:36px;transform:translate(-50%,0);z-index:2;filter:drop-shadow(0 2px 3px rgba(0,0,0,.4))'; el.style.left='106%'; area.appendChild(el); w.el=el; waves.push(w); spawned++; nextSpawn=now+1300+Math.random()*500; }
    const spd=44;
    for(const w of waves){ w.x-=spd*dt; if(w.el) w.el.style.left=w.x+'%';
      if(!w.passed && w.x<=20){ w.passed=true;
        if(jy>6){ cleared++; if(sfx.netfill)sfx.netfill(cleared/total); hud.textContent='Welle '+cleared+'/'+total;
          if(cleared>=total){ alive=false; cancelAnimationFrame(raf); cleanup(); finish(true); return; } }
        else { alive=false; cancelAnimationFrame(raf); cleanup(); finish(false); return; } } }
    waves=waves.filter(w=>{ if(w.x<-8){ if(w.el) w.el.remove(); return false; } return true; });
    raf=requestAnimationFrame(loop); }
  function finish(won){
    if(won){ addKarma(15); save(); syncTop(); if(sfx.coupon)sfx.coupon();
      M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">🦘😎</div><div class="fname">Trocken geblieben!</div>
        <div class="sub" style="margin:8px 6px">Alle Wellen gemeistert – flink wie ein Reh übergesprungen! Keinen Tropfen abbekommen. (+15 ☯️ Karma)</div>
        <button class="btn full gold" id="bwGo">Weiter</button></div>`; }
    else { if(sfx.lose)sfx.lose();
      M.innerHTML=`<div style="text-align:center"><div style="font-size:52px">💦😩</div><div class="fname">Nasse Füße!</div>
        <div class="sub" style="margin:8px 6px">Eine Welle erwischt dich voll – nasse Füße und ein nasser Hintern! Naja, trocknet ja wieder.</div>
        <button class="btn full gold" id="bwGo">Mist…</button></div>`; }
    M.querySelector('#bwGo').onclick=()=>evClose(ov);
  }
  raf=requestAnimationFrame(loop);
}

function showTrash(){
  const ov=document.createElement('div'); ov.className='overlay';
  const M=()=>ov.querySelector('.modal');
  ov.innerHTML=`<div class="modal" style="max-width:410px;text-align:center">
    <div style="font-size:54px">🗑️</div>
    <div class="fname">Müll am Wasser</div>
    <div class="sub" style="margin:8px 6px">Du findest Müll, den andere Angler liegen gelassen haben. Was machst du?</div>
    <button class="btn ghost full enopt" id="t1">› Ich gehe weiter – und verfluche die Müll-Angler.</button>
    <button class="btn ghost full enopt" id="t2">› Ich nehm den Müll natürlich mit (und verfluche sie trotzdem).</button>
    <button class="btn ghost full enopt" id="t3">› Moment … das ist mein Müll!</button></div>`;
  document.body.appendChild(ov);
  M().querySelector('#t1').onclick=()=>{ M().innerHTML=`<div style="text-align:center">
    <div style="font-size:48px">🌍</div><div class="fname">Hm… eigentlich…</div>
    <div class="sub" style="margin:8px 6px;text-align:left">Verfluchen ist verständlich – aber am besten nimmt man fremden Müll <b>trotzdem mit</b>. Jeder Beitrag hält das Gewässer sauber.<br><br>💡 <b>Wusstest du?</b> Weggeworfene <b>Angelschnur (Nylon) braucht bis zu ~600 Jahre</b> zum Verrotten. <b>Plastiktüte ~20 Jahre</b>, <b>Getränkedose ~50 Jahre</b>, <b>Styropor</b> praktisch nie. Tiere verfangen sich darin.</div>
    <button class="btn full gold" id="tGo">Verstanden – nächstes Mal nehm ich's mit</button></div>`;
    M().querySelector('#tGo').onclick=()=>ov.remove(); };
  M().querySelector('#t2').onclick=()=>{ addKarma(2); S.nextBigFish=true; save(); syncTop(); sfx.coupon();
    M().innerHTML=`<div style="text-align:center">
    <div style="font-size:48px">😇🐟</div><div class="fname">Karma-Punkt!</div>
    <div class="sub" style="margin:8px 6px">Sauber! Das Gewässer – und dein Karma – danken dir. Petri-Bonus: Dein <b>nächster Fisch wird ein richtig guter!</b></div>
    <button class="btn full gold" id="tGo">🎣 Los geht's!</button></div>`;
    M().querySelector('#tGo').onclick=()=>ov.remove(); };
  M().querySelector('#t3').onclick=()=>{
    const r=Math.random(); let msg;
    if(r<0.34){ S.money=Math.floor(S.money/2); msg='💸 Kurz nachdem du deinen Müll liegen gelassen hast, ist dein Portemonnaie weg. <b>Die Hälfte deiner Kohle ist futsch.</b> Karma, ne?'; }
    else if(r<0.67){ S.rod='teleskop'; msg='🎣💥 Deine Rutenspitze ist soeben gebrochen – du musst erstmal mit der alten <b>Teleskoprute</b> weiterangeln.'; }
    else { S.lure='tauwurm'; if(!S.ownLures.includes('tauwurm'))S.ownLures.push('tauwurm'); if(!rigOK(S.rig,'tauwurm'))S.rig=defaultRigFor('tauwurm'); msg='🪝 Hänger! Dein Köder ist weg – du fischst erstmal wieder mit dem <b>Tauwurm</b>.'; }
    save(); syncTop(); sfx.lose();
    M().innerHTML=`<div style="text-align:center">
    <div style="font-size:48px">😬</div><div class="fname">Autsch…</div>
    <div class="sub" style="margin:8px 6px">${msg}</div>
    <button class="btn full" id="tGo">Selbst schuld.</button></div>`;
    M().querySelector('#tGo').onclick=()=>{ ov.remove(); if(route==='fish') renderFishing(); }; };
}
function openTackle(){
  const ov=document.createElement('div'); ov.className='overlay';
  function chips(field,keys,items){ return keys.map(k=>`<div class="tkchip ${S[field]===k?'sel':''}" data-f="${field}" data-k="${k}">${items[k].ic} ${items[k].name}${field==='lure'?lureTypeTag(k):''}</div>`).join(''); }
  function build(){
    const rigChips=Object.keys(RIGS).map(k=>{const ok=rigOK(k,S.lure);return `<div class="tkchip ${S.rig===k?'sel':''} ${ok?'':'rigbad'}" data-rig="${k}">${RIGS[k].ic} ${RIGS[k].name}</div>`;}).join('');
    let boatSec='';
    if(S.level>=BOAT_LEVEL){
      const tog=`<div class="tkrow"><div class="tkchip ${!S.fromBoat?'sel':''}" data-bm="ufer">🏞️ Vom Ufer</div><div class="tkchip ${S.fromBoat?'sel':''}" data-bm="boot">🚣 Vom Boot</div></div>`;
      const bts=S.boats.length?`<div class="tkrow" style="margin-top:6px">`+S.boats.map(k=>`<div class="tkchip ${S.boat===k?'sel':''}" data-bt="${k}">${BOATS[k].ic} ${BOATS[k].name}</div>`).join('')+`</div>`:`<div class="sub" style="margin:4px 0">Noch kein Boot – im Angelladen kaufen.</div>`;
      boatSec=`<div class="tksec"><b>🚣 Angelplatz</b>${tog}${bts}</div>`;
    }
    ov.querySelector('.modal').innerHTML=`
      <div style="text-align:center;font-weight:900;font-size:18px;margin-bottom:4px">⚙️ Anpassen</div>
      <div class="sub" style="text-align:center;margin-bottom:6px">Tippe an, was du ändern willst – wirkt sofort auf den nächsten Wurf.</div>
      <div class="tksec"><b>🏞️ Gewässer</b><div class="tkrow">${chips('water',Object.keys(WATERS).filter(k=>S.level>=WATERS[k].unlock),WATERS)}</div></div>
      <div class="tksec"><b>🌅 Tageszeit</b><div class="tkrow">${chips('time',Object.keys(TIMES),TIMES)}</div></div>
      <div class="tksec"><b>📅 Jahreszeit</b><div class="tkrow">${chips('season',Object.keys(SEASONS),SEASONS)}</div></div>
      <div class="tksec"><b>🌦️ Wetter</b><div class="tkrow">${chips('weather',Object.keys(WEATHER),WEATHER)}</div></div>
      <div class="tksec"><b>🎣 Köder</b><div class="tkrow">${chips('lure',S.ownLures,LURES)}</div></div>
      <div class="tksec"><b>🎨 Köderfarbe</b><div class="tkrow">${chips('color',Object.keys(COLORS),COLORS)}</div></div>
      <div class="tksec"><b>🪝 Montage</b><div class="tkrow">${rigChips}</div></div>
      <div class="tksec"><b>🪄 Rute</b><div class="tkrow">${chips('rod',S.ownRods,RODS)}</div></div>
      <div class="tksec"><b>⚙️ Rolle</b><div class="tkrow">${chips('reel',S.ownReels,REELS)}</div></div>
      <div class="tksec"><b>🥅 Kescher</b><div class="tkrow">${chips('net',S.ownNets,NETS)}</div></div>
      ${boatSec}
      <button class="btn full gold" id="tkDone" style="margin-top:8px">Fertig</button>`;
    ov.querySelectorAll('[data-f]').forEach(el=>el.onclick=()=>{ const f=el.dataset.f,k=el.dataset.k;
      S[f]=k; if(f==='net') S.netBroken=false; if(f==='lure'&&!rigOK(S.rig,S.lure)){ S.rig=defaultRigFor(S.lure); toast('🪢 Montage auf '+RIGS[S.rig].name+' umgestellt.'); } save(); build(); });
    ov.querySelectorAll('[data-rig]').forEach(el=>el.onclick=()=>{ const rk=el.dataset.rig;
      if(!rigOK(rk,S.lure)){ toast('🚫 Passt nicht zu '+LURES[S.lure].name+'.'); return; } S.rig=rk; save(); build(); });
    ov.querySelectorAll('[data-bm]').forEach(el=>el.onclick=()=>{ if(el.dataset.bm==='boot'){ if(!S.boats.length){toast('🚣 Erst ein Boot kaufen');return;} if(!S.boat)S.boat=S.boats[0]; S.fromBoat=true; } else S.fromBoat=false; save(); build(); });
    ov.querySelectorAll('[data-bt]').forEach(el=>el.onclick=()=>{ S.boat=el.dataset.bt; S.fromBoat=true; save(); build(); });
    ov.querySelector('#tkDone').onclick=()=>{ ov.remove(); renderFishing(); };
  }
  ov.innerHTML=`<div class="modal" style="max-width:440px;text-align:left;max-height:88vh;overflow:auto"></div>`;
  document.body.appendChild(ov); build();
}
function fmtW(w){ return w>=1? w.toFixed(2)+' kg' : Math.round(w*1000)+' g'; }
function lengthEst(sp,w){ const s=SPECIES[sp], ratio={barsch:35,hecht:95,zander:75,blackbass:42,wels:200,rapfen:65,dorsch:90,seelachs:85,heilbutt:200}[sp]||50;
  return Math.round(ratio*Math.pow(w/Math.max(s.trophy,0.1),0.33)+ratio*0.25); }
function showResult(r){
  const {sp,s,weight,money,xp,isRecord,isTrophy,lvlUp,lure,hookLabel,diff,netNote,found,couponNew,released,boss}=r;
  const goodCatch = boss || (weight>=0.55*s.trophy);   // Teilen-Buttons nur bei sehr guten Fischen (Spiel-Definition „sehr guter Fisch")
  const ov=document.createElement('div'); ov.className='overlay';
  const couponBox = couponNew ? `<div class="lurebox" style="border-color:var(--gold);display:block;text-align:center">
    <div class="nm">🏆 „DURCHGESPIELT"-BELOHNUNG freigeschaltet!</div>
    <div class="sub2" style="margin:4px 0">5% auf alle LMAB-Köder im echten Shop mit Code:</div>
    <div style="font-weight:900;font-size:21px;letter-spacing:2px;color:var(--gold)">${COUPON_CODE}</div>
    <a class="btn full gold" href="${COUPON_URL}" target="_blank" rel="noopener" style="margin-top:8px;text-decoration:none">🛒 LMAB-Köder ansehen ↗</a></div>` : '';
  const lureBox=lure.handle?`<div class="lurebox">${thumb(lure)}<div class="info"><div class="nm">Gefangen mit: ${lure.name} ${lureStars(S.lure)?`<span style="color:var(--gold)">${lureStars(S.lure)}</span>`:''}</div><div class="sub2">${lure.brand||''} · <a href="${SHOP}${lure.handle}" target="_blank" rel="noopener">Im Shop ansehen ↗</a></div></div></div>`:'';
  const foundBox=found?`<div class="lurebox" style="border-color:var(--gold)">${thumb(found[2])}<div class="info"><div class="nm">🎁 Am Ufer gefunden: ${found[2].name}</div><div class="sub2">${found[2].brand||'Fundstück'} – jemand hat es vergessen!</div></div></div>
    <button class="btn full" id="equipFound" style="margin-top:2px">🎒 Aufheben & direkt benutzen</button>`:'';
  ov.innerHTML=`<div class="modal">
    ${boss?`<div class="ribbon" style="background:linear-gradient(90deg,#b06bff,#ff5ca8)">🐉 LEGENDE GELANDET: ${boss.name}!</div>`:''}
    ${!boss&&isTrophy?'<div class="ribbon">🏆 KAPITALER FANG!</div>':''}
    ${!boss&&isRecord&&!isTrophy?'<div class="ribbon">✨ NEUER REKORD</div>':''}
    ${released?'<div class="ribbon" style="background:var(--accent2);color:#04220f">🤲 SCHONEND ZURÜCKGESETZT</div>':''}
    <div class="bigfish">${fishIcon(sp,96)}</div><div class="fname">${boss?boss.name+' ':''}${s.name} ${s.special?'⭐':''}</div><div class="fsci">${s.sci}</div>
    <div class="statline compact"><div><div class="v">${fmtW(weight)}</div><div class="l">Gewicht</div></div><div><div class="v">~${lengthEst(sp,weight)} cm</div><div class="l">Länge</div></div><div><div class="v">+${money} 💶</div><div class="l">Verkauf</div></div><div><div class="v">+${xp} XP</div><div class="l">Erfahrung</div></div></div>
    ${lvlUp?`<div class="ribbon" style="background:var(--accent)">⬆️ LEVEL ${S.level} erreicht!</div>`:''}
    <div class="sub" style="margin:2px 0 4px">${hookLabel?hookLabel+' · ':''}🎚️ ${diff}</div>
    ${(S.hook&&S.hook.n)?`<div class="sub2" style="margin:0 0 4px;color:var(--muted)">⚡ Ø Reaktion ${Math.round(S.hook.sum/S.hook.n)} ms · Bestzeit ${S.hook.best} ms${(S.hook.streak||0)>=2?' · 🔥 Serie '+S.hook.streak+'×':''}</div>`:''}
    ${netNote?`<div class="sub" style="color:var(--accent2);margin:0 0 4px">${netNote}</div>`:''}
    <div class="sub" style="margin:2px 0 4px">😄 ${pick(QUIPS.catch)}</div>
    ${couponBox}
    ${foundBox}
    ${lureBox}<div style="color:var(--muted);font-size:12px;margin:6px 0 4px">${s.desc}</div>
    <button class="btn full gold" id="again" style="margin-top:8px">🎣 Weiterangeln</button>
    ${(!released)?`<button class="btn full" id="releaseBtn" style="margin-top:8px">🤲 Schonend zurücksetzen (+Karma)</button>`:''}
    ${goodCatch?`<button class="btn full" id="photoCatch" style="margin-top:8px">📸 Trophäenbild teilen</button>`:''}
    ${goodCatch?`<button class="btn full" id="shareCatch" style="margin-top:8px">📤 Fang als Text teilen</button>`:''}
  </div>`;
  document.body.appendChild(ov);
  // Schutz: direkt nach Drill/Keschern „nachklickt" man oft – die Buttons hier erst nach kurzer Sperre aktiv,
  // damit das Fang-Popup nicht versehentlich sofort weggeklickt wird. Es schließt nur über die Buttons.
  { const lockEls=ov.querySelectorAll('button, a.btn'); lockEls.forEach(b=>b.style.pointerEvents='none');
    ov.classList.add('armlock'); setTimeout(()=>{ lockEls.forEach(b=>b.style.pointerEvents=''); ov.classList.remove('armlock'); }, 900); }
  if(found){ const eb=ov.querySelector('#equipFound'); eb.onclick=()=>{ equipItem(found[0],found[1],true); sfx.buy(); eb.textContent='✅ Angelegt: '+found[2].name; eb.disabled=true; }; }
  { const sc2=ov.querySelector('#shareCatch'); if(sc2) sc2.onclick=()=>shareNative(); }
  { const pc=ov.querySelector('#photoCatch'); if(pc) pc.onclick=()=>shareTrophyImage(sp,weight,boss); }
  { const rb=ov.querySelector('#releaseBtn'); if(rb) rb.onclick=()=>{ S.money=Math.max(0,S.money-money); S.releases=(S.releases||0)+1; addKarma(boss?6:2); S.nextBigFish=true; save(); syncTop(); checkBadges(); rb.textContent=boss?'✅ Legende zurückgesetzt – Respekt! (+Karma)':'✅ Zurückgesetzt – Petri Dank! (+2 ☯️ Karma)'; rb.disabled=true; toast(boss?'🐉🤲 Legende zurückgesetzt – Karma gerettet!':'🤲 Schonend zurückgesetzt – +2 Karma!'); }; }
  ov.querySelector('#again').onclick=()=>{ ov.remove(); setMsg('Petri Heil! Tippe „Auswerfen" für den nächsten Wurf.'); armIdle(true); };
}

/* Verlust-Erklärung: zeigt den Grund + passenden Tipp und pausiert, bis der Spieler weitermacht */
function showLoss(emoji,title,reason,tip){
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:360px;text-align:center">
    <div style="font-size:58px;line-height:1;margin:2px 0">${emoji}</div>
    <div class="fname" style="color:var(--danger)">${title}</div>
    <div class="sub" style="margin:8px 6px 8px">${reason}</div>
    <div class="lurebox" style="display:block;text-align:left;border-color:var(--accent)"><b>💡 Tipp:</b> ${tip}</div>
    <button class="btn full gold" id="lossGo" style="margin-top:10px">🎣 Weiter angeln</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#lossGo').onclick=()=>{ ov.remove(); setMsg('Neuer Versuch – Petri Heil!'); armIdle(true); };
}
/* Tipps-Overlay (beim ersten Mal + jederzeit über den Button) */
function showChallengeNudge(){
  if(document.querySelector('.overlay')) return;
  const ov=document.createElement('div'); ov.className='overlay'; sfx.tip();
  ov.innerHTML=`<div class="modal" style="max-width:380px;text-align:center">
    <div style="font-size:54px">🏆</div>
    <div class="fname">Lust auf mehr?</div>
    <div class="sub" style="margin:8px 6px">Du angelst schon eine Weile im freien Modus – stark! 💪 Für richtig Langzeit-Motivation probier mal die <b>Challenges</b>: zeitlich begrenzte Aufgaben an bestimmten Gewässern mit fetten Belohnungen.</div>
    <button class="btn full gold" id="nudgeGo">🏆 Zu den Challenges</button>
    <button class="btn ghost full" id="nudgeLater" style="margin-top:8px">Später, erst weiterangeln</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#nudgeGo').onclick=()=>{ ov.remove(); go('challenges'); };
  ov.querySelector('#nudgeLater').onclick=()=>ov.remove();
}
function showTips(){
  const ov=document.createElement('div'); ov.className='overlay';
  ov.innerHTML=`<div class="modal" style="max-width:440px">
    <div style="text-align:center;font-weight:900;font-size:19px;margin-bottom:4px">💡 Hilfe & Tipps</div>
    <div class="sub" style="text-align:center;margin-bottom:8px">Alles, was du fürs Raubfischangeln wissen musst:</div>
    <div style="font-weight:800;margin:8px 2px 4px">⚡ Schnellstart</div>
    ${TIPS.map(t=>`<div class="lurebox" style="display:block;text-align:left;margin:5px 0">• ${t}</div>`).join('')}
    <div style="font-weight:800;margin:14px 2px 4px">📖 Alle Features im Detail</div>
    ${HELP_SECTIONS.map(s=>`<div class="lurebox" style="display:block;text-align:left;margin:5px 0"><div class="nm" style="margin-bottom:2px">${s.h}</div><div class="sub2">${s.t}</div></div>`).join('')}
    <button class="btn full gold" id="tipsGo" style="margin-top:10px">🎣 Verstanden, los geht’s!</button></div>`;
  document.body.appendChild(ov);
  ov.querySelector('#tipsGo').onclick=()=>ov.remove();
}

{ const vn=document.getElementById('verno'); if(vn) vn.textContent=VERSION; }
render();
window.addEventListener('contextmenu',e=>{ if(route==='fish') e.preventDefault(); });
// dezenter Klick-Sound auf allen Buttons
document.addEventListener('click',e=>{ if(e.target.closest('.btn')||e.target.closest('.condchip')||e.target.closest('.tkchip')) sfx.click(); }, true);
// Guide-Ablauf global überwachen (auch außerhalb des Angel-Screens)
setInterval(()=>{ if(S.guideKey && S.guideUntil && Date.now()>=S.guideUntil){ const endedKey=S.guideKey, gc=S.guideCatch; S.guideKey=null; S.guideUntil=0; S.guideCatch=null; save(); showGuideEnd(endedKey, gc); if(route==='fish') renderFishing(); else syncTop(); } }, 1000);
// Angelkumpel verabschiedet sich nach 5 Min – aber nicht mitten im aktiven Wurf/Drill
setInterval(()=>{ if(S.buddyUntil && Date.now()>=S.buddyUntil){
  const busy = (route==='fish' && game && game.state && game.state!=='idle' && game.state!=='done');
  if(!busy) endBuddy();
} }, 1000);
// Nach ~9 Min normalem Spiel einmalig auf Challenges hinweisen (mehr Langzeitmotivation)
setInterval(()=>{
  if(route==='fish' && !CH && !TOURNEY) normalPlaySec++;
  if(!challengePrompted && normalPlaySec>=540 && route==='fish' && game && (game.state==='idle'||game.state==='done')
     && !CH && !TOURNEY && !document.querySelector('.overlay')){
    challengePrompted=true; showChallengeNudge();
  }
}, 1000);
// Tageszeit wechselt automatisch alle 2 Minuten (pausiert während Challenge)
const TIME_CYCLE=['morgen','tag','abend','nacht'];
const TIME_MSG={ morgen:'🌅 Die Morgendämmerung bricht an', tag:'☀️ Es ist jetzt Tag', abend:'🌇 Die Abenddämmerung hat begonnen', nacht:'🌙 Es ist jetzt Nacht' };
setInterval(()=>{ if(CH||TOURNEY) return; const i=TIME_CYCLE.indexOf(S.time); let next=TIME_CYCLE[(i+1)%TIME_CYCLE.length];
  // Beim allerersten Spielen (vor dem 1. Fang) keine Nacht – die erste Runde bleibt am Tag
  if(next==='nacht' && S.totalCatch===0 && !S.nightSeen) next='morgen';
  S.time=next; save();
  toast(TIME_MSG[S.time]||('🕒 '+TIMES[S.time].name));
  if(route==='fish'&&game&&(game.state==='idle'||game.state==='done')) renderFishing(); }, 120000);
